// supersavings
import img10 from "../assets/supersaving/img10.jpg";
import img11 from "../assets/supersaving/img11.jpg";
import img20 from "../assets/supersaving/img20.jpg";
import img21 from "../assets/supersaving/img21.jpg";
import img30 from "../assets/supersaving/img30.jpg";
import img31 from "../assets/supersaving/img31.jpg";
import img40 from "../assets/supersaving/img40.jpg";
import img41 from "../assets/supersaving/img41.jpg";
import img50 from "../assets/supersaving/img50.jpg";
import img51 from "../assets/supersaving/img51.jpg";
import img60 from "../assets/supersaving/img60.jpg";
import img61 from "../assets/supersaving/img61.jpg";
import img70 from "../assets/supersaving/img70.jpg";
import img71 from "../assets/supersaving/img71.jpg";
import img80 from "../assets/supersaving/img80.jpg";
import img81 from "../assets/supersaving/img81.jpg";
import img90 from "../assets/supersaving/img90.jpg";
import img91 from "../assets/supersaving/img91.jpg";
import img100 from "../assets/supersaving/img100.png";
import img101 from "../assets/supersaving/img101.png";
import img110 from "../assets/supersaving/img110.jpg";
import img111 from "../assets/supersaving/img111.jpg";
import img120 from "../assets/supersaving/img120.jpg";
import img121 from "../assets/supersaving/img121.jpg";
import img130 from "../assets/supersaving/img130.jpg";
import img131 from "../assets/supersaving/img131.png";
import img140 from "../assets/supersaving/img140.jpg";
import img141 from "../assets/supersaving/img141.jpg";
import img150 from "../assets/supersaving/img150.png";
import img151 from "../assets/supersaving/img151.png";
// vegetables
import v1 from "../assets/vegetables/lf.jpg";
import v2 from "../assets/vegetables/matar.jpg";
import v3 from "../assets/vegetables/pg1.jpg";
import v4 from "../assets/vegetables/nenua.jpg";
import v5 from "../assets/vegetables/bhua.jpg";
import v6 from "../assets/vegetables/amla.jpg";
import v7 from "../assets/vegetables/sem.jpg";
import v8 from "../assets/vegetables/mustardleaf.jpg";
import v9 from "../assets/vegetables/redcabbage.jpg";
import v10 from "../assets/vegetables/newredpotato.png";
import v11 from "../assets/vegetables/kanda.jpg";
import v12 from "../assets/vegetables/garlic.jpg";
import v13 from "../assets/vegetables/carrot.jpg";
import v14 from "../assets/vegetables/radish.png";
import v15 from "../assets/vegetables/brinjal.jpg";
import v16 from "../assets/vegetables/greenchilli.jpg";
import v17 from "../assets/vegetables/cauliflower.png";
import v18 from "../assets/vegetables/cabbage.jpg";
import v19 from "../assets/vegetables/lemon.png";
import v20 from "../assets/vegetables/pg2.png";
import v21 from "../assets/vegetables/ginger.jpg";
import v22 from "../assets/vegetables/whitepotato.png";
import v23 from "../assets/vegetables/redpotato.jpg";
import v24 from "../assets/vegetables/baby.png";
import v25 from "../assets/vegetables/beetroot.jpg";
import v26 from "../assets/vegetables/cucumber.jpg";
import v27 from "../assets/vegetables/capsicum.jpg";
import v28 from "../assets/vegetables/mushroom.png";
import v29 from "../assets/vegetables/yellowcapsicum.jpg";
import v30 from "../assets/vegetables/bittergourd.jpg";
import v31 from "../assets/vegetables/mintleaves.jpg";
import v32 from "../assets/vegetables/redspinach.png";
import v33 from "../assets/vegetables/beans.jpg";
import v34 from "../assets/vegetables/boro.png";
import v35 from "../assets/vegetables/rawbanana.png";
import v36 from "../assets/vegetables/kundri.jpg";
import v37 from "../assets/vegetables/tamarind.jpg";
import v38 from "../assets/vegetables/arbi.png";
import v39 from "../assets/vegetables/kohra.png";
import v40 from "../assets/vegetables/coriander.jpg";
import v41 from "../assets/vegetables/lauki.png";
import v42 from "../assets/vegetables/pinkonion.jpg";
import v43 from "../assets/vegetables/curry.png";
import v44 from "../assets/vegetables/oal.jpg";
import v45 from "../assets/vegetables/tomato.jpg";
import v46 from "../assets/vegetables/babycorn.jpg";
import v47 from "../assets/vegetables/rawpapaya.jpg";
import v48 from "../assets/vegetables/newpotato.jpg";
import v49 from "../assets/vegetables/broccoli.jpg";
import v50 from "../assets/vegetables/spinach.jpg";
import v51 from "../assets/vegetables/methipatta.png";
import v52 from "../assets/vegetables/jackfruit.png";
import v53 from "../assets/vegetables/redonion.jpg";
import v54 from "../assets/vegetables/arbi.png";
import v55 from "../assets/vegetables/chathail.png";
import v56 from "../assets/vegetables/soyaleaf.jpg";
import v57 from "../assets/vegetables/brinjal2.jpg";
import v58 from "../assets/vegetables/rawbanana2.png";
import v59 from "../assets/vegetables/ridgegourd.jpg";
import v60 from "../assets/vegetables/wholejack.jpg";
// fruits
import f1 from "../assets/fruits/f1.png";
import f2 from "../assets/fruits/f2.jpg";
import f3 from "../assets/fruits/f3.png";
import f4 from "../assets/fruits/f4.jpg";
import f5 from "../assets/fruits/f5.jpg";
import f6 from "../assets/fruits/f6.png";
import f7 from "../assets/fruits/f7.jpg";
import f8 from "../assets/fruits/f8.png";
import f9 from "../assets/fruits/f9.png";
import f10 from "../assets/fruits/f10.jpg";
import f11 from "../assets/fruits/f11.jpg";
import f12 from "../assets/fruits/f12.jpg";
import f13 from "../assets/fruits/f13.jpg";
import f14 from "../assets/fruits/f14.png";
import f15 from "../assets/fruits/f15.jpg";
import f16 from "../assets/fruits/f16.jpg";
import f17 from "../assets/fruits/f17.jpg";
import f18 from "../assets/fruits/f18.png";
import f19 from "../assets/fruits/f19.jpg";
import f20 from "../assets/fruits/f20.jpg";
import f21 from "../assets/fruits/f21.jpg";
import f22 from "../assets/fruits/f22.jpg";
import f23 from "../assets/fruits/f23.jpg";
import f24 from "../assets/fruits/f24.jpg";
import f25 from "../assets/fruits/f25.jpg";
import f26 from "../assets/fruits/f26.jpg";
import f27 from "../assets/fruits/f27.jpg";
import f28 from "../assets/fruits/f28.jpg";
import f29 from "../assets/fruits/f29.png";
import f30 from "../assets/fruits/f30.jpg";
import f31 from "../assets/fruits/f31.jpg";
import f32 from "../assets/fruits/f32.jpg";
import f33 from "../assets/fruits/f33.jpg";
import f34 from "../assets/fruits/f34.jpg";
import f35 from "../assets/fruits/f35.jpg";
import f36 from "../assets/fruits/f36.jpg";
// groceries
import g1 from "../assets/groceries/g1.jpg";
import g2 from "../assets/groceries/g2.jpg";
import g3 from "../assets/groceries/g3.jpg";
import g4 from "../assets/groceries/g4.jpg";
import g5 from "../assets/groceries/g5.jpg";
import g6 from "../assets/groceries/g6.jpg";
import g7 from "../assets/groceries/g7.jpg";
import g8 from "../assets/groceries/g8.jpg";
import g9 from "../assets/groceries/g9.jpg";
import g10 from "../assets/groceries/g10.jpg";
import g11 from "../assets/groceries/g11.jpg";
import g12 from "../assets/groceries/g12.png";
import g13 from "../assets/groceries/g13.jpg";
import g14 from "../assets/groceries/g14.jpg";
import g15 from "../assets/groceries/g15.jpg";
import g16 from "../assets/groceries/g16.jpg";
import g17 from "../assets/groceries/g17.jpg";
import g18 from "../assets/groceries/g18.jpg";
import g19 from "../assets/groceries/g19.jpg";
import g20 from "../assets/groceries/g20.jpg";
import g21 from "../assets/groceries/g21.png";
import g22 from "../assets/groceries/g22.png";
import g23 from "../assets/groceries/g23.jpg";
import g24 from "../assets/groceries/g24.jpg";
import g25 from "../assets/groceries/g25.jpg";
import g26 from "../assets/groceries/g26.jpg";
import g27 from "../assets/groceries/g27.jpg";
import g28 from "../assets/groceries/g28.jpg";
import g29 from "../assets/groceries/g29.jpg";
import g30 from "../assets/groceries/g30.jpg";
import g31 from "../assets/groceries/g31.jpg";
import g32 from "../assets/groceries/g32.jpg";
import g33 from "../assets/groceries/g33.png";
import g34 from "../assets/groceries/g34.jpg";
import g35 from "../assets/groceries/g35.jpg";
import g36 from "../assets/groceries/g36.jpg";
import g37 from "../assets/groceries/g37.jpg";
import g38 from "../assets/groceries/g38.jpg";
import g39 from "../assets/groceries/g39.jpg";
import g40 from "../assets/groceries/g40.jpg";
import g41 from "../assets/groceries/g41.jpg";
import g42 from "../assets/groceries/g42.jpg";
import g43 from "../assets/groceries/g43.jpg";
import g44 from "../assets/groceries/g44.png";
import g45 from "../assets/groceries/g45.jpg";
import g46 from "../assets/groceries/g46.jpg";
import g47 from "../assets/groceries/g47.jpg";
import g48 from "../assets/groceries/g48.png";
import g49 from "../assets/groceries/g49.png";
import g50 from "../assets/groceries/g50.jpg";
import g52 from "../assets/groceries/g52.jpg";
import g51 from "../assets/groceries/g51.png";
import g53 from "../assets/groceries/g53.jpg";
import g54 from "../assets/groceries/g54.jpg";
import g55 from "../assets/groceries/g55.png";
import g56 from "../assets/groceries/g56.png";
import g57 from "../assets/groceries/g57.jpg";
import g58 from "../assets/groceries/g58.png";
import g59 from "../assets/groceries/g59.png";
import g60 from "../assets/groceries/g60.png";
import g61 from "../assets/groceries/g61.jpg";
import g62 from "../assets/groceries/g62.jpg";
import g63 from "../assets/groceries/g63.jpg";
import g64 from "../assets/groceries/g64.jpg";
import g65 from "../assets/groceries/g65.jpg";
import g66 from "../assets/groceries/g66.jpg";
import g67 from "../assets/groceries/g67.jpg";
import g68 from "../assets/groceries/g68.jpg";
import g69 from "../assets/groceries/g69.png";
import g70 from "../assets/groceries/g70.jpg";
import g71 from "../assets/groceries/g71.jpg";
import g72 from "../assets/groceries/g72.png";
import g73 from "../assets/groceries/g73.jpg";
import g74 from "../assets/groceries/g74.jpg";
import g75 from "../assets/groceries/g75.jpg";
import g76 from "../assets/groceries/g76.png";
import g77 from "../assets/groceries/g77.jpg";
import g78 from "../assets/groceries/g78.jpg";
import g79 from "../assets/groceries/g79.jpg";
import g80 from "../assets/groceries/g80.jpg";
import g81 from "../assets/groceries/g81.jpg";
import g82 from "../assets/groceries/g82.png";
import g83 from "../assets/groceries/g83.jpg";
import g84 from "../assets/groceries/g84.jpg";
import g85 from "../assets/groceries/g85.jpg";
import g86 from "../assets/groceries/g86.jpg";
import g87 from "../assets/groceries/g87.png";
import g88 from "../assets/groceries/g88.jpg";
import g89 from "../assets/groceries/g89.png";
import g90 from "../assets/groceries/g90.jpg";
import g91 from "../assets/groceries/g91.jpg";
import g92 from "../assets/groceries/g92.jpg";
import g93 from "../assets/groceries/g93.jpg";
import g94 from "../assets/groceries/g94.jpg";
import g95 from "../assets/groceries/g95.jpg";
import g96 from "../assets/groceries/g96.png";
import g97 from "../assets/groceries/g97.png";
import g98 from "../assets/groceries/g98.png";
import g99 from "../assets/groceries/g99.jpg";
import g100 from "../assets/groceries/g100.jpg";
import g101 from "../assets/groceries/g101.jpg";
import g102 from "../assets/groceries/g102.jpg";
import g103 from "../assets/groceries/g103.jpg";
import g104 from "../assets/groceries/g104.jpg";
import g105 from "../assets/groceries/g105.jpg";
import g106 from "../assets/groceries/g106.jpg";
import g107 from "../assets/groceries/g107.jpg";
import g108 from "../assets/groceries/g108.png";
import g109 from "../assets/groceries/g109.jpg";
import g110 from "../assets/groceries/g110.jpg";
import g111 from "../assets/groceries/g111.jpg";
import g112 from "../assets/groceries/g112.png";
import g113 from "../assets/groceries/g113.png";
import g114 from "../assets/groceries/g114.jpg";
import g115 from "../assets/groceries/g115.jpg";
import g116 from "../assets/groceries/g116.jpg";
import g117 from "../assets/groceries/g117.png";
import g118 from "../assets/groceries/g118.jpg";
import g119 from "../assets/groceries/g119.jpg";
import g120 from "../assets/groceries/g120.jpg";
import g121 from "../assets/groceries/g121.jpg";
import g122 from "../assets/groceries/g122.jpg";
import g123 from "../assets/groceries/g123.jpg";
import g124 from "../assets/groceries/g124.jpg";
import g125 from "../assets/groceries/g125.jpg";
import g126 from "../assets/groceries/g126.jpg";
import g127 from "../assets/groceries/g127.jpg";
import g128 from "../assets/groceries/g128.png";
import g129 from "../assets/groceries/g129.jpg";
import g130 from "../assets/groceries/g130.jpg";
import g131 from "../assets/groceries/g131.jpg";
import g132 from "../assets/groceries/g132.jpg";
import g133 from "../assets/groceries/g133.jpg";
import g134 from "../assets/groceries/g134.jpg";
import g135 from "../assets/groceries/g135.jpg";
import g136 from "../assets/groceries/g136.jpg";
import g137 from "../assets/groceries/g137.jpg";
import g138 from "../assets/groceries/g138.jpg";
import g139 from "../assets/groceries/g139.jpg";
// flours
import fl1 from "../assets/Flours/fl1.png";
import fl2 from "../assets/Flours/fl2.png";
import fl3 from "../assets/Flours/fl3.jpg";
import fl4 from "../assets/Flours/fl4.png";
import fl5 from "../assets/Flours/fl5.png";
import fl6 from "../assets/Flours/fl6.png";
import fl7 from "../assets/Flours/fl7.jpg";
import fl8 from "../assets/Flours/fl8.png";
import fl9 from "../assets/Flours/fl9.png";
import fl10 from "../assets/Flours/fl10.jpg";
import fl11 from "../assets/Flours/fl11.png";
// pulse
import pu18 from "../assets/pulses/p18.jpg";
// snacks
import s1 from "../assets/Snacks/s1.png";
import s2 from "../assets/Snacks/s2.jpg";
import s3 from "../assets/Snacks/s3.png";
import s4 from "../assets/Snacks/s4.jpg";
import s5 from "../assets/Snacks/s5.png";
import s6 from "../assets/Snacks/s6.jpg";
import s7 from "../assets/Snacks/s7.png";
import s8 from "../assets/Snacks/s8.png";
import s9 from "../assets/Snacks/s9.png";
import s10 from "../assets/Snacks/s10.png";
import s11 from "../assets/Snacks/s11.jpg";
import s12 from "../assets/Snacks/s12.jpg";
import s13 from "../assets/Snacks/s13.png";
import s14 from "../assets/Snacks/s14.jpg";
import s15 from "../assets/Snacks/s15.png";
import s16 from "../assets/Snacks/s16.png";
import s17 from "../assets/Snacks/s17.jpg";
import s18 from "../assets/Snacks/s18.jpg";
import s19 from "../assets/Snacks/s19.jpg";
import s20 from "../assets/Snacks/s20.jpg";
import s21 from "../assets/Snacks/s21.png";
import s22 from "../assets/Snacks/s22.jpg";
import s23 from "../assets/Snacks/s23.jpg";
import s24 from "../assets/Snacks/s24.jpg";
import s25 from "../assets/Snacks/s25.png";
import s26 from "../assets/Snacks/s26.jpg";
import s27 from "../assets/Snacks/s27.png";
import s28 from "../assets/Snacks/s28.jpg";
import s29 from "../assets/Snacks/s29.jpg";
import s30 from "../assets/Snacks/s30.jpg";
import s31 from "../assets/Snacks/s31.jpg";
import s32 from "../assets/Snacks/s32.png";
import s33 from "../assets/Snacks/s33.jpg";
import s34 from "../assets/Snacks/s34.jpg";
import s35 from "../assets/Snacks/s35.jpg";
import s36 from "../assets/Snacks/s36.jpg";
import s37 from "../assets/Snacks/s37.jpg";
import s38 from "../assets/Snacks/s38.jpg";
import s39 from "../assets/Snacks/s39.jpg";
import s40 from "../assets/Snacks/s40.jpg";
import s41 from "../assets/Snacks/s41.jpg";
import s42 from "../assets/Snacks/s42.jpg";
import s43 from "../assets/Snacks/s43.jpg";
import s44 from "../assets/Snacks/s44.jpg";
import s45 from "../assets/Snacks/s45.jpg";
import s46 from "../assets/Snacks/s46.jpg";
import s47 from "../assets/Snacks/s47.jpg";
import s48 from "../assets/Snacks/s48.jpg";
import s49 from "../assets/Snacks/s49.jpg";
import s50 from "../assets/Snacks/s50.jpg";
import s51 from "../assets/Snacks/s51.jpg";
import s52 from "../assets/Snacks/s52.jpg";
import s53 from "../assets/Snacks/s53.jpg";
import s54 from "../assets/Snacks/s54.jpg";
import s55 from "../assets/Snacks/s55.jpg";
import s56 from "../assets/Snacks/s56.jpg";
import s57 from "../assets/Snacks/s57.jpg";
import s58 from "../assets/Snacks/s58.jpg";
import s59 from "../assets/Snacks/s59.jpg";
import s60 from "../assets/Snacks/s60.jpg";
import s61 from "../assets/Snacks/s61.jpg";
import s62 from "../assets/Snacks/s62.png";
import s63 from "../assets/Snacks/s63.jpg";
import s64 from "../assets/Snacks/s64.jpg";
import s65 from "../assets/Snacks/s65.jpg";
import s66 from "../assets/Snacks/s66.png";
import s67 from "../assets/Snacks/s67.jpg";
import s68 from "../assets/Snacks/s68.jpg";
import s69 from "../assets/Snacks/s69.jpg";
import s70 from "../assets/Snacks/s70.jpg";
import s71 from "../assets/Snacks/s71.jpg";
import s72 from "../assets/Snacks/s72.jpg";
import s73 from "../assets/Snacks/s73.jpg";
import s74 from "../assets/Snacks/s74.png";
import s75 from "../assets/Snacks/s75.jpg";
import s76 from "../assets/Snacks/s76.jpg";
import s77 from "../assets/Snacks/s77.jpg";
import s78 from "../assets/Snacks/s78.jpg";
import s79 from "../assets/Snacks/s79.jpg";
import s80 from "../assets/Snacks/s80.jpg";
import s81 from "../assets/Snacks/s81.jpg";
import s82 from "../assets/Snacks/s82.jpg";
import s83 from "../assets/Snacks/s83.jpg";
import s84 from "../assets/Snacks/s84.png";
import s85 from "../assets/Snacks/s85.jpg";
import s86 from "../assets/Snacks/s86.jpg";
import s87 from "../assets/Snacks/s87.jpg";
import s88 from "../assets/Snacks/s88.jpg";
import s89 from "../assets/Snacks/s89.jpg";
import s90 from "../assets/Snacks/s90.jpg";
import s91 from "../assets/Snacks/s91.jpg";
import s92 from "../assets/Snacks/s92.jpg";
import s93 from "../assets/Snacks/s93.jpg";
import s94 from "../assets/Snacks/s94.png";
import s95 from "../assets/Snacks/s95.jpg";
import s96 from "../assets/Snacks/s96.png";
import s97 from "../assets/Snacks/s97.png";
import s98 from "../assets/Snacks/s98.png";
import s99 from "../assets/Snacks/s99.png";
import s100 from "../assets/Snacks/s100.png";
import s101 from "../assets/Snacks/s101.png";
import s102 from "../assets/Snacks/s102.png";
import s103 from "../assets/Snacks/s103.png";
import s104 from "../assets/Snacks/s104.png";
import s105 from "../assets/Snacks/s105.jpg";
import s106 from "../assets/Snacks/s106.jpg";
import s107 from "../assets/Snacks/s107.jpg";
import s108 from "../assets/Snacks/s108.jpg";
import s109 from "../assets/Snacks/s109.png";
import s110 from "../assets/Snacks/s110.png";
import s111 from "../assets/Snacks/s111.jpg";
import s112 from "../assets/Snacks/s112.jpg";
import s113 from "../assets/Snacks/s113.jpg";
import s114 from "../assets/Snacks/s114.jpg";
import s115 from "../assets/Snacks/s115.jpg";
import s116 from "../assets/Snacks/s116.jpg";
import s117 from "../assets/Snacks/s117.jpg";
// Household
import h1 from "../assets/household/h1.jpg";
import h2 from "../assets/household/h2.jpg";
import h3 from "../assets/household/h3.jpg";
import h4 from "../assets/household/h4.jpg";
import h5 from "../assets/household/h5.jpg";
import h6 from "../assets/household/h6.jpg";
import h7 from "../assets/household/h7.jpg";
import h8 from "../assets/household/h8.jpg";
import h9 from "../assets/household/h9.jpg";
import h10 from "../assets/household/h10.png";
import h11 from "../assets/household/h11.jpg";
import h12 from "../assets/household/h12.jpg";
import h13 from "../assets/household/h13.jpg";
import h14 from "../assets/household/h14.jpg";
import h15 from "../assets/household/h15.jpg";
import h16 from "../assets/household/h16.jpg";
import h17 from "../assets/household/h17.jpg";
import h18 from "../assets/household/h18.jpg";
import h19 from "../assets/household/h19.jpg";
import h20 from "../assets/household/h20.png";
import h21 from "../assets/household/h21.jpg";
import h22 from "../assets/household/h22.jpg";
import h23 from "../assets/household/h23.jpg";
import h24 from "../assets/household/h24.jpg";
import h25 from "../assets/household/h25.jpg";
import h26 from "../assets/household/h26.png";
import h27 from "../assets/household/h27.png";
import h28 from "../assets/household/h28.png";
import h29 from "../assets/household/h29.png";
import h30 from "../assets/household/h30.png";
import h31 from "../assets/household/h31.jpg";
import h32 from "../assets/household/h32.jpg";
import h33 from "../assets/household/h33.jpg";
import h34 from "../assets/household/h34.jpg";
import h35 from "../assets/household/h35.jpg";
import h36 from "../assets/household/h36.jpg";
import h37 from "../assets/household/h37.jpg";
import h38 from "../assets/household/h38.jpg";
import h39 from "../assets/household/h39.jpg";
import h40 from "../assets/household/h40.jpg";
import h41 from "../assets/household/h41.jpg";
import h42 from "../assets/household/h42.jpg";
import h43 from "../assets/household/h43.jpg";
import h44 from "../assets/household/h44.jpg";
import h45 from "../assets/household/h45.jpg";
import h46 from "../assets/household/h46.jpg";
import h47 from "../assets/household/h47.png";
import h48 from "../assets/household/h48.png";
// Dry Fruits
import d1 from "../assets/dairy/d1.jpg";
import d2 from "../assets/dairy/d2.png";
import d3 from "../assets/dairy/d3.jpg";
import d4 from "../assets/dairy/d4.jpg";
import d5 from "../assets/dairy/d5.jpg";
import d6 from "../assets/dairy/d6.jpg";
import d7 from "../assets/dairy/d7.png";
import d8 from "../assets/dairy/d8.jpg";
import d9 from "../assets/dairy/d9.jpg";
import d10 from "../assets/dairy/d10.jpg";
// personal
import p1 from "../assets/personal/p1.jpg";
import p2 from "../assets/personal/p2.jpg";
import p3 from "../assets/personal/p3.jpg";
import p4 from "../assets/personal/p4.jpg";
import p5 from "../assets/personal/p5.jpg";
import p6 from "../assets/personal/p6.jpg";
import p7 from "../assets/personal/p7.jpg";
import p8 from "../assets/personal/p8.jpg";
import p9 from "../assets/personal/p9.jpg";
import p10 from "../assets/personal/p10.png";
import p11 from "../assets/personal/p11.jpg";
import p12 from "../assets/personal/p12.jpg";
import p13 from "../assets/personal/p13.jpg";
import p14 from "../assets/personal/p14.jpg";
import p15 from "../assets/personal/p15.jpg";
import p16 from "../assets/personal/p16.jpg";
import p17 from "../assets/personal/p17.jpg";
import p18 from "../assets/personal/p18.jpg";
import p19 from "../assets/personal/p19.jpg";
import p20 from "../assets/personal/p20.jpg";
import p21 from "../assets/personal/p21.jpg";
import p22 from "../assets/personal/p22.jpg";
import p23 from "../assets/personal/p23.jpg";
import p24 from "../assets/personal/p24.jpg";
import p25 from "../assets/personal/p25.jpg";
import p26 from "../assets/personal/p26.jpg";
import p27 from "../assets/personal/p27.jpg";
import p28 from "../assets/personal/p28.jpg";
import p29 from "../assets/personal/p29.jpg";
import p30 from "../assets/personal/p30.jpg";
import p31 from "../assets/personal/p31.jpg";
import p32 from "../assets/personal/p32.jpg";
import p33 from "../assets/personal/p33.png";
import p34 from "../assets/personal/p34.jpg";
import p35 from "../assets/personal/p35.jpg";
import p36 from "../assets/personal/p36.jpg";
import p37 from "../assets/personal/p37.jpg";
import p38 from "../assets/personal/p38.jpg";
import p39 from "../assets/personal/p39.jpg";
import p40 from "../assets/personal/p40.jpg";
import p41 from "../assets/personal/p41.jpg";
import p42 from "../assets/personal/p42.jpg";
import p43 from "../assets/personal/p43.jpg";
import p44 from "../assets/personal/p44.jpg";
import p45 from "../assets/personal/p45.jpg";
import p46 from "../assets/personal/p46.png";
import p47 from "../assets/personal/p47.jpg";
import p48 from "../assets/personal/p48.jpg";
import p49 from "../assets/personal/p49.jpg";
import p50 from "../assets/personal/p50.jpg";
import p51 from "../assets/personal/p51.png";
import p52 from "../assets/personal/p52.png";
import p53 from "../assets/personal/p53.jpg";
import p54 from "../assets/personal/p54.jpg";
import p55 from "../assets/personal/p55.jpg";
import p56 from "../assets/personal/p56.jpg";
import p57 from "../assets/personal/p57.jpg";
import p58 from "../assets/personal/p58.jpg";

// Pooja
import pj1 from "../assets/pooja/pj1.jpg";
import pj2 from "../assets/pooja/pj2.jpg";
import pj3 from "../assets/pooja/pj3.png";
import pj4 from "../assets/pooja/pj4.png";
import pj5 from "../assets/pooja/pj5.png";
import pj6 from "../assets/pooja/pj6.jpg";
import pj7 from "../assets/pooja/pj7.png";
import pj8 from "../assets/pooja/pj8.png";
import pj9 from "../assets/pooja/pj9.jpg";
import pj10 from "../assets/pooja/pj10.png";
import pj11 from "../assets/pooja/pj11.png";
import pj12 from "../assets/pooja/pj12.png";
import pj13 from "../assets/pooja/pj13.png";
import pj14 from "../assets/pooja/pj14.jpg";
import pj15 from "../assets/pooja/pj15.jpg";
import pj16 from "../assets/pooja/pj16.jpg";
import pj17 from "../assets/pooja/pj17.jpg";
import pj18 from "../assets/pooja/pj18.jpg";
import pj19 from "../assets/pooja/pj19.jpg";
import pj20 from "../assets/pooja/pj20.png";
import pj21 from "../assets/pooja/pj21.jpg";
import pj22 from "../assets/pooja/pj22.png";
import pj23 from "../assets/pooja/pj23.jpg";
import pj24 from "../assets/pooja/pj24.png";
import pj25 from "../assets/pooja/pj25.png";
import pj26 from "../assets/pooja/pj26.jpg";
import pj27 from "../assets/pooja/pj27.jpg";
import pj28 from "../assets/pooja/pj28.png";
import pj29 from "../assets/pooja/pj29.jpg";
import pj30 from "../assets/pooja/pj30.jpg";
// medical
import m1 from "../assets/Medical/m1.jpg";
import m2 from "../assets/Medical/m2.jpg";
import m3 from "../assets/Medical/m3.jpg";
import m4 from "../assets/Medical/m4.jpg";
import m5 from "../assets/Medical/m5.jpg";
import m6 from "../assets/Medical/m6.jpg";
import m7 from "../assets/Medical/m7.jpg";
import m8 from "../assets/Medical/m8.jpg";
import m9 from "../assets/Medical/m9.jpg";
import m10 from "../assets/Medical/m10.jpg";
import m11 from "../assets/Medical/m11.jpg";
import m12 from "../assets/Medical/m12.jpg";
import m13 from "../assets/Medical/m13.png";
import m14 from "../assets/Medical/m14.jpg";
import m15 from "../assets/Medical/m15.jpg";
import m16 from "../assets/Medical/m16.jpg";
import m17 from "../assets/Medical/m17.jpg";
import m18 from "../assets/Medical/m18.jpg";
import m19 from "../assets/Medical/m19.jpg";
import m20 from "../assets/Medical/m20.png";
import m21 from "../assets/Medical/m21.png";
import m22 from "../assets/Medical/m22.png";
import m23 from "../assets/Medical/m23.png";
import m24 from "../assets/Medical/m24.png";
import m25 from "../assets/Medical/m25.png";
import m26 from "../assets/Medical/m26.jpg";
import m27 from "../assets/Medical/m27.jpg";
import m28 from "../assets/Medical/m28.jpg";
import m29 from "../assets/Medical/m29.jpg";
import m30 from "../assets/Medical/m30.png";
import m31 from "../assets/Medical/m31.png";
import m32 from "../assets/Medical/m32.jpg";
import m33 from "../assets/Medical/m33.jpg";
import m34 from "../assets/Medical/m34.jpg";
import m35 from "../assets/Medical/m35.png";
import m36 from "../assets/Medical/m36.png";
// Frozen
import fz1 from "../assets/frozen/f1.png";
import fz2 from "../assets/frozen/f2.jpg";
import fz3 from "../assets/frozen/f3.jpg";
import fz4 from "../assets/frozen/f4.jpg";
// Essential
import e1 from "../assets/Essential/e1.jpg";
import e2 from "../assets/Essential/e2.jpg";
import e3 from "../assets/Essential/e3.jpg";
import e4 from "../assets/Essential/e4.jpg";












export const SuperSaving = [
  {
    id: 1,
    name: "Cadbury Oreo Chocolatey Sandwich Cream Biscuit (Orginal)",
    nameH: "कैडबरी ओरेओ चॉकलेट चॉकलेट सैंडविच बिस्किट",
    brand: "Cadbury",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "120 Gram",
    discount: "3% off",
    img: [img10, img11],
  },

  {
    id: 2,
    name: "Jeera Wounder Biscuit",
    nameH: "जीरा वाउंडर बिस्किट",
    brand: "Biskfarm",
    oldprice: "25.00",
    newprice: "24.00",
    qty: "1 Piece",
    discount: "4% off",
    img: [img20, img21],
  },
  {
    id: 3,
    name: "Stayfree Secure Regular Sanitary Pad (Regular Size 7 Pieces)",
    nameH: "स्टेफ्री सिक्योर कॉटनी सॉफ्ट कवर सैनिटरी पैड",
    brand: "Stayfree",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "1 Piece",
    discount: "3% off",
    img: [img30, img31],
  },
  {
    id: 4,
    name: "Whisper Choice Extra Long Sanitary Pad (XL Size 6 Pieces)",
    nameH: "व्हिस्पर चॉइस एक्स्ट्रा लॉन्ग सैनिटरी पैड",
    brand: "Whisper",
    oldprice: "32.00",
    newprice: "30.00",
    qty: "1 Piece",
    discount: "6% off",
    img: [img40, img41],
  },
  {
    id: 5,
    name: "Pro-Ease Go Sanitary Pad (XL Size Pack Of 6)",
    nameH: "प्रो-इज़ गो सेनेटरी पैड",
    brand: "Pro-Ease",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "1 Piece",
    discount: "3% off",
    img: [img50, img51],
  },
  {
    id: 6,
    name: "Everest Kasuri Methi",
    nameH: "कश्तुरी मेथी",
    brand: "Everest",
    oldprice: "47.00",
    newprice: "46.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [img60, img61],
  },
  {
    id: 7,
    name: "Whisper Choice Aloe Cottony Soft Sanitary Pad(Size XL Pack Of 6)",
    nameH: "व्हिस्पर चॉइस एलो कॉटनी सॉफ्ट सेनेटरीपैड",
    brand: "Whisper",
    oldprice: "28.00",
    newprice: "26.00",
    qty: "1 Piece",
    discount: "7% off",
    img: [img70, img71],
  },
  {
    id: 8,
    name: "Whisper Choice Aloe Cottony Soft Sanitary Pad(Size XL Pack Of 20)",
    nameH: "व्हिस्पर चॉइस एलो कॉटनी सॉफ्ट सेनेटरीपैड",
    brand: "Whisper",
    oldprice: "72.00",
    newprice: "67.00",
    qty: "! Piece",
    discount: "7% off",
    img: [img80, img81],
  },
  {
    id: 9,
    name: "Cadbury Oreo Chocolatey Sandwich Cream Biscuit (Choco Creme)",
    nameH: "कैडबरी ओरेओ चॉकलेट चॉकलेट सैंडविच बिस्किट",
    brand: "Cadbury",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "120 Gram",
    discount: "3% off",
    img: [img90, img91],
  },
  {
    id: 10,
    name: "Parle 20 20 Butter Cookies",
    nameH: "पार्ले 20 20 बटर कूकीज",
    brand: "Parle",
    oldprice: "20.00",
    newprice: "19.00",
    qty: "150 Gram",
    discount: "5% off",
    img: [img100, img101],
  },
  {
    id: 11,
    name: "Sunfeast Yippee Magic Masala Instant Noodle",
    nameH: "यिप्पी मैजिक मसाला इंस्टेंट नूडल",
    brand: "Sunfeast",
    oldprice: "12.00",
    newprice: "11.04",
    qty: "70 Gram",
    discount: "8% off",
    img: [img110, img111],
  },
  {
    id: 12,
    name: "Yippee Masala Treat Macaroni/Elbow Pasta",
    nameH: "यिप्पी मसाला ट्रीट मैकरोनी/एल्बो पास्ता",
    brand: "Sunfeast",
    oldprice: "25.00",
    newprice: "24.00",
    qty: "65 Gram",
    discount: "4% off",
    img: [img120, img121],
  },
  {
    id: 13,
    name: "Cucumber",
    nameH: "खीरा",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "48.00",
    qty: "1 KG",
    discount: "20% off",
    img: [img130, img131],
  },
  {
    id: 14,
    name: "Knorr Classic Hot & Sour Vegetable Soup",
    nameH: "नॉर क्लासिक हॉट एंड सॉर वेजिटेबल सूप",
    brand: "multi brand",
    oldprice: "55.00",
    newprice: "52.00",
    qty: "5% off",
    discount: "43 Gram",
    img: [img140, img141],
  },
  {
    id: 15,
    name: "Shree Neelkamal Dalia",
    nameH: "श्री नीलकमल दलिया",
    brand: "Neelkamal",
    oldprice: "30.00",
    newprice: "28.00",
    qty: "400 Gram",
    discount: "7% off",
    img: [img150, img151],
  },
];

export const Vegetables = [
  {
    id: 1,
    name: "Lady Finger",
    nameH: "भिंडी",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "52.00",
    qty: "1 KG",
    discount: "13% off",
    img: [v1],
  },
  {
    id: 2,
    name: "Matar(Chhemi)",
    nameH: "मटर",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "95.00",
    qty: "1 KG",
    discount: "21% off",
    img: [v2],
  },
  {
    id: 3,
    name: "Pointed Gourd(Parwal Local)",
    nameH: "परवल",
    brand: "Matardana",
    oldprice: "80.00",
    newprice: "70.00",
    qty: "1 KG",
    discount: "13% off",
    img: [v3],
  },
  {
    id: 4,
    name: "Nenua",
    nameH: "नेनुआ",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "48.00",
    qty: "1 KG",
    discount: "20% off",
    img: [v4],
  },
  {
    id: 5,
    name: "Bhua (Ash Gourd)",
    nameH: "भुआ",
    brand: "Matardana",
    oldprice: "300.00",
    newprice: "280.00",
    qty: "4 KG",
    discount: "7% off",
    img: [v5],
  },
  {
    id: 6,
    name: "Amla (Indian Gooseberry)",
    nameH: "आंवला",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "30.00",
    qty: "500 Gram",
    discount: "25% off",
    img: [v6],
  },
  {
    id: 7,
    name: "Sem",
    nameH: "सेम",
    brand: "Matardana",
    oldprice: "80.00",
    newprice: "50.00",
    qty: "1 KG",
    discount: "38% off",
    img: [v7],
  },
  {
    id: 8,
    name: "Mustard Leaf ( Sarso Ka Saag)",
    nameH: "सरसों के साग",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "35.00",
    qty: "1 KG",
    discount: "13% off",
    img: [v8],
  },
  {
    id: 9,
    name: "Red Cabbage",
    nameH: "",
    brand: "Matardana",
    oldprice: "300.00",
    newprice: "240.00",
    qty: "1 KG",
    discount: "20% off",
    img: [v9],
  },
  {
    id: 10,
    name: "New Red Potato",
    nameH: "नया लाल आलू",
    brand: "Matardana",
    oldprice: "70.00",
    newprice: "44.00",
    qty: "1 KG",
    discount: "37% off",
    img: [v10],
  },
  {
    id: 11,
    name: "Kanda",
    nameH: "कंदा",
    brand: "Matardana",
    oldprice: "35.00",
    newprice: "25.00",
    qty: "500 Gram",
    discount: "29% off",
    img: [v11],
  },
  {
    id: 12,
    name: "Garlic",
    nameH: "लहसुन",
    brand: "Matardana",
    oldprice: "130.00",
    newprice: "115.00",
    qty: "1 KG",
    discount: "12% off",
    img: [v12],
  },
  {
    id: 13,
    name: "Salad Carrot",
    nameH: "सलाद का गाजर",
    brand: "Matardana",
    oldprice: "70.00",
    newprice: "40.00",
    qty: "1 KG",
    discount: "43% off",
    img: [v13],
  },
  {
    id: 14,
    name: "Radish",
    nameH: "मूली",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "30.00",
    qty: "1 KG",
    discount: "40% off",
    img: [v14],
  },
  {
    id: 15,
    name: "Brinjal",
    nameH: "बैगन",
    brand: "Matardana",
    oldprice: "70.00",
    newprice: "40.00",
    qty: "1 KG",
    discount: "43% off",
    img: [v15],
  },
  {
    id: 16,
    name: "Green Chili",
    nameH: "हरी मिर्च ",
    brand: "Matardana",
    oldprice: "12.00",
    newprice: "7.00",
    qty: "100 Gram",
    discount: "42% off",
    img: [v16],
  },
  {
    id: 17,
    name: "Cauliflower",
    nameH: "गोभी ",
    brand: "Matardana",
    oldprice: "80.00",
    newprice: "50.00",
    qty: "1 Piece",
    discount: "38% off",
    img: [v17],
  },
  {
    id: 18,
    name: "Cabbage",
    nameH: "पत्ता गोभी",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "35.00",
    qty: "1 KG",
    discount: "42% off",
    img: [v18],
  },
  {
    id: 19,
    name: "Lemon",
    nameH: "नींबू ",
    brand: "Matardana",
    oldprice: "15.00",
    newprice: "11.00",
    qty: "3 Piece",
    discount: "27% off",
    img: [v19],
  },
  {
    id: 20,
    name: "Pointed Gourd (Parwal)",
    nameH: "परवल",
    brand: "Matardana",
    oldprice: "80.00",
    newprice: "68.00",
    qty: "1 KG",
    discount: "15% off",
    img: [v20],
  },
  {
    id: 21,
    name: "Ginger (Adrak)",
    nameH: "अदरक",
    brand: "Matardana",
    oldprice: "12.00",
    newprice: "10.00",
    qty: "100 Gram",
    discount: "17% off",
    img: [v21],
  },
  {
    id: 22,
    name: "White Potato (Safed Aalu)",
    nameH: "सफेद आलू",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "33.00",
    qty: "1 KG",
    discount: "18% off",
    img: [v22],
  },
  {
    id: 23,
    name: "Red Potato",
    nameH: "लाल आलू",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "36.00",
    qty: "1 KG",
    discount: "10% off",
    img: [v23],
  },
  {
    id: 24,
    name: "Baby Potato",
    nameH: "बेबी पोटैटो / छोटा आलू",
    brand: "Matardana",
    oldprice: "18.00",
    newprice: "15.00",
    qty: "500 Gram",
    discount: "17% off",
    img: [v24],
  },
  {
    id: 25,
    name: "Beetroot",
    nameH: "चुकुन्दर",
    brand: "Matardana",
    oldprice: "15.00",
    newprice: "11.00",
    qty: "250 Gram",
    discount: "27% off",
    img: [v25],
  },
  {
    id: 26,
    name: "Cucumber",
    nameH: "खीरा",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "48.00",
    qty: "1 KG",
    discount: "20% off",
    img: [v26],
  },
  {
    id: 27,
    name: "Capsicum",
    nameH: "शिमला मिर्च",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "40.00",
    qty: "500 Gram",
    discount: "20% off",
    img: [v27],
  },
  {
    id: 28,
    name: "Mushroom",
    nameH: "मशरुम",
    brand: "Matardana",
    oldprice: "70.00",
    newprice: "60.00",
    qty: "200 Gram",
    discount: "14% off",
    img: [v28],
  },
  {
    id: 29,
    name: "Yellow Capsicum",
    nameH: "पीला शिमला मिर्च",
    brand: "Matardana",
    oldprice: "110.00",
    newprice: "85.00",
    qty: "250 Gram",
    discount: "23% off",
    img: [v29],
  },
  {
    id: 30,
    name: "Bitter Gourd (Karela)",
    nameH: "करेला",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "26.00",
    qty: "500 Gram",
    discount: "13% off",
    img: [v30],
  },
  {
    id: 31,
    name: "Mint Leaves (Pudina)",
    nameH: "पुदीना",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "45.00",
    qty: "100 Gram",
    discount: "25% off",
    img: [v31],
  },
  {
    id: 32,
    name: "Red Spinach",
    nameH: "लाल साग",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "20.00",
    qty: "500 Gram",
    discount: "20% off",
    img: [v32],
  },
  {
    id: 33,
    name: "Beans",
    nameH: "बीन्स",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "25.00",
    qty: "250 Gram",
    discount: "17% off",
    img: [v33],
  },
  {
    id: 34,
    name: "Boro",
    nameH: "बोरो",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "35.00",
    qty: "500 Gram",
    discount: "42% off",
    img: [v34],
  },
  {
    id: 35,
    name: "Raw Banana",
    nameH: "कच्चा केला",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "17.00",
    qty: "6 Piece",
    discount: "43% off",
    img: [v35],
  },
  {
    id: 36,
    name: "Kundri",
    nameH: "कुंदरी / कुन्द्रु",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "15.00",
    qty: "500 Gram",
    discount: "25% off",
    img: [v36],
  },

  {
    id: 37,
    name: "Tamarind (Imli)",
    nameH: "इमली",
    brand: "Matardana",
    oldprice: "15.00",
    newprice: "10.00",
    qty: "100 Gram",
    discount: "33% off",
    img: [v37],
  },
  {
    id: 38,
    name: "Arbi",
    nameH: "अरबी",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "27.00",
    qty: "500 Gram",
    discount: "10% off",
    img: [v38],
  },

  {
    id: 39,
    name: "Kohra",
    nameH: "कोंहरा / कोहड़ा",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "22.00",
    qty: "500 Gram",
    discount: "12% off",
    img: [v39],
  },

  {
    id: 40,
    name: "Coriander (Hara Dhaniya)",
    nameH: "हरा धनिया",
    brand: "Matardana",
    oldprice: "16.00",
    newprice: "12.00",
    qty: "100 Gram",
    discount: "25% off",
    img: [v40],
  },
  {
    id: 41,
    name: "Lauki (Bottle Gourds)",
    nameH: "लौकी",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "35.00",
    qty: "1 KG",
    discount: "42% off",
    img: [v41],
  },
  {
    id: 42,
    name: "Pink Onion",
    nameH: "प्याज",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "35.00",
    qty: "1 KG",
    discount: "42% off",
    img: [v42],
  },
  {
    id: 43,
    name: "Curry Leaves Twig",
    nameH: "करी पत्ता",
    brand: "Matardana",
    oldprice: "",
    newprice: "5.00",
    qty: "5 Piece",
    discount: "",
    img: [v43],
  },
  {
    id: 44,
    name: "Oal (Yam)",
    nameH: "ओल",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "50.00",
    qty: "1 Kg",
    discount: "17% off",
    img: [v44],
  },
  {
    id: 45,
    name: "Tomato",
    nameH: "टमाटर",
    brand: "Matardana",
    oldprice: "90.00",
    newprice: "80.00",
    qty: "1 KG",
    discount: "11% off",
    img: [v45],
  },
  {
    id: 46,
    name: "Baby Corn",
    nameH: "बेबी कॉर्न",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "55.00",
    qty: "200 Gram",
    discount: "8% off",
    img: [v46],
  },

  {
    id: 47,
    name: "Raw Papaya",
    nameH: "कच्चा पपीता",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "19.00",
    qty: "500 Gram",
    discount: "24% off",
    img: [v47],
  },
  {
    id: 48,
    name: "New Potato",
    nameH: "नया आलू",
    brand: "Matardana",
    oldprice: "65.00",
    newprice: "42.00",
    qty: "1 KG",
    discount: "35% off",
    img: [v48],
  },
  {
    id: 49,
    name: "Broccoli",
    nameH: "ब्रोकली",
    brand: "Matardana",
    oldprice: "175.00",
    newprice: "165.00",
    qty: "500 Gram",
    discount: "6% off",
    img: [v49],
  },
  {
    id: 50,
    name: "Spinach (Palak)",
    nameH: "पालक",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "18.00",
    qty: "500 Gram",
    discount: "28% off",
    img: [v50],
  },
  {
    id: 51,
    name: "Methi Patta/Saag",
    nameH: "मेथी",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "14.00",
    qty: "250 Gram",
    discount: "30% off",
    img: [v51],
  },
  {
    id: 52,
    name: "Pealed Jackfruit(Kathal)",
    nameH: "छिले हुए कटहल",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "45.00",
    qty: "1 KG",
    discount: "25% off",
    img: [v52],
    available: "not",
  },
  {
    id: 53,
    name: "Red Onion",
    nameH: "लाल प्याज",
    brand: "Matardana",
    oldprice: "45.00",
    newprice: "34.00",
    qty: "1 kG",
    discount: "24% off",
    img: [v53],
    available: "not",
  },
  {
    id: 54,
    name: "Ridge Gourd (Tori / Turai)",
    nameH: "तोरई",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "25.00",
    qty: "500 Gram",
    discount: "17% off",
    img: [v59],
    available: "not",
  },
  {
    id: 55,
    name: "Arbi Leaf ( Kopal)",
    nameH: "अरवी कोपल / अरबी पत्ता",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "22.00",
    qty: "250 Gram",
    discount: "12% off",
    img: [v54],
    available: "not",
  },
  {
    id: 56,
    name: "Chathail",
    nameH: "चटैल",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "23.00",
    qty: "500 Gram",
    discount: "8% off",
    img: [v55],
    available: "not",
  },
  {
    id: 57,
    name: "Whole Jackfruit (Kathal)",
    nameH: "कटहल",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "40.00",
    qty: "1 KG",
    discount: "33% off",
    img: [v60],
    available: "not",
  },
  {
    id: 58,
    name: "Soya Leaf",
    nameH: "सोया पत्ता",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "10.00",
    qty: "50 Gram",
    discount: "50% off",
    img: [v56],
    available: "not",
  },
  {
    id: 59,
    name: "Brinjal (Round)",
    nameH: "गोल बैगन",
    brand: "Matardana",
    oldprice: "70.00",
    newprice: "60.00",
    qty: "1 KG",
    discount: "14% off",
    img: [v57],
    available: "not",
  },
  {
    id: 60,
    name: "Banana Battisa",
    nameH: "कच्चा केला बत्तीसा",
    brand: "Matardana",
    oldprice: "90.00",
    newprice: "65.00",
    qty: "12 Piece",
    discount: "28% off",
    img: [v58],
    available: "not",
  },
];

export const Fruits = [
  {
    id: 1,
    name: "Aalu Bukhara (Plum)",
    nameH: "आलू बुखारा (पल्म)",
    brand: "Matardana",
    oldprice: "400.00",
    newprice: "248.00",
    qty: "750 Gram",
    discount: "38% off",
    img: [f1],
  },
  {
    id: 2,
    name: "Shimla Apple",
    nameH: "शिमला एप्पल",
    brand: "Matardana",
    oldprice: "65.00",
    newprice: "58.00",
    qty: "500 Gram",
    discount: "11% off",
    img: [f2],
  },
  {
    id: 3,
    name: "Singhara Fruit (kuchha)",
    nameH: "सिंघाड़ा फल (कच्चा)",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "75.00",
    qty: "1 KG",
    discount: "25% off",
    img: [f3],
  },
  {
    id: 4,
    name: "Apple Imported",
    nameH: "इम्पोर्टेड सेब",
    brand: "Matardana",
    oldprice: "150.00",
    newprice: "116.00",
    qty: "500 Gram",
    discount: "23% off",
    img: [f4],
  },
  {
    id: 5,
    name: "Apple Kashmir",
    nameH: "सेब",
    brand: "Matardana",
    oldprice: "200.00",
    newprice: "150.00",
    qty: "1 KG",
    discount: "25% off",
    img: [f5],
  },
  {
    id: 6,
    name: "Pineapple(Medium Size)",
    nameH: "अनानास",
    brand: "Matardana",
    oldprice: "90.00",
    newprice: "65.00",
    qty: "1 Piece",
    discount: "28% off",
    img: [f6],
  },
  {
    id: 7,
    name: "Coconut(Medium)",
    nameH: "नारियल",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "35.00",
    qty: "1 Piece",
    discount: "30% off",
    img: [f7],
  },
  {
    id: 8,
    name: "Papaya",
    nameH: "पपीता",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "42.00",
    qty: "1 KG",
    discount: "30% off",
    img: [f8],
  },
  {
    id: 9,
    name: "Pomegranate (Medium Size Anar)",
    nameH: "अनार",
    brand: "Matardana",
    oldprice: "190.00",
    newprice: "170.00",
    qty: "1 KG",
    discount: "11% off",
    img: [f9],
  },
  {
    id: 10,
    name: "Orange",
    nameH: "संतरा",
    brand: "Matardana",
    oldprice: "75.00",
    newprice: "48.00",
    qty: "1 KG",
    discount: "36% off",
    img: [f10],
  },
  {
    id: 11,
    name: "Mosambi",
    nameH: "मौसम्बी",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "65.00",
    qty: "1 KG",
    discount: "35% off",
    img: [f11],
  },
  {
    id: 12,
    name: "Kiwi",
    nameH: "कीवी",
    brand: "Matardana",
    oldprice: "130.00",
    newprice: "105.00",
    qty: "3 Piece",
    discount: "19% off",
    img: [f12],
  },
  {
    id: 13,
    name: "Banana Chinia(Medium Size)",
    nameH: "चिनिया केला",
    brand: "Matardana",
    oldprice: "28.00",
    newprice: "24.00",
    qty: "6 Piece",
    discount: "14% off",
    img: [f13],
  },
  {
    id: 14,
    name: "Singapuri Banana",
    nameH: "सिंगापुरी केला",
    brand: "Matardana",
    oldprice: "160.00",
    newprice: "105.00",
    qty: "24 Piece",
    discount: "34% off",
    img: [f14],
  },
  {
    id: 15,
    name: "Pealed Pineapple (Medium Size)",
    nameH: "छीला हुआ अनानास",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "70.00",
    qty: "1 Piece",
    discount: "30% off",
    img: [f15],
  },
  {
    id: 16,
    name: "Pear (Nashpati)",
    nameH: "नाशपाती",
    brand: "Matardana",
    oldprice: "80.00",
    newprice: "75.00",
    qty: "500 Gram",
    discount: "6% off",
    img: [f16],
  },
  {
    id: 17,
    name: "Tender Coconut(Big)",
    nameH: "कच्चा नारियल (बड़ा)",
    brand: "Matardana",
    oldprice: "80.00",
    newprice: "70.00",
    qty: "1 Piece",
    discount: "13% off",
    img: [f17],
  },
  {
    id: 18,
    name: "Tender Coconut(Small)",
    nameH: "कच्चा नारियल (छोटा)",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "55.00",
    qty: "1 Piece",
    discount: "8% off",
    img: [f18],
  },
  {
    id: 19,
    name: "Sweet Tamarind",
    nameH: "मीठी इमली",
    brand: "multi brand",
    oldprice: "250.00",
    newprice: "230.00",
    qty: "250 Gram",
    discount: "8% off",
    img: [f19],
  },
  {
    id: 20,
    name: "Cherry",
    nameH: "चेरी",
    brand: "Matardana",
    oldprice: "450.00",
    newprice: "400.00",
    qty: "500 Gram",
    discount: "11% off",
    img: [f20],
  },
  {
    id: 21,
    name: "Guava",
    nameH: "अमरुद",
    brand: "Matardana",
    oldprice: "75.00",
    newprice: "57.00",
    qty: "500 Gram",
    discount: "24% off",
    img: [f21],
  },
  {
    id: 22,
    name: "Apple Himachal",
    nameH: "हिमाचल का सेब",
    brand: "Matardana",
    oldprice: "75.00",
    newprice: "60.00",
    qty: "500 Gram",
    discount: "20% off",
    img: [f22],
  },
  {
    id: 23,
    name: "Ghagra Nimbu",
    nameH: "गगरा निम्बू",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "35.00",
    qty: "1 Piece",
    discount: "30% off",
    img: [f23],
  },
  {
    id: 24,
    name: "Kinnow",
    nameH: "माल्टा",
    brand: "Matardana",
    oldprice: "75.00",
    newprice: "64.00",
    qty: "500 Gram",
    discount: "15% off",
    img: [f24],
    available: "not",
  },
  {
    id: 25,
    name: "Sweet Potato",
    nameH: "शकरकंद",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "25.00",
    qty: "500 Gram",
    discount: "38% off",
    img: [f25],
  },
  {
    id: 26,
    name: "Grapes",
    nameH: "अंगूर",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "90.00",
    qty: "500 Gram",
    discount: "10% off",
    img: [f26],
    available: "not",
  },
  {
    id: 27,
    name: "Pomegranate (Big Size Anar)",
    nameH: "अनार",
    brand: "Matardana",
    oldprice: "110.00",
    newprice: "95.00",
    qty: "500 Gram",
    discount: "14% off",
    img: [f27],
    available: "not",
  },

  {
    id: 28,
    name: "Coconut(Big)",
    nameH: "नारियल",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "50.00",
    qty: "1 Piece",
    discount: "17% off",
    img: [f28],
    available: "not",
  },
  {
    id: 29,
    name: "Black Grapes",
    nameH: "काला अंगूर",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "40.00",
    qty: "250 Gram",
    discount: "33% off",
    img: [f29],
    available: "not",
  },
  {
    id: 30,
    name: "Custard Apple (Sharifa)",
    nameH: "शरीफा",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "50.00",
    qty: "250 Gram",
    discount: "17% off",
    img: [f30],
    available: "not",
  },
  {
    id: 31,
    name: "Dragon Fruit",
    nameH: "ड्रैगन फल",
    brand: "Matardana",
    oldprice: "350.00",
    newprice: "300.00",
    qty: "3 Piece",
    discount: "14% off",
    img: [f31],
    available: "not",
  },
  {
    id: 32,
    name: "Star Fruits",
    nameH: "स्टार फल",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "40.00",
    qty: "200 Gram",
    discount: "20% off",
    img: [f32],
    available: "not",
  },
  {
    id: 33,
    name: "Avocado",
    nameH: "एवाकाडो",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "90.00",
    qty: "250 Gram",
    discount: "10% off",
    img: [f33],
    available: "not",
  },
  {
    id: 34,
    name: "Strawberry",
    nameH: "स्ट्रॉबेरी",
    brand: "Matardana",
    oldprice: "250.00",
    newprice: "240.00",
    qty: "200 Gram",
    discount: "4% off",
    img: [f34],
    available: "not",
  },
  {
    id: 35,
    name: "Red Grapes",
    nameH: "लाल अंगूर",
    brand: "Matardana",
    oldprice: "240.00",
    newprice: "190.00",
    qty: "500 Gram",
    discount: "21% off",
    img: [f35],
    available: "not",
  },

  {
    id: 36,
    name: "Apple Washington",
    nameH: "वाशिंगटन का सेब",
    brand: "Matardana",
    oldprice: "150.00",
    newprice: "133.00",
    qty: "500 Gram",
    discount: "11% off",
    img: [f36],
    available: "not",
  },
];

export const Groceries = [
  {
    id: 1,
    name: "Kushi Kerao",
    nameH: "कुशी केराओ",
    brand: "Matardana",
    oldprice: "",
    newprice: "50.00",
    qty: "1 KG",
    discount: "",
    img: [g1],
  },
  {
    id: 2,
    name: "Fortune Pure & Hygienic Sulphurless Process Sugar",
    nameH: "फॉर्च्यून शुद्ध और स्वच्छ सल्फर रहित चीनी",
    brand: "Fortune",
    oldprice: "60.00 ",
    newprice: "59.00",
    qty: "1 KG",
    discount: "2% off",
    img: [g2],
  },
  {
    id: 3,
    name: "Dal Badi",
    nameH: "दाल बड़ी",
    brand: "Matardana",
    oldprice: "",
    newprice: "40.00",
    qty: "200 Gram",
    discount: "",
    img: [g3],
  },
  {
    id: 4,
    name: "Makhana (Top Quality)",
    nameH: "मखाना",
    brand: "Matardana",
    oldprice: "210.00",
    newprice: "185.00",
    qty: "250 Gram",
    discount: "12% off",
    img: [g4],
  },
  {
    id: 5,
    name: "Everest Garam Masala",
    nameH: "एवरेस्ट गरम मसाला",
    brand: "Everest",
    oldprice: "78.00",
    newprice: "76.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g5],
  },
  {
    id: 6,
    name: "Everest Amchur",
    nameH: "अमचूर",
    brand: "Everest",
    oldprice: "80.00",
    newprice: "75.00",
    qty: "100 Gram",
    discount: "6% off",
    img: [g6],
  },
  {
    id: 7,
    name: "Everest Haldi Powder",
    nameH: "हल्दी पाउडर",
    brand: "Everest",
    oldprice: "31.00",
    newprice: "30.00",
    qty: "100 Gram",
    discount: "3%  off",
    img: [g7],
  },
  {
    id: 8,
    name: "Everest Dhaniya Powder",
    nameH: "धनिया पाउडर",
    brand: "Everest",
    oldprice: "35.00",
    newprice: "32.00",
    qty: "100 Gram",
    discount: "9% off",
    img: [g8],
  },
  {
    id: 9,
    name: "Everest Black Pepper Powder",
    nameH: "गोलकी पाउडर",
    brand: "Everest",
    oldprice: "67.00",
    newprice: "66.00",
    qty: "50 Gram",
    discount: "1% off",
    img: [g9],
  },
  {
    id: 10,
    name: "Everest Kasuri Methi",
    nameH: "कश्तुरी मेथी",
    brand: "Everest",
    oldprice: "47.00",
    newprice: "46.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [g10],
  },
  {
    id: 11,
    name: "Everest Biryani Masala",
    nameH: "बिरयानी मसाला",
    brand: "Everest",
    oldprice: "70.00",
    newprice: "68.00",
    qty: "50 Gram",
    discount: "3% off",
    img: [g11],
  },
  {
    id: 12,
    name: "Everest Chaat Masala",
    nameH: "चाट मसाला",
    brand: "Everest",
    oldprice: "62.00",
    newprice: "61.00",
    qty: "100 Gram",
    discount: "2% off",
    img: [g12],
  },
  {
    id: 13,
    name: "Everest Meat Masala",
    nameH: "मीट मसाला",
    brand: "Everest",
    oldprice: "72.00",
    newprice: "71.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g13],
  },
  {
    id: 14,
    name: "Everest Pav Bhaji Masala",
    nameH: "पावभाजी मसाला",
    brand: "Everest",
    oldprice: "40.00",
    newprice: "36.00",
    qty: "50 Gram",
    discount: "10% off",
    img: [g14],
  },
  {
    id: 15,
    name: "Bhua Badi",
    nameH: "भुआ बड़ी",
    brand: "Matardana",
    oldprice: "",
    newprice: "100.00",
    qty: "500 Gram",
    discount: "",
    img: [g15],
  },
  {
    id: 16,
    name: "Everest Sambhar Masala",
    nameH: "सांभर मसाला",
    brand: "Everest",
    oldprice: "36.00",
    newprice: "35.00",
    qty: "50 Gram",
    discount: "3% off",
    img: [g16],
  },
  {
    id: 17,
    name: "Black Til",
    nameH: "काला तिल",
    brand: "Matardana",
    oldprice: "",
    newprice: "55.00",
    qty: "250 Gram",
    discount: "",
    img: [g17],
  },
  {
    id: 18,
    name: "Tisi",
    nameH: "तिसी",
    brand: "Matardana",
    oldprice: "",
    newprice: "38.00",
    qty: "250 Gram",
    discount: "",
    img: [g18],
  },
  {
    id: 19,
    name: "White Til",
    nameH: "सफेद तिल",
    brand: "Matardana",
    oldprice: "",
    newprice: "55.00",
    qty: "250 Gram",
    discount: "",
    img: [g19],
  },
  {
    id: 20,
    name: "Everest Jaljira Powder",
    nameH: "एवरेस्ट जलजीरा पाउडर",
    brand: "Everest",
    oldprice: "50.00",
    newprice: "49.00",
    qty: "100 Gram",
    discount: "2% off",
    img: [g20],
  },
  {
    id: 21,
    name: "Raagi Flour(Marua Aata)",
    nameH: "मरुआ का आटा",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "16.00",
    qty: "250 Gram",
    discount: "20% off",
    img: [g21],
  },
  {
    id: 22,
    name: "Everest Chicken Masala",
    nameH: "एवरेस्ट चिकन मसाला",
    brand: "Everest",
    oldprice: "72.00",
    newprice: "71.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g22],
  },
  {
    id: 23,
    name: "Everest Kitchen King Masala",
    nameH: "एवरेस्ट किचन किंग मसाला",
    brand: "Everest",
    oldprice: "65.00",
    newprice: "62.00",
    qty: "100 Gram",
    discount: "5% off",
    img: [g23],
  },
  {
    id: 24,
    name: "Everest Sabji Masala",
    nameH: "एवरेस्ट सब्जी मसाला",
    brand: "Everest",
    oldprice: "29.00",
    newprice: "27.00",
    qty: "50 Gram",
    discount: "7% off",
    img: [g24],
  },
  {
    id: 25,
    name: "Everest Kashmirilal Red Chilli Powder",
    nameH: "एवरेस्ट कश्मीरीलाल लाल मिर्च पाउडर",
    brand: "Everest",
    oldprice: "65.00",
    newprice: "62.00",
    qty: "100 Gram",
    discount: "5% off",
    img: [g25],
  },
  {
    id: 26,
    name: "Everest Jeera Powder",
    nameH: "एवरेस्ट जीरा पाउडर",
    brand: "Everest",
    oldprice: "28.00",
    newprice: "26.00",
    qty: "50 Gram",
    discount: "7% off",
    img: [g26],
  },
  {
    id: 27,
    name: "Everest Red Chilli Powder",
    nameH: "एवरेस्ट लाल मिर्च पाउडर",
    brand: "Everest",
    oldprice: "23.00",
    newprice: "22.00",
    qty: "50 Gram",
    discount: "4% off",
    img: [g27],
  },
  {
    id: 28,
    name: "Kaju",
    nameH: "काजू",
    brand: "Matardana",
    oldprice: "270.00",
    newprice: "263.00",
    qty: "250 Gram",
    discount: "3% off",
    img: [g28],
  },
  {
    id: 29,
    name: "MDH Meat Masala",
    nameH: "एमडीएच मीट मसाला",
    brand: "MDH",
    oldprice: "73.00",
    newprice: "72.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g29],
  },
  {
    id: 30,
    name: "MDH Kitchen King",
    nameH: "एमडीएच किचन किंग",
    brand: "MDH",
    oldprice: "70.00",
    newprice: "68.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g30],
  },
  {
    id: 31,
    name: "MDH Jeera Powder",
    nameH: "जीरा पाउडर",
    brand: "MDH",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [g31],
  },
  {
    id: 32,
    name: "MDH Chicken Masala",
    nameH: "चिकन मसाला",
    brand: "MDH",
    oldprice: "70.00",
    newprice: "69.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g32],
  },
  {
    id: 33,
    name: "MDH Amchur Powder",
    nameH: "एमडीएच अमचूर पाउडर",
    brand: "MDH",
    oldprice: "80.00",
    newprice: "78.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g33],
  },
  {
    id: 34,
    name: "MDH Chunky Chat Masala",
    nameH: "एमडीएच चंकी चाट मसाला",
    brand: "MDH",
    oldprice: "65.00",
    newprice: "63.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g34],
  },
  {
    id: 35,
    name: "MDH Garam Masala",
    nameH: "एमडीएच गरम मसाला",
    brand: "MDH",
    oldprice: "78.00",
    newprice: "75.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [g35],
  },
  {
    id: 36,
    name: "MDH Karahi Paneer Masala",
    nameH: "एमडीएच कराही पनीर मसाला",
    brand: "MDH",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "60 Gram",
    discount: "4% off",
    img: [g36],
  },
  {
    id: 37,
    name: "MDH Shahi Paneer Masala",
    nameH: "एमडीएच शाही पनीर मसाला",
    brand: "MDH",
    oldprice: "42.00",
    newprice: "41.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [g37],
  },
  {
    id: 38,
    name: "MDH Kasuri Methi",
    nameH: "एमडीएच कस्तूरी मैथि",
    brand: "Everest",
    oldprice: "46.00",
    newprice: "45.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [g38],
  },
  {
    id: 39,
    name: "Chings Secret Veg Manchurian Masala",
    nameH: "चिंग्स सीक्रेट वेज मंचूरियन मसाला",
    brand: "Chings",
    oldprice: "",
    newprice: "10.00",
    qty: "20 Gram",
    discount: "",
    img: [g39],
  },
  {
    id: 40,
    name: "Almond",
    nameH: "बादाम",
    brand: "Matardana",
    oldprice: "250.00",
    newprice: "240.00",
    qty: "250 Gram",
    discount: "4% off",
    img: [g40],
  },
  {
    id: 41,
    name: "Rakesh Garam Masala",
    nameH: "राकेश गरम मसाला",
    brand: "Rakesh",
    oldprice: "50.00",
    newprice: "47.00",
    qty: "50 Gram",
    discount: "6% off",
    img: [g41],
  },
  {
    id: 42,
    name: "Weikfield Baking Powder",
    nameH: "बेकिंग पाउडर",
    brand: "Weikfield",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g42],
  },
  {
    id: 43,
    name: "Rakesh Mirch Powder",
    nameH: "मिर्च पाउडर",
    brand: "Rakesh",
    oldprice: "25.00",
    newprice: "23.00",
    qty: "50 Gram",
    discount: "8% off",
    img: [g43],
  },
  {
    id: 44,
    name: "Pista(Roasted & Salted With Shell)",
    nameH: "पिस्ता(रोस्टेड & साल्टेड विथ शैल)",
    brand: "multi brand",
    oldprice: "350.00",
    newprice: "305.00",
    qty: "200 Gram",
    discount: "13% off",
    img: [g44],
  },
  {
    id: 45,
    name: "Nilons Ginger Garlic Paste",
    nameH: "निलोंस अदरक लहसुन का पेस्ट",
    brand: "Nilons",
    oldprice: "",
    newprice: "5.00",
    qty: "30 Gram",
    discount: "",
    img: [g45],
  },
  {
    id: 46,
    name: "Sunrise Hing Powder",
    nameH: "हिंग पाउडर",
    brand: "Sunrise",
    oldprice: "",
    newprice: "10.00",
    qty: "8 Gram",
    discount: "",
    img: [g46],
  },
  {
    id: 47,
    name: "Peanut",
    nameH: "मूंगफली दाना",
    brand: "Matardana",
    oldprice: "150.00",
    newprice: "140.00",
    qty: "1 KG",
    discount: "7% off",
    img: [g47],
  },

  {
    id: 48,
    name: "Homefills Edible Soda(Baking Soda)",
    nameH: "होमफिल्ल्स खाद्य सोडा",
    brand: "Homefills",
    oldprice: "",
    newprice: "10.00",
    qty: "100 Gram",
    discount: "",
    img: [g48],
  },
  {
    id: 49,
    name: "Chings Schezwan Fried Rice Masala",
    nameH: "चिंग्स सचेज़वान फ्राइड राइस मसाला",
    brand: "Chings",
    oldprice: "",
    newprice: "10.00",
    qty: "20 Gram",
    discount: "",
    img: [g49],
  },
  {
    id: 50,
    name: "Gud/Mithha",
    nameH: "गुड़",
    brand: "Matardana",
    oldprice: "75.00",
    newprice: "65.00",
    qty: "1 KG",
    discount: "13% off",
    img: [g50],
  },
  {
    id: 51,
    name: "Maggie Magic Masala",
    nameH: "मैगी मैजिक मसाला",
    brand: "Maggi",
    oldprice: "",
    newprice: "10.00",
    qty: "6 Gram",
    discount: "",
    img: [g51],
  },
  {
    id: 52,
    name: "Rice Flour",
    nameH: "चावल का आटा",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "38.00",
    qty: "1 KG",
    discount: "37% off",
    img: [g52],
  },
  {
    id: 53,
    name: "Sebai",
    nameH: "सबई",
    brand: "Bombino",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [g53],
  },
  {
    id: 54,
    name: "Aashirwad Iodized Salt",
    nameH: "आशीर्वाद आयोडीन नमक",
    brand: "ITC",
    oldprice: "21.00",
    newprice: "19.00",
    qty: "1 KG",
    discount: "10% off",
    img: [g54],
  },
  {
    id: 55,
    name: "Aashirvaad Atta",
    nameH: "आशीर्वाद आटा",
    brand: "Aashirvaad",
    oldprice: "213.00",
    newprice: "180.00",
    qty: "5 KG",
    discount: "15% off",
    img: [g55],
  },
  {
    id: 56,
    name: "Sabudana",
    nameH: "साबूदाना",
    brand: "Matardana",
    oldprice: "45.00",
    newprice: "40.00",
    qty: "250 Gram",
    discount: "11% off",
    img: [g56],
  },
  {
    id: 57,
    name: "Parmal Boiled Rice",
    nameH: "परमल चावल",
    brand: "Matardana",
    oldprice: "340.00",
    newprice: "310.00",
    qty: "5 KG",
    discount: "9% off",
    img: [g57],
  },
  {
    id: 58,
    name: "Biryani Rice",
    nameH: "बिरयानी चावल",
    brand: "Matardana",
    oldprice: "150.00",
    newprice: "90.00",
    qty: "1 KG",
    discount: "40% off",
    img: [g58],
  },
  {
    id: 59,
    name: "Pulav Rice",
    nameH: "पुलाव चावल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "90.00",
    qty: "1 KG",
    discount: "25% off",
    img: [g59],
  },
  {
    id: 60,
    name: "Basmati Rice",
    nameH: "बासमती चावल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "100.00",
    qty: "1 KG",
    discount: "17% off",
    img: [g60],
  },
  {
    id: 61,
    name: "Tata Salt",
    nameH: "नमक",
    brand: "Tata",
    oldprice: "21.00",
    newprice: "20.00",
    qty: "1 KG",
    discount: "5% off",
    img: [g61],
  },
  {
    id: 62,
    name: "Tata Tea Gold",
    nameH: "टाटा चाय गोल्ड",
    brand: "Tata",
    oldprice: "125.00",
    newprice: "123.00",
    qty: "250 Gram",
    discount: "2% off",
    img: [g62],
  },
  {
    id: 63,
    name: "Black Salt(Powder)",
    nameH: "काला नमक",
    brand: "Matardana",
    oldprice: "35.00",
    newprice: "30.00",
    qty: "500 Gram",
    discount: "14% off",
    img: [g63],
  },
  {
    id: 64,
    name: "Rock Salt (Powder)",
    nameH: "सेंधा नमक",
    brand: "Matardana",
    oldprice: "",
    newprice: "34.00",
    qty: "500 Gram",
    discount: "",
    img: [g64],
  },
  {
    id: 65,
    name: "Chana Dal",
    nameH: "चना दाल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "85.00",
    qty: "1 KG",
    discount: "29% off",
    img: [g65],
  },
  {
    id: 66,
    name: "Masoor Dal",
    nameH: "मसूर दाल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "105.00",
    qty: "1 KG",
    discount: "13% off",
    img: [g66],
  },
  {
    id: 67,
    name: "Moong Dal",
    nameH: "मूंग का दाल",
    brand: "Matardana",
    oldprice: "135.00",
    newprice: "125.00",
    qty: "1 KG",
    discount: "7% off",
    img: [g67],
  },
  {
    id: 68,
    name: "Urad Dal",
    nameH: "उरद दाल",
    brand: "Matardana",
    oldprice: "170.00",
    newprice: "121.00",
    qty: "1 KG",
    discount: "29% off",
    img: [g68],
  },
  {
    id: 69,
    name: "Kali Urad",
    nameH: "काली उरद",
    brand: "Matardana",
    oldprice: "145.00",
    newprice: "140.00",
    qty: "1 KG",
    discount: "3% off",
    img: [g69],
  },
  {
    id: 70,
    name: "Arhar Dal",
    nameH: "अरहर दाल",
    brand: "Matardana",
    oldprice: "130.00",
    newprice: "120.00",
    qty: "1 KG",
    discount: "8% off",
    img: [g70],
  },
  {
    id: 71,
    name: "Khara Moong Dal",
    nameH: "खरा मूंग दाल",
    brand: "Matardana",
    oldprice: "",
    newprice: "129.00",
    qty: "1 KG",
    discount: "",
    img: [g71],
  },
  {
    id: 72,
    name: "Khesari Pulse (Khesari Dal)",
    nameH: "खेसारी दाल",
    brand: "Matardana",
    oldprice: "",
    newprice: "70.00",
    qty: "1 KG",
    discount: "",
    img: [g72],
  },
  {
    id: 73,
    name: "Kala Chana",
    nameH: "काला चना",
    brand: "Matardana",
    oldprice: "95.00",
    newprice: "72.00",
    qty: "1 KG",
    discount: "24% off",
    img: [g73],
  },
  {
    id: 74,
    name: "Kaabuli Chana",
    nameH: "काबुली चना",
    brand: "Matardana",
    oldprice: "140.00",
    newprice: "120.00",
    qty: "1 KG",
    discount: "14% off",
    img: [g74],
  },
  {
    id: 75,
    name: "Desi Pila Chana",
    nameH: "देशी पीला चना",
    brand: "Matardana",
    oldprice: "90.00",
    newprice: "78.00",
    qty: "1 KG",
    discount: "13% off",
    img: [g75],
  },
  {
    id: 76,
    name: "Rajma Black",
    nameH: "राजमा ब्लैक",
    brand: "Matardana",
    oldprice: "130.00",
    newprice: "122.00",
    qty: "1 KG",
    discount: "6% off",
    img: [g76],
  },
  {
    id: 77,
    name: "Kabuli Matar(Desi Small Size)",
    nameH: "काबुली मटर (देसी छोटा आकार)",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "55.00",
    qty: "1 KG",
    discount: "8% off",
    img: [g77],
  },
  {
    id: 78,
    name: "Hara Matar",
    nameH: "हरा मटर",
    brand: "Matardana",
    oldprice: "160.00",
    newprice: "144.00",
    qty: "1 KG",
    discount: "10% off",
    img: [g78],
  },
  {
    id: 79,
    name: "Kishmish",
    nameH: "किशमिश",
    brand: "Matardana",
    oldprice: "",
    newprice: "40.00",
    qty: "100 Gram",
    discount: "",
    img: [g79],
  },
  {
    id: 80,
    name: "Wallnut/ Akhrot - Inshell",
    nameH: "अखरोट",
    brand: "Matardana",
    oldprice: "600.00",
    newprice: "387.00",
    qty: "500 Gram",
    discount: "36% off",
    img: [g80],
  },
  {
    id: 81,
    name: "Coconut Powder",
    nameH: "नारियल का बुरादा",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "32.00",
    qty: "100 Gram",
    discount: "20% off",
    img: [g81],
  },
  {
    id: 82,
    name: "Dates With Seed",
    nameH: "बिज़ बाला खजूर",
    brand: "Matardana",
    oldprice: "365.00",
    newprice: "210.00",
    qty: "500 Gram",
    discount: "42% off",
    img: [g82],
  },
  {
    id: 83,
    name: "Munakka",
    nameH: "मुनक्का",
    brand: "Matardana",
    oldprice: "175.00",
    newprice: "165.00",
    qty: "250 Gram",
    discount: "6% off",
    img: [g83],
  },
  {
    id: 84,
    name: "Ajwain",
    nameH: "आजवाइन",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "35.00",
    qty: "100 Gram",
    discount: "13% off",
    img: [g84],
  },
  {
    id: 85,
    name: "Mangrela",
    nameH: "मंगरेला",
    brand: "Matardana",
    oldprice: "56.00",
    newprice: "42.00",
    qty: "100 Gram",
    discount: "25% off",
    img: [g85],
  },
  {
    id: 86,
    name: "Saunf",
    nameH: "सौंफ",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "20.00",
    qty: "100 Gram",
    discount: "33% off",
    img: [g86],
  },
  {
    id: 87,
    name: "Methi",
    nameH: "मेथी",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "18.00",
    qty: "100 Gram",
    discount: "10% off",
    img: [g87],
  },
  {
    id: 88,
    name: "Yellow Mustard (Pila Sarso)",
    nameH: "पीला सरसों",
    brand: "Matardana",
    oldprice: "22.00",
    newprice: "15.00",
    qty: "100 Gram",
    discount: "32% off",
    img: [g88],
  },
  {
    id: 89,
    name: "Black Mustard (Rai)",
    nameH: "Black Mustard (Rai)",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "18.00",
    qty: "100 Gram",
    discount: "28% off",
    img: [g89],
  },
  {
    id: 90,
    name: "Panch Phoron",
    nameH: "पंचफोरन",
    brand: "Matardana",
    oldprice: "35.00",
    newprice: "25.00",
    qty: "100 Gram",
    discount: "29% off",
    img: [g90],
    overview:
      "Methi, Pila Sarso, Sauf, Jeera, and Kalonji and five ingredients in Panch Phoron.Panch Phoron is delicious as a rub for meats, added to Indian stews, sprinkled on vegetables, or used for pickling vegetables.  It is also a delicious addition to any “carb-like” foods such as bread-like naan bread.",
  },
  {
    id: 91,
    name: "Sugar (Chini)",
    nameH: "चीनी",
    brand: "Matardana",
    oldprice: "48.00",
    newprice: "44.00",
    qty: "1 KG",
    discount: "8% off",
    img: [g91],
  },
  {
    id: 92,
    name: "Jeera",
    nameH: "जीरा",
    brand: "Matardana",
    oldprice: "35.00",
    newprice: "30.00",
    qty: "100 Gram",
    discount: "14% off",
    img: [g92],
  },
  {
    id: 93,
    name: "Fortune Atta",
    nameH: "फॉर्च्यून आटा",
    brand: "Fortune",
    oldprice: "195.00",
    newprice: "170.00",
    qty: "5 KG",
    discount: "13% off",
    img: [g93],
  },
  {
    id: 94,
    name: "Dry Dates",
    nameH: "छुहारा",
    brand: "Matardana",
    oldprice: "",
    newprice: "165.00",
    qty: "500 Gram",
    discount: "% off",
    img: [g94],
  },
  {
    id: 95,
    name: "Dry Coconut",
    nameH: "सूखा नारियल/गरि नारियल",
    brand: "Matardana",
    oldprice: "",
    newprice: "150.00",
    qty: "500 Gram",
    discount: "",
    img: [g95],
  },
  {
    id: 96,
    name: "Neelkamal Besan",
    nameH: "नीलकमल बेसन",
    brand: "Neelkamal",
    oldprice: "40.00",
    newprice: "34.00",
    qty: "250 Gram",
    discount: "15% off",
    img: [g96],
  },
  {
    id: 97,
    name: "Neelkamal Sattu",
    nameH: "नीलकमल सत्तू",
    brand: " Neelkamal",
    oldprice: "43.00",
    newprice: "40.00",
    qty: "250 Gram",
    discount: "7% off",
    img: [g97],
  },
  {
    id: 98,
    name: "Subhkamal Maida",
    nameH: "सुभकमल मैदा",
    brand: "Subh Kamal",
    oldprice: "29.00",
    newprice: "27.00",
    qty: "500 Gram",
    discount: "7% off",
    img: [g98],
  },
  {
    id: 99,
    name: "Weikfield Corn Flour",
    nameH: "वेइकफील्ड कॉर्न फ्लोर",
    brand: "Weikfield",
    oldprice: "27.00",
    newprice: "26.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [g99],
  },
  {
    id: 100,
    name: "Dhara Mustard Oil",
    nameH: "धारा सरसों का तेल",
    brand: "Dhara",
    oldprice: "200.00",
    newprice: "190.00",
    qty: "1 Ltr",
    discount: "5% off",
    img: [g100],
  },
  {
    id: 101,
    name: "Scooter Premium Kacchi Ghani Pure Mustard Oil",
    nameH: "स्कूटर प्रीमियम कच्ची घानी शुद्ध सरसों का तेल",
    brand: "Scooter",
    oldprice: "200.00",
    newprice: "190.00",
    qty: "1 Ltr",
    discount: "5% off",
    img: [g101],
  },
  {
    id: 102,
    name: "Fortune Rice Bran Refined Oil",
    nameH: "फॉर्च्यून राइस ब्रान रिफाइंड तेल",
    brand: "Fortune",
    oldprice: "205.00",
    newprice: "200.00",
    qty: "1 Ltr",
    discount: "2% off",
    img: [g102],
  },
  {
    id: 103,
    name: "Fortune Refine Soyabean Oil",
    nameH: "फॉर्च्यून सोयाबीन तेल",
    brand: "Fortune",
    oldprice: "190.00",
    newprice: "185.00",
    qty: "1 Ltr",
    discount: "3% off",
    img: [g103],
  },
  {
    id: 104,
    name: "Emami Healthy & Tasty Kachchi Ghani Mustard Oil",
    nameH: "इमामी स्वस्थ और स्वादिष्ट कच्ची घानी सरसों का तेल",
    brand: "Emami",
    oldprice: "205.00",
    newprice: "195.00",
    qty: "1 Ltr",
    discount: "5% off",
    img: [g104],
  },
  {
    id: 105,
    name: "Emami Healthy & Tasty Refined Soyabean Oil",
    nameH: "इमामी स्वस्थ और स्वादिष्ट रिफाइंड सोयाबीन तेल",
    brand: "Emami",
    oldprice: "175.00",
    newprice: "170.00",
    qty: "1 Ltr",
    discount: "3% off",
    img: [g105],
  },
  {
    id: 106,
    name: "Home Made Fresh Mustard Oil (Home Made)",
    nameH: "सरसों का तेल",
    brand: "Matardana",
    oldprice: "250.00",
    newprice: "220.00",
    qty: "1 Ltr",
    discount: "12% off",
    img: [g106],
  },
  {
    id: 107,
    name: "Sudha Ghee",
    nameH: "सुधा घी",
    brand: "Sudha",
    oldprice: "250.00",
    newprice: "248.00",
    qty: "500 Gram",
    discount: "1% off",
    img: [g107],
  },
  {
    id: 108,
    name: "Amul Ghee",
    nameH: "अमूल घी",
    brand: "Amul",
    oldprice: "255.00",
    newprice: "250.00",
    qty: "500 Gram",
    discount: "2% off",
    img: [g108],
  },
  {
    id: 109,
    name: "Maize Flour",
    nameH: "मकई का आटा",
    brand: "Matardana",
    oldprice: "67.00",
    newprice: "44.00",
    qty: "1 KG",
    discount: "34% off",
    img: [g109],
  },
  {
    id: 110,
    name: "Sugar Free Gold(25 Sachets)",
    nameH: "शुगर फ्री गोल्ड",
    brand: "Sugar Free",
    oldprice: "44.00",
    newprice: "42.00",
    qty: "18.75 Gram",
    discount: "5% off",
    img: [g110],
  },
  {
    id: 111,
    name: "Catch Black Salt",
    nameH: "काला नमक",
    brand: "multi brand",
    oldprice: "",
    newprice: "45.00",
    qty: "200 Gram",
    discount: "",
    img: [g111],
  },
  {
    id: 112,
    name: "Shree Neelkamal Dalia",
    nameH: "श्री नीलकमल दलिया",
    brand: "Neelkamal",
    oldprice: "30.00",
    newprice: "28.00",
    qty: "400 Gram",
    discount: "7% off",
    img: [g112],
  },
  {
    id: 113,
    name: "Subhkamal Suji",
    nameH: "सुभकमल सुजि",
    brand: "Subh Kamal",
    oldprice: "29.00",
    newprice: "27.00",
    qty: "500 Gram",
    discount: "7% off",
    img: [g113],
  },
  {
    id: 114,
    name: "Rock Salt(Rock)",
    nameH: "सेंधा नमक (रॉक)",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "82.00",
    qty: "1 KG",
    discount: "32% off",
    img: [g114],
  },
  {
    id: 115,
    name: "Black Salt(Rock)",
    nameH: "काला नमक (रॉक)",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "45.00",
    qty: "1 KG",
    discount: "55% off",
    img: [g115],
  },
  {
    id: 116,
    name: "MDH Kesar",
    nameH: "एमडीएच केसर",
    brand: "MDH",
    oldprice: "255.00",
    newprice: "240.00",
    qty: "1 Gram",
    discount: "6% off",
    img: [g116],
  },
  {
    id: 117,
    name: "Chakki Aata",
    nameH: "चक्की आटा",
    brand: "Matardana",
    oldprice: "130.00",
    newprice: "115.00",
    qty: "5 KG",
    discount: "12% off",
    img: [g117],
    available: "not",
  },
  {
    id: 118,
    name: "Pista",
    nameH: "पिस्ता",
    brand: "Matardana",
    oldprice: "600.00",
    newprice: "530.00",
    qty: "200 Gram",
    discount: "12% off",
    img: [g118],
    available: "not",
  },
  {
    id: 119,
    name: "Badi Elaichi",
    nameH: "बड़ी इलायची",
    brand: "Matardana",
    oldprice: "140.00",
    newprice: "112.00",
    qty: "100 Gram",
    discount: "20% off",
    img: [g119],
  },
  {
    id: 120,
    name: "Basmati Chura",
    nameH: "बासमती चुरा",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "100.00",
    qty: "1 KG",
    discount: "17% off",
    img: [g120],
  },
  {
    id: 121,
    name: "Posta Dana",
    nameH: "पोस्ता दाना",
    brand: "Matardana",
    oldprice: "",
    newprice: "200.00",
    qty: "100 Gram",
    discount: "",
    img: [g121],
  },
  {
    id: 122,
    name: "Cardamom (Elaichi)",
    nameH: "इलायची",
    brand: "Matardana",
    oldprice: "110.00",
    newprice: "70.00",
    qty: "25 Gram",
    discount: "36% off",
    img: [g122],
  },
  {
    id: 123,
    name: "Chura",
    nameH: "चुरा",
    brand: "Matardana",
    oldprice: "",
    newprice: "20.00",
    qty: "500 Gram",
    discount: "",
    img: [g123],
  },
  {
    id: 124,
    name: "Dhaga Misri",
    nameH: "धागा मिसरि",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "26.00",
    qty: "250 Gram",
    discount: "13% off",
    img: [g124],
  },
  {
    id: 125,
    name: "Kheer Rice",
    nameH: "खीर का चावल",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "60.00",
    qty: "1 KG",
    discount: "40% off",
    img: [g125],
  },
  {
    id: 126,
    name: "Laung",
    nameH: "लौंग",
    brand: "Matardana",
    oldprice: "81.00",
    newprice: "38.00",
    qty: "50 Gram",
    discount: "53% off",
    img: [g126],
  },
  {
    id: 127,
    name: "Shahi Jeera",
    nameH: "शाही जीरा",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "20.00",
    qty: "20 Gram",
    discount: "33% off",
    img: [g127],
  },
  {
    id: 128,
    name: "Khara Masur Dal",
    nameH: "खरा मसूर दाल",
    brand: "Matardana",
    oldprice: "",
    newprice: "80.00",
    qty: "1 KG",
    discount: "",
    img: [p18],
    available: "not",
  },
  {
    id: 129,
    name: "Rajma Spot",
    nameH: "राजमा",
    brand: "Matardana",
    oldprice: "160.00",
    newprice: "135.00",
    qty: "1 KG",
    discount: "16% off",
    img: [g76],
  },
  {
    id: 130,
    name: "Fortune Refine Soyabean Oil",
    nameH: "फॉर्च्यून सोयाबीन तेल",
    brand: "Fortune",
    oldprice: "190.00",
    newprice: "185.00",
    qty: "1 Ltr",
    discount: "3% off",
    img: [g129],
  },
  {
    id: 131,
    name: "Arwa Rice",
    nameH: "अरवा चावल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "100.00",
    qty: "2 KG",
    discount: "17% off",
    img: [g128],
  },
  {
    id: 132,
    name: "Mace ( Javitri )",
    nameH: "जावित्री",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "76.00",
    qty: "20 Gram",
    discount: "24% off",
    img: [g132],
  },
  {
    id: 133,
    name: "Nutmeg (Jayphal)",
    nameH: "जायफल",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "33.00",
    qty: "20 Gram",
    discount: "18% off",
    img: [g133],
  },
  {
    id: 134,
    name: "Sukhi Lal Mirch",
    nameH: "सुखी लाल मिर्च",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "24.00",
    qty: "100 Gram",
    discount: "20% off",
    img: [g134],
  },
  {
    id: 135,
    name: "Tej Patta",
    nameH: "तेज पत्ता",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "10.00",
    qty: "50 Gram",
    discount: "60% off",
    img: [g135],
  },
  {
    id: 136,
    name: "Dhaniya",
    nameH: "धनिया",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "26.00",
    qty: "100 Gram",
    discount: "13% off",
    img: [g136],
  },
  {
    id: 137,
    name: "Black Pepper",
    nameH: "काली मीर्च",
    brand: "Matardana",
    oldprice: "82.00",
    newprice: "65.00",
    qty: "100 Gram",
    discount: "21% off",
    img: [g137],
  },
  {
    id: 138,
    name: "Star Anise (Chakri Phool)",
    nameH: "चक्र फूल",
    brand: "Matardana",
    oldprice: "150.00",
    newprice: "147.00",
    qty: "100 Gram",
    discount: "2% off",
    img: [g131],
  },
  {
    id: 139,
    name: "Dalchini",
    nameH: "दालचीनी",
    brand: "Matardana",
    oldprice: "55.00",
    newprice: "39.00",
    qty: "50 Gram",
    discount: "29% off",
    img: [g130],
  },
];

export const Flours = [
  {
    id: 1,
    name: "Raagi Flour(Marua Aata)",
    nameH: "मरुआ का आटा",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "16.00",
    qty: "250 Gram",
    discount: "20% off",
    img: [fl1],
  },
  {
    id: 2,
    name: "Aashirvaad Atta",
    nameH: "आशीर्वाद आटा",
    brand: "Aashirvaad",
    oldprice: "213.00",
    newprice: "180.00",
    qty: "5 KG",
    discount: "15% off",
    img: [fl2],
  },
  {
    id: 3,
    name: "Fortune Atta",
    nameH: "फॉर्च्यून आटा",
    brand: "Fortune",
    oldprice: "195.00",
    newprice: "170.00",
    qty: "5 KG",
    discount: "13% off",
    img: [fl3],
  },
  {
    id: 4,
    name: "Neelkamal Besan",
    nameH: "नीलकमल बेसन",
    brand: "Neelkamal",
    oldprice: "40.00",
    newprice: "34.00",
    qty: "250 Gram",
    discount: "15% off",
    img: [fl4],
  },
  {
    id: 5,
    name: "Neelkamal Sattu",
    nameH: "नीलकमल सत्तू",
    brand: "Neelkamal",
    oldprice: "43.00",
    newprice: "40.00",
    qty: "250 Gram",
    discount: "7% off",
    img: [fl5],
  },
  {
    id: 6,
    name: "Subhkamal Maida",
    nameH: "सुभकमल मैदा",
    brand: "Subh Kamal",
    oldprice: "29.00",
    newprice: "27.00",
    qty: "500 Gram",
    discount: "7% off",
    img: [fl6],
  },
  {
    id: 7,
    name: "Weikfield Corn Flour",
    nameH: "वेइकफील्ड कॉर्न फ्लोर",
    brand: "Weikfield",
    oldprice: "27.00",
    newprice: "26.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [fl7],
  },
  {
    id: 8,
    name: "Subhkamal Suji",
    nameH: "सुभकमल सुजि",
    brand: "Subh kamal",
    oldprice: "29.00",
    newprice: "27.00",
    qty: "500 Gram",
    discount: "7% off",
    img: [fl8],
  },
  {
    id: 9,
    name: "Shree Neelkamal Dalia",
    nameH: "श्री नीलकमल दलिया",
    brand: "Neelkamal",
    oldprice: "30.00",
    newprice: "28.00",
    qty: "400 Gram",
    discount: "7% off",
    img: [fl9],
  },
  {
    id: 10,
    name: "Maize Flour",
    nameH: "मकई का आटा",
    brand: "Matardana",
    oldprice: "67.00",
    newprice: "44.00",
    qty: "1 KG",
    discount: "34% off",
    img: [fl10],
  },
  {
    id: 11,
    name: "Chakki Aata",
    nameH: "चक्की आटा",
    brand: "Matardana",
    oldprice: "130.00",
    newprice: "115.00",
    qty: "5 KG",
    discount: "12% off",
    img: [fl11],
  },
];

export const Pulses = [
  {
    id: 1,
    name: "Kushi Kerao",
    nameH: "कुशी केराओ",
    brand: "Matardana",
    oldprice: "",
    newprice: "50.00",
    qty: "1 KG",
    discount: "",
    img: [g1],
  },
  {
    id: 2,
    name: "Chana Dal",
    nameH: "चना दाल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "85.00",
    qty: "1 KG",
    discount: "29% off",
    img: [g65],
  },
  {
    id: 3,
    name: "Masoor Dal",
    nameH: "मसूर दाल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "105.00",
    qty: "1 KG",
    discount: "13% off",
    img: [g66],
  },
  {
    id: 4,
    name: "Moong Dal",
    nameH: "मूंग का दाल",
    brand: "Matardana",
    oldprice: "135.00",
    newprice: "125.00",
    qty: "1 KG",
    discount: "7% off",
    img: [g67],
  },
  {
    id: 5,
    name: "Urad Dal",
    nameH: "उरद दाल",
    brand: "Matardana",
    oldprice: "170.00",
    newprice: "121.00",
    qty: "1 KG",
    discount: "29% off",
    img: [g68],
  },
  {
    id: 6,
    name: "Kali Urad",
    nameH: "काली उरद",
    brand: "Matardana",
    oldprice: "145.00",
    newprice: "140.00",
    qty: "1 KG",
    discount: "3% off",
    img: [g69],
  },
  {
    id: 7,
    name: "Arhar Dal",
    nameH: "अरहर दाल",
    brand: "Matardana",
    oldprice: "130.00",
    newprice: "120.00",
    qty: "1 KG",
    discount: "8% off",
    img: [g70],
  },
  {
    id: 8,
    name: "Khara Moong Dal",
    nameH: "खरा मूंग दाल",
    brand: "Matardana",
    oldprice: "",
    newprice: "129.00",
    qty: "1 KG",
    discount: "",
    img: [g71],
  },
  {
    id: 9,
    name: "Khesari Pulse (Khesari Dal)",
    nameH: "खेसारी दाल",
    brand: "Matardana",
    oldprice: "",
    newprice: "70.00",
    qty: "1 KG",
    discount: "",
    img: [g72],
  },
  {
    id: 10,
    name: "Kala Chana",
    nameH: "काला चना",
    brand: "Matardana",
    oldprice: "95.00",
    newprice: "72.00",
    qty: "1 KG",
    discount: "24% off",
    img: [g73],
  },
  {
    id: 11,
    name: "Kaabuli Chana",
    nameH: "काबुली चना",
    brand: "Matardana",
    oldprice: "140.00",
    newprice: "120.00",
    qty: "1 KG",
    discount: "14% off",
    img: [g74],
  },
  {
    id: 12,
    name: "Desi Pila Chana",
    nameH: "देशी पीला चना",
    brand: "Matardana",
    oldprice: "90.00",
    newprice: "78.00",
    qty: "1 KG",
    discount: "13% off",
    img: [g75],
  },
  {
    id: 13,
    name: "Rajma Spot",
    nameH: "राजमा",
    brand: "Matardana",
    oldprice: "160.00",
    newprice: "135.00",
    qty: "1 KG",
    discount: "16% off",
    img: [g76],
  },
  {
    id: 14,
    name: "Rajma Black",
    nameH: "राजमा ब्लैक",
    brand: "Matardana",
    oldprice: "130.00",
    newprice: "122.00",
    qty: "1 KG",
    discount: "6% off",
    img: [g76],
  },
  {
    id: 15,
    name: "Kabuli Matar(Desi Small Size)",
    nameH: "काबुली मटर (देसी छोटा आकार)",
    brand: "Matardana",
    oldprice: "60.00",
    newprice: "55.00",
    qty: "1 KG",
    discount: "8% off",
    img: [g77],
  },
  {
    id: 16,
    name: "Kabuli Matar",
    nameH: "काबुली मटर",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "78.00",
    qty: "1 KG",
    discount: "22% off",
    img: [g77],
  },
  {
    id: 17,
    name: "Hara Matar",
    nameH: "हरा मटर",
    brand: "Matardana",
    oldprice: "160.00",
    newprice: "144.00",
    qty: "1 KG",
    discount: "10% off",
    img: [g78],
  },
  {
    id: 18,
    name: "Khara Masur Dal",
    nameH: "खरा मसूर दाल",
    brand: "Matardana",
    oldprice: "",
    newprice: "80.00",
    qty: "1 KG",
    discount: "",
    img: [pu18],
    available: "not",
  },
];

export const Rice = [
  {
    id: 1,
    name: "Arwa Rice",
    nameH: "अरवा चावल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "100.00",
    qty: "2 KG",
    discount: "17% off",
    img: [g128],
  },
  {
    id: 2,
    name: "Parmal Boiled Rice",
    nameH: "परमल चावल",
    brand: "Matardana",
    oldprice: "340.00",
    newprice: "310.00",
    qty: "5 KG",
    discount: "9% off",
    img: [g57],
  },
  {
    id: 3,
    name: "Biryani Rice",
    nameH: "बिरयानी चावल",
    brand: "Matardana",
    oldprice: "150.00",
    newprice: "90.00",
    qty: "1 KG",
    discount: "40% off",
    img: [g58],
  },
  {
    id: 4,
    name: "Pulav Rice",
    nameH: "पुलाव चावल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "90.00",
    qty: "1 KG",
    discount: "25% off",
    img: [g59],
  },
  {
    id: 5,
    name: "Basmati Rice",
    nameH: "बासमती चावल",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "100.00",
    qty: "1 KG",
    discount: "17% off",
    img: [g60],
  },
  {
    id: 6,
    name: "Kheer Rice",
    nameH: "खीर का चावल",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "60.00",
    qty: "1 KG",
    discount: "40% off",
    img: [g125],
  },
  {
    id: 7,
    name: "Chura",
    nameH: "चुरा",
    brand: "Matardana",
    oldprice: "",
    newprice: "20.00",
    qty: "500 Gram",
    discount: "",
    img: [g123],
  },
  {
    id: 8,
    name: "Basmati Chura",
    nameH: "बासमती चुरा",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "100.00",
    qty: "1 KG",
    discount: "17% off",
    img: [g120],
  },
];

export const Salt = [
  {
    id: 1,
    name: "Fortune Pure & Hygienic Sulphurless Process Sugar",
    nameH: "फॉर्च्यून शुद्ध और स्वच्छ सल्फर रहित चीनी",
    brand: "Fortune",
    oldprice: "60.00 ",
    newprice: "59.00",
    qty: "1 KG",
    discount: "2% off",
    img: [g2],
  },

  {
    id: 2,
    name: "Aashirwad Iodized Salt",
    nameH: "आशीर्वाद आयोडीन नमक",
    brand: "ITC",
    oldprice: "21.00",
    newprice: "19.00",
    qty: "1 KG",
    discount: "10% off",
    img: [g54],
  },
  {
    id: 3,
    name: "Tata Salt",
    nameH: "नमक",
    brand: "Tata",
    oldprice: "21.00",
    newprice: "20.00",
    qty: "1 KG",
    discount: "5% off",
    img: [g61],
  },
  {
    id: 4,
    name: "Black Salt(Powder)",
    nameH: "काला नमक",
    brand: "Matardana",
    oldprice: "35.00",
    newprice: "30.00",
    qty: "500 Gram",
    discount: "14% off",
    img: [g63],
  },
  {
    id: 5,
    name: "Rock Salt (Powder)",
    nameH: "सेंधा नमक",
    brand: "Matardana",
    oldprice: "",
    newprice: "34.00",
    qty: "500 Gram",
    discount: "",
    img: [g64],
  },
  {
    id: 6,
    name: "Dhaga Misri",
    nameH: "धागा मिसरि",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "26.00",
    qty: "250 Gram",
    discount: "13% off",
    img: [g124],
  },
  {
    id: 7,
    name: "Gud/Mithha",
    nameH: "गुड़",
    brand: "Matardana",
    oldprice: "75.00",
    newprice: "65.00",
    qty: "1 KG",
    discount: "13% off",
    img: [g50],
  },
  {
    id: 8,
    name: "Sugar (Chini)",
    nameH: "चीनी",
    brand: "Matardana",
    oldprice: "48.00",
    newprice: "44.00",
    qty: "1 KG",
    discount: "8% off",
    img: [g91],
  },
  {
    id: 9,
    name: "Black Salt(Rock)",
    nameH: "काला नमक (रॉक)",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "45.00",
    qty: "1 KG",
    discount: "55% off",
    img: [g115],
  },
  {
    id: 10,
    name: "Rock Salt(Rock)",
    nameH: "सेंधा नमक (रॉक)",
    brand: "Matardana",
    oldprice: "120.00",
    newprice: "82.00",
    qty: "1 KG",
    discount: "32% off",
    img: [g114],
  },
  {
    id: 11,
    name: "Catch Black Salt",
    nameH: "काला नमक",
    brand: "multi brand",
    oldprice: "",
    newprice: "45.00",
    qty: "200 Gram",
    discount: "",
    img: [g111],
  },
  {
    id: 12,
    name: "Sugar Free Gold(25 Sachets)",
    nameH: "शुगर फ्री गोल्ड",
    brand: "Sugar Free",
    oldprice: "44.00",
    newprice: "42.00",
    qty: "18.75 Gram",
    discount: "5% off",
    img: [g110],
  },
];

export const Oil = [
  {
    id: 1,
    name: "Dhara Mustard Oil",
    nameH: "धारा सरसों का तेल",
    brand: "Dhara",
    oldprice: "200.00",
    newprice: "190.00",
    qty: "1 Ltr",
    discount: "5% off",
    img: [g100],
  },

  {
    id: 2,
    name: "Scooter Premium Kacchi Ghani Pure Mustard Oil",
    nameH: "स्कूटर प्रीमियम कच्ची घानी शुद्ध सरसों का तेल",
    brand: "Scooter",
    oldprice: "200.00",
    newprice: "190.00",
    qty: "1 Ltr",
    discount: "5% off",
    img: [g101],
  },
  {
    id: 3,
    name: "Fortune Rice Bran Refined Oil",
    nameH: "फॉर्च्यून राइस ब्रान रिफाइंड तेल",
    brand: "Fortune",
    oldprice: "205.00",
    newprice: "200.00",
    qty: "1 Ltr",
    discount: "2% off",
    img: [g102],
  },
  {
    id: 4,
    name: "Fortune Refine Soyabean Oil",
    nameH: "फॉर्च्यून सोयाबीन तेल",
    brand: "Fortune",
    oldprice: "190.00",
    newprice: "185.00",
    qty: "1 Ltr",
    discount: "3% off",
    img: [g129],
  },
  {
    id: 5,
    name: "Emami Healthy & Tasty Kachchi Ghani Mustard Oil",
    nameH: "इमामी स्वस्थ और स्वादिष्ट कच्ची घानी सरसों का तेल",
    brand: "Emami",
    oldprice: "205.00",
    newprice: "195.00",
    qty: "1 Ltr",
    discount: "5% off",
    img: [g104],
  },
  {
    id: 6,
    name: "Emami Healthy & Tasty Refined Soyabean Oil",
    nameH: "इमामी स्वस्थ और स्वादिष्ट रिफाइंड सोयाबीन तेल",
    brand: "Emami",
    oldprice: "175.00",
    newprice: "170.00",
    qty: "1 Ltr",
    discount: "3% off",
    img: [g105],
  },
  {
    id: 7,
    name: "Home Made Fresh Mustard Oil (Home Made)",
    nameH: "सरसों का तेल",
    brand: "Matardana",
    oldprice: "250.00",
    newprice: "220.00",
    qty: "1 Ltr",
    discount: "12% off",
    img: [g106],
  },
  {
    id: 8,
    name: "Sudha Ghee",
    nameH: "सुधा घी",
    brand: "Sudha",
    oldprice: "250.00",
    newprice: "248.00",
    qty: "500 Gram",
    discount: "1% off",
    img: [g107],
  },
  {
    id: 9,
    name: "Amul Ghee",
    nameH: "अमूल घी",
    brand: "Amul",
    oldprice: "255.00",
    newprice: "250.00",
    qty: "500 Gram",
    discount: "2% off",
    img: [g108],
  },
];

export const Spices = [
  {
    id: 1,
    name: "Everest Garam Masala",
    nameH: "एवरेस्ट गरम मसाला",
    brand: "Everest",
    oldprice: "78.00",
    newprice: "76.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g5],
  },

  {
    id: 2,
    name: "Everest Amchur",
    nameH: "अमचूर",
    brand: "Everest",
    oldprice: "80.00",
    newprice: "75.00",
    qty: "100 Gram",
    discount: "6% off",
    img: [g6],
  },
  {
    id: 3,
    name: "Everest Haldi Powder",
    nameH: "हल्दी पाउडर",
    brand: "Everest",
    oldprice: "31.00",
    newprice: "30.00",
    qty: "100 Gram",
    discount: "3%  off",
    img: [g7],
  },
  {
    id: 4,
    name: "Everest Dhaniya Powder",
    nameH: "धनिया पाउडर",
    brand: "Everest",
    oldprice: "35.00",
    newprice: "32.00",
    qty: "100 Gram",
    discount: "9% off",
    img: [g8],
  },
  {
    id: 5,
    name: "Everest Black Pepper Powder",
    nameH: "गोलकी पाउडर",
    brand: "Everest",
    oldprice: "67.00",
    newprice: "66.00",
    qty: "50 Gram",
    discount: "1% off",
    img: [g9],
  },
  {
    id: 6,
    name: "Everest Kasuri Methi",
    nameH: "कश्तुरी मेथी",
    brand: "Everest",
    oldprice: "47.00",
    newprice: "46.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [img60, img61],
  },
  {
    id: 7,
    name: "Everest Biryani Masala",
    nameH: "बिरयानी मसाला",
    brand: "Everest",
    oldprice: "70.00",
    newprice: "68.00",
    qty: "50 Gram",
    discount: "3% off",
    img: [g11],
  },
  {
    id: 8,
    name: "Everest Chaat Masala",
    nameH: "चाट मसाला",
    brand: "Everest",
    oldprice: "62.00",
    newprice: "61.00",
    qty: "100 Gram",
    discount: "2% off",
    img: [g12],
  },
  {
    id: 9,
    name: "Everest Meat Masala",
    nameH: "मीट मसाला",
    brand: "Everest",
    oldprice: "72.00",
    newprice: "71.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g13],
  },
  {
    id: 10,
    name: "Everest Pav Bhaji Masala",
    nameH: "पावभाजी मसाला",
    brand: "Everest",
    oldprice: "40.00",
    newprice: "36.00",
    qty: "50 Gram",
    discount: "10% off",
    img: [g14],
  },
  {
    id: 11,
    name: "Everest Sambhar Masala",
    nameH: "सांभर मसाला",
    brand: "Everest",
    oldprice: "36.00",
    newprice: "35.00",
    qty: "50 Gram",
    discount: "3% off",
    img: [g16],
  },
  {
    id: 12,
    name: "Everest Jaljira Powder",
    nameH: "एवरेस्ट जलजीरा पाउडर",
    brand: "Everest",
    oldprice: "50.00",
    newprice: "49.00",
    qty: "100 Gram",
    discount: "2% off",
    img: [g20],
  },
  {
    id: 13,
    name: "Everest Chicken Masala",
    nameH: "एवरेस्ट चिकन मसाला",
    brand: "Everest",
    oldprice: "72.00",
    newprice: "71.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g22],
  },
  {
    id: 14,
    name: "Everest Kitchen King Masala",
    nameH: "एवरेस्ट किचन किंग मसाला",
    brand: "Everest",
    oldprice: "65.00",
    newprice: "62.00",
    qty: "100 Gram",
    discount: "5% off",
    img: [g23],
  },
  {
    id: 15,
    name: "Everest Sabji Masala",
    nameH: "एवरेस्ट सब्जी मसाला",
    brand: "Everest",
    oldprice: "29.00",
    newprice: "27.00",
    qty: "50 Gram",
    discount: "7% off",
    img: [g24],
  },
  {
    id: 16,
    name: "Everest Kashmirilal Red Chilli Powder",
    nameH: "एवरेस्ट कश्मीरीलाल लाल मिर्च पाउडर",
    brand: "Everest",
    oldprice: "65.00",
    newprice: "62.00",
    qty: "100 Gram",
    discount: "5% off",
    img: [g25],
  },
  {
    id: 17,
    name: "Everest Jeera Powder",
    nameH: "एवरेस्ट जीरा पाउडर",
    brand: "Everest",
    oldprice: "28.00",
    newprice: "26.00",
    qty: "50 Gram",
    discount: "7% off",
    img: [g26],
  },
  {
    id: 18,
    name: "Everest Red Chilli Powder",
    nameH: "एवरेस्ट लाल मिर्च पाउडर",
    brand: "Everest",
    oldprice: "23.00",
    newprice: "22.00",
    qty: "50 Gram",
    discount: "4% off",
    img: [g27],
  },

  {
    id: 19,
    name: "MDH Meat Masala",
    nameH: "एमडीएच मीट मसाला",
    brand: "MDH",
    oldprice: "73.00",
    newprice: "72.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g29],
  },
  {
    id: 20,
    name: "MDH Kitchen King",
    nameH: "एमडीएच किचन किंग",
    brand: "MDH",
    oldprice: "70.00",
    newprice: "68.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g30],
  },
  {
    id: 21,
    name: "MDH Jeera Powder",
    nameH: "जीरा पाउडर",
    brand: "MDH",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [g31],
  },
  {
    id: 22,
    name: "MDH Chicken Masala",
    nameH: "चिकन मसाला",
    brand: "MDH",
    oldprice: "70.00",
    newprice: "69.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g32],
  },
  {
    id: 23,
    name: "MDH Amchur Powder",
    nameH: "एमडीएच अमचूर पाउडर",
    brand: "MDH",
    oldprice: "80.00",
    newprice: "78.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g33],
  },
  {
    id: 24,
    name: "MDH Chunky Chat Masala",
    nameH: "एमडीएच चंकी चाट मसाला",
    brand: "MDH",
    oldprice: "65.00",
    newprice: "63.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g34],
  },
  {
    id: 25,
    name: "MDH Garam Masala",
    nameH: "एमडीएच गरम मसाला",
    brand: "MDH",
    oldprice: "78.00",
    newprice: "75.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [g35],
  },
  {
    id: 26,
    name: "MDH Karahi Paneer Masala",
    nameH: "एमडीएच कराही पनीर मसाला",
    brand: "MDH",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "60 Gram",
    discount: "4% off",
    img: [g36],
  },
  {
    id: 27,
    name: "MDH Shahi Paneer Masala",
    nameH: "एमडीएच शाही पनीर मसाला",
    brand: "MDH",
    oldprice: "42.00",
    newprice: "41.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [g37],
  },
  {
    id: 28,
    name: "MDH Kasuri Methi",
    nameH: "एमडीएच कस्तूरी मैथि",
    brand: "Everest",
    oldprice: "46.00",
    newprice: "45.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [g38],
  },
  {
    id: 29,
    name: "Chings Secret Veg Manchurian Masala",
    nameH: "चिंग्स सीक्रेट वेज मंचूरियन मसाला",
    brand: "Chings",
    oldprice: "",
    newprice: "10.00",
    qty: "20 Gram",
    discount: "",
    img: [g39],
  },

  {
    id: 30,
    name: "Rakesh Garam Masala",
    nameH: "राकेश गरम मसाला",
    brand: "Rakesh",
    oldprice: "50.00",
    newprice: "47.00",
    qty: "50 Gram",
    discount: "6% off",
    img: [g41],
  },
  {
    id: 31,
    name: "Weikfield Baking Powder",
    nameH: "बेकिंग पाउडर",
    brand: "Weikfield",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g42],
  },
  {
    id: 32,
    name: "Rakesh Mirch Powder",
    nameH: "मिर्च पाउडर",
    brand: "Rakesh",
    oldprice: "25.00",
    newprice: "23.00",
    qty: "50 Gram",
    discount: "8% off",
    img: [g43],
  },
  {
    id: 33,
    name: "Nilons Ginger Garlic Paste",
    nameH: "निलोंस अदरक लहसुन का पेस्ट",
    brand: "Nilons",
    oldprice: "",
    newprice: "5.00",
    qty: "30 Gram",
    discount: "",
    img: [g45],
  },
  {
    id: 34,
    name: "Sunrise Hing Powder",
    nameH: "हिंग पाउडर",
    brand: "Sunrise",
    oldprice: "",
    newprice: "10.00",
    qty: "8 Gram",
    discount: "",
    img: [g46],
  },

  {
    id: 35,
    name: "Homefills Edible Soda(Baking Soda)",
    nameH: "होमफिल्ल्स खाद्य सोडा",
    brand: "Homefills",
    oldprice: "",
    newprice: "10.00",
    qty: "100 Gram",
    discount: "",
    img: [g48],
  },
  {
    id: 36,
    name: "Chings Schezwan Fried Rice Masala",
    nameH: "चिंग्स सचेज़वान फ्राइड राइस मसाला",
    brand: "Chings",
    oldprice: "",
    newprice: "10.00",
    qty: "20 Gram",
    discount: "",
    img: [g49],
  },

  {
    id: 37,
    name: "Maggie Magic Masala",
    nameH: "मैगी मैजिक मसाला",
    brand: "Maggi",
    oldprice: "",
    newprice: "10.00",
    qty: "6 Gram",
    discount: "",
    img: [g51],
  },

  {
    id: 38,
    name: "Ajwain",
    nameH: "आजवाइन",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "35.00",
    qty: "100 Gram",
    discount: "13% off",
    img: [g84],
  },
  {
    id: 39,
    name: "Mangrela",
    nameH: "मंगरेला",
    brand: "Matardana",
    oldprice: "56.00",
    newprice: "42.00",
    qty: "100 Gram",
    discount: "25% off",
    img: [g85],
  },
  {
    id: 40,
    name: "Saunf",
    nameH: "सौंफ",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "20.00",
    qty: "100 Gram",
    discount: "33% off",
    img: [g86],
  },
  {
    id: 41,
    name: "Methi",
    nameH: "मेथी",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "18.00",
    qty: "100 Gram",
    discount: "10% off",
    img: [g87],
  },
  {
    id: 42,
    name: "Yellow Mustard (Pila Sarso)",
    nameH: "पीला सरसों",
    brand: "Matardana",
    oldprice: "22.00",
    newprice: "15.00",
    qty: "100 Gram",
    discount: "32% off",
    img: [g88],
  },
  {
    id: 43,
    name: "Black Mustard (Rai)",
    nameH: "Black Mustard (Rai)",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "18.00",
    qty: "100 Gram",
    discount: "28% off",
    img: [g89],
  },
  {
    id: 44,
    name: "Panch Phoron",
    nameH: "पंचफोरन",
    brand: "Matardana",
    oldprice: "35.00",
    newprice: "25.00",
    qty: "100 Gram",
    discount: "29% off",
    img: [g90],
    overview:
      "Methi, Pila Sarso, Sauf, Jeera, and Kalonji and five ingredients in Panch Phoron.Panch Phoron is delicious as a rub for meats, added to Indian stews, sprinkled on vegetables, or used for pickling vegetables.  It is also a delicious addition to any “carb-like” foods such as bread-like naan bread.",
  },

  {
    id: 45,
    name: "Cardamom (Elaichi)",
    nameH: "इलायची",
    brand: "Matardana",
    oldprice: "110.00",
    newprice: "70.00",
    qty: "25 Gram",
    discount: "36% off",
    img: [g122],
  },
  {
    id: 46,
    name: "Dalchini",
    nameH: "दालचीनी",
    brand: "Matardana",
    oldprice: "55.00",
    newprice: "39.00",
    qty: "50 Gram",
    discount: "29% off",
    img: [g130],
  },
  {
    id: 47,
    name: "Laung",
    nameH: "लौंग",
    brand: "Matardana",
    oldprice: "81.00",
    newprice: "38.00",
    qty: "50 Gram",
    discount: "53% off",
    img: [g126],
  },
  {
    id: 48,
    name: "Star Anise (Chakri Phool)",
    nameH: "चक्र फूल",
    brand: "Matardana",
    oldprice: "150.00",
    newprice: "147.00",
    qty: "100 Gram",
    discount: "2% off",
    img: [g131],
  },
  {
    id: 49,
    name: "Shahi Jeera",
    nameH: "शाही जीरा",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "20.00",
    qty: "20 Gram",
    discount: "33% off",
    img: [g127],
  },
  {
    id: 50,
    name: "Badi Elaichi",
    nameH: "बड़ी इलायची",
    brand: "Matardana",
    oldprice: "140.00",
    newprice: "112.00",
    qty: "100 Gram",
    discount: "20% off",
    img: [g119],
  },
  {
    id: 51,
    name: "Jeera",
    nameH: "जीरा",
    brand: "Matardana",
    oldprice: "35.00",
    newprice: "30.00",
    qty: "100 Gram",
    discount: "14% off",
    img: [g92],
  },
  {
    id: 51,
    name: "Mace ( Javitri )",
    nameH: "जावित्री",
    brand: "Matardana",
    oldprice: "100.00",
    newprice: "76.00",
    qty: "20 Gram",
    discount: "24% off",
    img: [g132],
  },
  {
    id: 52,
    name: "Nutmeg (Jayphal)",
    nameH: "जायफल",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "33.00",
    qty: "20 Gram",
    discount: "18% off",
    img: [g133],
  },
  {
    id: 53,
    name: "Sukhi Lal Mirch",
    nameH: "सुखी लाल मिर्च",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "24.00",
    qty: "100 Gram",
    discount: "20% off",
    img: [g134],
  },
  {
    id: 54,
    name: "Tej Patta",
    nameH: "तेज पत्ता",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "10.00",
    qty: "50 Gram",
    discount: "60% off",
    img: [g135],
  },
  {
    id: 55,
    name: "Dhaniya",
    nameH: "धनिया",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "26.00",
    qty: "100 Gram",
    discount: "13% off",
    img: [g136],
  },
  {
    id: 56,
    name: "Black Pepper",
    nameH: "काली मीर्च",
    brand: "Matardana",
    oldprice: "82.00",
    newprice: "65.00",
    qty: "100 Gram",
    discount: "21% off",
    img: [g137],
  },
];

export const Dry = [
  {
    id: 1,
    name: "Makhana (Top Quality)",
    nameH: "मखाना",
    brand: "Matardana",
    oldprice: "210.00",
    newprice: "185.00",
    qty: "250 Gram",
    discount: "12% off",
    img: [g4],
  },

  {
    id: 2,
    name: "Kaju",
    nameH: "काजू",
    brand: "Matardana",
    oldprice: "270.00",
    newprice: "263.00",
    qty: "250 Gram",
    discount: "3% off",
    img: [g28],
  },
  {
    id: 3,
    name: "Almond",
    nameH: "बादाम",
    brand: "Matardana",
    oldprice: "250.00",
    newprice: "240.00",
    qty: "250 Gram",
    discount: "4% off",
    img: [g40],
  },
  {
    id: 4,
    name: "Pista(Roasted & Salted With Shell)",
    nameH: "पिस्ता(रोस्टेड & साल्टेड विथ शैल)",
    brand: "multi brand",
    oldprice: "350.00",
    newprice: "305.00",
    qty: "200 Gram",
    discount: "13% off",
    img: [g44],
  },
  {
    id: 5,
    name: "Peanut",
    nameH: "मूंगफली दाना",
    brand: "Matardana",
    oldprice: "150.00",
    newprice: "140.00",
    qty: "1 KG",
    discount: "7% off",
    img: [g47],
  },
  {
    id: 6,
    name: "Kishmish",
    nameH: "किशमिश",
    brand: "Matardana",
    oldprice: "",
    newprice: "40.00",
    qty: "100 Gram",
    discount: "",
    img: [g79],
  },
  {
    id: 7,
    name: "Wallnut/ Akhrot - Inshell",
    nameH: "अखरोट",
    brand: "Matardana",
    oldprice: "600.00",
    newprice: "387.00",
    qty: "500 Gram",
    discount: "36% off",
    img: [g80],
  },
  {
    id: 8,
    name: "Coconut Powder",
    nameH: "नारियल का बुरादा",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "32.00",
    qty: "100 Gram",
    discount: "20% off",
    img: [g81],
  },
  {
    id: 9,
    name: "Dates With Seed",
    nameH: "बिज़ बाला खजूर",
    brand: "Matardana",
    oldprice: "365.00",
    newprice: "210.00",
    qty: "500 Gram",
    discount: "42% off",
    img: [g82],
  },
  {
    id: 10,
    name: "Munakka",
    nameH: "मुनक्का",
    brand: "Matardana",
    oldprice: "175.00",
    newprice: "165.00",
    qty: "250 Gram",
    discount: "6% off",
    img: [g83],
  },
  {
    id: 11,
    name: "Dry Dates",
    nameH: "छुहारा",
    brand: "Matardana",
    oldprice: "",
    newprice: "165.00",
    qty: "500 Gram",
    discount: "% off",
    img: [g94],
  },
  {
    id: 12,
    name: "Dry Coconut",
    nameH: "सूखा नारियल/गरि नारियल",
    brand: "Matardana",
    oldprice: "",
    newprice: "150.00",
    qty: "500 Gram",
    discount: "",
    img: [g95],
  },

  {
    id: 13,
    name: "Posta Dana",
    nameH: "पोस्ता दाना",
    brand: "Matardana",
    oldprice: "",
    newprice: "200.00",
    qty: "100 Gram",
    discount: "",
    img: [g121],
  },
  {
    id: 14,
    name: "MDH Kesar",
    nameH: "एमडीएच केसर",
    brand: "MDH",
    oldprice: "255.00",
    newprice: "240.00",
    qty: "1 Gram",
    discount: "6% off",
    img: [g116],
  },
  {
    id: 15,
    name: "Walnut Without Shell",
    nameH: "बिना शेल वाला अखरोट",
    brand: "multi brand",
    oldprice: "435.00",
    newprice: "350.00",
    qty: "250 Gram",
    discount: "20% off",
    img: [g138],
  },

  {
    id: 16,
    name: "Pista",
    nameH: "पिस्ता",
    brand: "Matardana",
    oldprice: "600.00",
    newprice: "530.00",
    qty: "200 Gram",
    discount: "12% off",
    img: [g118],
    available: "not",
  },
  {
    id: 17,
    name: "Dates Without Seed",
    nameH: "बिना बिज़ का खजूर",
    brand: "Matardana",
    oldprice: "",
    newprice: "350.00",
    qty: "500 Gram",
    discount: "",
    img: [g139],
    available: "not",
  },
];

export const Snacks = [
  {
    id: 1,
    name: "Parle-G Original Glucose Biscuits (2 Pack)",
    nameH: "पारले-जी ओरिजिनल ग्लूकोज बिस्किट",
    brand: "Parle",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [s1],
  },

  {
    id: 2,
    name: "Bisk Farm Googly Sweet And Salt Biscuits",
    nameH: "बिस्क फार्म गुगली मीठा और नमक बिस्कुट",
    brand: "Biskfarm",
    oldprice: "",
    newprice: "10.00",
    qty: "80 Gram",
    discount: "",
    img: [s2],
  },
  {
    id: 3,
    name: "Sunfeast Moms Magic Cashew & Almond Cookies(Pack Of 2)",
    nameH: "काजू और बादाम कुकीज़",
    brand: "Sunfeast",
    oldprice: "",
    newprice: "10.00",
    qty: "33 Gram",
    discount: "",
    img: [s3],
  },
  {
    id: 4,
    name: "Sunfeast Dark Fantasy Choco Fills Filled Biscuits",
    nameH: "सनफीस्ट डार्क फैंटेसी चोको बिस्कुट",
    brand: "Sunfeast",
    oldprice: "",
    newprice: "120.00",
    qty: "300 Gram",
    discount: "",
    img: [s4],
  },
  {
    id: 5,
    name: "Parle Platina Hide & Seek Cookies (2 Packs)",
    nameH: "पार्ले प्लेटिना हाईड एन सिक",
    brand: "Parle",
    oldprice: "",
    newprice: "20.00",
    qty: "1 Piece",
    discount: "",
    img: [s5],
  },
  {
    id: 6,
    name: "Cadbury Oreo Chocolatey Sandwich Cream Biscuit (Orginal)",
    nameH: "कैडबरी ओरेओ चॉकलेट चॉकलेट सैंडविच बिस्किट",
    brand: "Cadbury",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "120 Gram",
    discount: "3% off",
    img: [s6],
  },
  {
    id: 7,
    name: "Sunfeast Bounce Choco Cream Biscuit(Pack Of 2)",
    nameH: "सनफीस्ट बाउंस चोको क्रीम बिस्किट",
    brand: "Sunfeast",
    oldprice: "",
    newprice: "10.00",
    qty: "34 Gram",
    discount: "",
    img: [s7],
  },
  {
    id: 8,
    name: "Sunfeast Bounce Elaichi Cream Biscuits(Pack Of 2)",
    nameH: "सनफीस्ट बाउंस एलैची क्रीम बिस्कुट",
    brand: "Sunfeast",
    oldprice: "",
    newprice: "10.00",
    qty: "34 Gram",
    discount: "",
    img: [s8],
  },
  {
    id: 9,
    name: "Sunfeast Bounce Cream Biscuit(82gm)",
    nameH: "सनफीस्ट बाउंस क्रीम बिस्किट",
    brand: "Sunfeast",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [s12],
  },
  {
    id: 10,
    name: "Sunfeast Moms Magic Cashew & Almond Cookies",
    nameH: "काजू और बादाम कुकीज़",
    brand: "Sunfeast",
    oldprice: "",
    newprice: "30.00",
    qty: "250 Gram",
    discount: "",
    img: [s13],
  },
  {
    id: 11,
    name: "Sunfeast Farmlite Nuts Digestive Biscuit",
    nameH: "",
    brand: "Sunfeast",
    oldprice: "60.00",
    newprice: "55.00",
    qty: "250 Gram",
    discount: "8% off",
    img: [s19],
  },
  {
    id: 12,
    name: "Sunfeast Farmlite 5 Seed Digestive Biscuit",
    nameH: "",
    brand: "Sunfeast",
    oldprice: "60.00",
    newprice: "56.00",
    qty: "250 Gram",
    discount: "7% off",
    img: [s20],
  },
  {
    id: 13,
    name: "Parle 20-20 Butter Cookies(pack Of 2)",
    nameH: "पार्ले 20-20 बटर कुकीज",
    brand: "Parle",
    oldprice: "",
    newprice: "10.00",
    qty: "35 Gram",
    discount: "",
    img: [s9],
  },
  {
    id: 14,
    name: "Lotte Chocopie Chocolate Biscuits",
    nameH: "लोटे चोको पाई चॉकलेट बिस्कुट",
    brand: "Lotte",
    oldprice: "",
    newprice: "20.00",
    qty: "2 Piece",
    discount: "",
    img: [s10],
  },
  {
    id: 15,
    name: "Jeera Wounder Biscuit",
    nameH: "जीरा वाउंडर बिस्किट",
    brand: "Biskfarm",
    oldprice: "25.00",
    newprice: "24.00",
    qty: "1 Piece",
    discount: "4% off",
    img: [s11],
  },
  {
    id: 16,
    name: "Britannia Marie Gold (Family Pack)",
    nameH: "मैरीगोल्ड बिस्कुट",
    brand: "britannia",
    oldprice: "34.00",
    newprice: "33.00",
    qty: "300 Gram",
    discount: "3% off",
    img: [s117],
  },
  {
    id: 17,
    name: "Cadbury Oreo Chocolatey Sandwich Cream Biscuit (Choco Creme)",
    nameH: "कैडबरी ओरेओ चॉकलेट चॉकलेट सैंडविच बिस्किट",
    brand: "Cadbury",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "120 Gram",
    discount: "3% off",
    img: [s14],
  },
  {
    id: 18,
    name: "WeikFIELD Custard Powder (Vanilla Flavour)",
    nameH: "वेकफील्ड कस्टर्ड पाउडर",
    brand: "Weikfield",
    oldprice: "37.00",
    newprice: "36.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [s15],
  },
  {
    id: 19,
    name: "Parle 20 20 Butter Cookies",
    nameH: "पार्ले 20 20 बटर कूकीज",
    brand: "Parle",
    oldprice: "20.00",
    newprice: "19.00",
    qty: "150 Gram",
    discount: "5% off",
    img: [s16],
  },
  {
    id: 20,
    name: "Hajmola Regular (120N)",
    nameH: "",
    brand: "Dabur",
    oldprice: "45.00",
    newprice: "44.00",
    qty: "1 Piece",
    discount: "2% off",
    img: [s17],
  },
  {
    id: 21,
    name: "Haldiram Moong Dal",
    nameH: "",
    brand: "Haldirams",
    oldprice: "",
    newprice: "103.00",
    qty: "400 Gram",
    discount: "",
    img: [s18],
  },
  {
    id: 22,
    name: "Cookies",
    nameH: "",
    brand: "Patanjali",
    oldprice: "50.00",
    newprice: "40.00",
    qty: "60 Piece",
    discount: "20% off",
    img: [s21],
  },
  {
    id: 23,
    name: "Marie Gold Biscuits(83 Gram) - (Pack Of 2)",
    nameH: "मैरीगोल्ड बिस्कुट",
    brand: "britannia",
    oldprice: "",
    newprice: "20.00",
    qty: "1 Piece",
    discount: "",
    img: [s22],
  },
  {
    id: 24,
    name: "Good Day Cashew Cookies 60gram",
    nameH: "गुड्डे बिस्कुट काजू फ्लेवर",
    brand: "britannia",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [s23],
  },
  {
    id: 25,
    name: "Britannia 50-50 Sweet & Salty Biscuit ",
    nameH: "ब्रिटानिया 50-50 मीठा और नमकीन बिस्किट",
    brand: "britannia",
    oldprice: "",
    newprice: "10.00",
    qty: "85 Gram",
    discount: "",
    img: [s24],
  },
  {
    id: 26,
    name: "Pappa Biscuits",
    nameH: "पप्पा बिस्कुट",
    brand: "Matardana",
    oldprice: "85.00",
    newprice: "80.00",
    qty: "500 Gram",
    discount: "6% off",
    img: [s25],
  },
  {
    id: 27,
    name: "Parle Rusk",
    nameH: "पारले रस्क",
    brand: "Parle",
    oldprice: "",
    newprice: "30.00",
    qty: "200 Gram",
    discount: "",
    img: [s26],
  },
  {
    id: 28,
    name: "Lipton Tulsi Natura Green 25 Tea Bags",
    nameH: "लिप्टन तुलसी नटुरे ग्रीन (25N)",
    brand: "Unilever",
    oldprice: "",
    newprice: "165.00",
    qty: "1 Piece",
    discount: "",
    img: [s27],
  },
  {
    id: 29,
    name: "Lipton Green Tea Honey Lemon (25 N)",
    nameH: "लिप्टन ग्रीन टिया हनी लेमन (25 N)",
    brand: "Unilever",
    oldprice: "",
    newprice: "165.00",
    qty: "1 Piece",
    discount: "",
    img: [s28],
  },
  {
    id: 30,
    name: "Hajmola Imli (50N)",
    nameH: "हाजमोला इमली",
    brand: "Dabur",
    oldprice: "",
    newprice: "20.00",
    qty: "1 Piece",
    discount: "",
    img: [s29],
  },
  {
    id: 31,
    name: "Hajmola Regular (50N)",
    nameH: "हाजमोला",
    brand: "Dabur",
    oldprice: "",
    newprice: "20.00",
    qty: "1 Piece",
    discount: "",
    img: [s30],
  },
  {
    id: 32,
    name: "Britannia Gobbles Choco Chill Cake (Pack Of 2)",
    nameH: "ब्रिटानिया गोबीज़ चोको चिल",
    brand: "britannia",
    oldprice: "20.00",
    newprice: "18.00",
    qty: "42 Gram",
    discount: "10% off",
    img: [s31],
  },
  {
    id: 33,
    name: "Pappa Biscut Long",
    nameH: "पप्पा बिस्कुट लम्बा",
    brand: "Matardana",
    oldprice: "85.00",
    newprice: "80.00",
    qty: "500 Gram",
    discount: "6% off",
    img: [s32],
  },
  {
    id: 34,
    name: "Anik Papad",
    nameH: "अनिक पापड़",
    brand: "Anik",
    oldprice: "45.00",
    newprice: "44.00",
    qty: "200 Gram",
    discount: "2% off",
    img: [s33],
  },
  {
    id: 35,
    name: "Kissan Chotu Fresh Tomato Ketchup",
    nameH: "किसान छोटू ताजा टमाटर केचप",
    brand: "Kissan",
    oldprice: "",
    newprice: "15.00",
    qty: "130 Gram",
    discount: "",
    img: [s34],
  },
  {
    id: 36,
    name: "Tomato Ketchup",
    nameH: "टमाटर का कैच अप",
    brand: "Kissan",
    oldprice: "65.00",
    newprice: "60.00",
    qty: "200 Gram",
    discount: "8% off",
    img: [s35],
  },
  {
    id: 37,
    name: "Tomato Sauce",
    nameH: "टमाटर का सौस",
    brand: "Maggi",
    oldprice: "65.00",
    newprice: "60.00",
    qty: "200 Gram",
    discount: "8% off",
    img: [s36],
  },
  {
    id: 38,
    name: "Schezwan Stir Fry Sauce",
    nameH: "शेजवान सौस",
    brand: "Chings",
    oldprice: "85.00",
    newprice: "80.00",
    qty: "250 Gram",
    discount: "6% off",
    img: [s37],
  },
  {
    id: 39,
    name: "WeikFIELD Red Chilli Sauce",
    nameH: "वीइक्फेल्ड रेड चिली सॉस",
    brand: "Weikfield",
    oldprice: "90.00",
    newprice: "80.00",
    qty: "630 Gram",
    discount: "11% off",
    img: [s38],
  },
  {
    id: 40,
    name: "Nilons Schezwan Chutney",
    nameH: "निलोन शेजवान चटनी",
    brand: "Nilons",
    oldprice: "75.00",
    newprice: "72.00",
    qty: "250 Gram",
    discount: "4% off",
    img: [s39],
  },
  {
    id: 41,
    name: "Nilons Soya Sauce",
    nameH: "निलोन की सोया सॉस",
    brand: "Nilons",
    oldprice: "",
    newprice: "20.00",
    qty: "80 Gram",
    discount: "",
    img: [s40],
  },
  {
    id: 42,
    name: "Mustard Sauce",
    nameH: "सरसो का सौस",
    brand: "Matardana",
    oldprice: "",
    newprice: "70.00",
    qty: "700 Gram",
    discount: "",
    img: [s41],
  },
  {
    id: 43,
    name: "Nilons Green Chilli Sauce",
    nameH: "निलोन की हरी मिर्च की चटनी",
    brand: "Nilons",
    oldprice: "",
    newprice: "20.00",
    qty: "80 Gram",
    discount: "",
    img: [s42],
  },
  {
    id: 44,
    name: "Nilons Tomato Ketchup",
    nameH: "निलोन का टमाटर केचप",
    brand: "Nilons",
    oldprice: "",
    newprice: "15.00",
    qty: "80 Gram",
    discount: "",
    img: [s43],
  },
  {
    id: 45,
    name: "Chings Dark Soya Sauce",
    nameH: "सोया सौस",
    brand: "Chings",
    oldprice: "",
    newprice: "20.00",
    qty: "90 Gram",
    discount: "",
    img: [s44],
  },
  {
    id: 46,
    name: "Tops Premium Red Chilli Red Sauce",
    nameH: "टॉप प्रीमियम रेड चिली रेड सॉस",
    brand: "Tops",
    oldprice: "",
    newprice: "70.00",
    qty: "650 Gram",
    discount: "",
    img: [s45],
  },
  {
    id: 47,
    name: "Fun Foods Pasta & Pizza Sauce",
    nameH: "फन फूड्स पास्ता और पिज्जा सॉस",
    brand: "multi brand",
    oldprice: "",
    newprice: "89.00",
    qty: "325 Gram",
    discount: "",
    img: [s46],
  },
  {
    id: 48,
    name: "Chings Secret Red Chilli Sauces",
    nameH: "लाल मिर्च सौस",
    brand: "Chings",
    oldprice: "",
    newprice: "20.00",
    qty: "90 Gram",
    discount: "",
    img: [s47],
  },
  {
    id: 49,
    name: "Bikaji Coated Peanuts Nut Cracker",
    nameH: "बीकाजी लेपित मूंगफली नट क्रैकर",
    brand: "Bikaji",
    oldprice: "110.00",
    newprice: "100.00",
    qty: "400 Gram",
    discount: "9% off",
    img: [s48],
  },
  {
    id: 50,
    name: "Sunfeast Yippee Magic Masala Instant Noodle",
    nameH: "यिप्पी मैजिक मसाला इंस्टेंट नूडल",
    brand: "Sunfeast",
    oldprice: "12.00",
    newprice: "11.04",
    qty: "70 Gram",
    discount: "8% off",
    img: [s49],
  },
  {
    id: 51,
    name: "Pasta Macaroni (loose)",
    nameH: "पास्ता मैक्रोनी",
    brand: "Matardana",
    oldprice: "55.00",
    newprice: "50.00",
    qty: "500 Gram",
    discount: "9% off",
    img: [s50],
  },
  {
    id: 52,
    name: "Chings Veg Hakka Instant Noodle",
    nameH: "चिंग्स वेज हक्का इंस्टा नूडल",
    brand: "Chings",
    oldprice: "30.00",
    newprice: "28.00",
    qty: "150 Gram",
    discount: "7% off",
    img: [s51],
  },
  {
    id: 53,
    name: "Masala Maggi",
    nameH: "मैगी मसाला",
    brand: "Nestle",
    oldprice: "",
    newprice: "12.00",
    qty: "1 Piece",
    discount: "",
    img: [s52],
  },
  {
    id: 54,
    name: "Masala Maggi - Pack Of 6",
    nameH: "मैगी मसाला",
    brand: "Nestle",
    oldprice: "",
    newprice: "68.00",
    qty: "420 Gram",
    discount: "",
    img: [s53],
  },
  {
    id: 55,
    name: "Masala Maggi - Pack Of 8",
    nameH: "मैगी मसाला",
    brand: "Nestle",
    oldprice: "",
    newprice: "91.00",
    qty: "560 Gram",
    discount: "",
    img: [s54],
  },
  {
    id: 56,
    name: "Yippee Tricolor Masala Pasta",
    nameH: "यिप्पी त्रिकॉलोर मसाला पास्ता",
    brand: "Sunfeast",
    oldprice: "",
    newprice: "25.00",
    qty: "65 Gram",
    discount: "",
    img: [s55],
  },
  {
    id: 57,
    name: "Yippee Masala Treat Macaroni/Elbow Pasta",
    nameH: "यिप्पी मसाला ट्रीट मैकरोनी/एल्बो पास्ता",
    brand: "Sunfeast",
    oldprice: "",
    newprice: "24.00",
    qty: "65 Gram",
    discount: "4% off",
    img: [s56],
  },
  {
    id: 58,
    name: "Britannia Nutri Choice Sugar Free Cracker Plain Biscuits",
    nameH: "ब्रिटानिया न्यूट्री चॉइस शुगर फ्री क्रैकर प्लेन बिस्किट",
    brand: "britannia",
    oldprice: "",
    newprice: "35.00",
    qty: "300 Gram",
    discount: "",
    img: [s57],
  },
  {
    id: 59,
    name: "Kissan Professional Sauce Dip",
    nameH: "किसान प्रोफेशनल सॉस डीप",
    brand: "Kissan",
    oldprice: "85.00",
    newprice: "82.00",
    qty: "930 Gram",
    discount: "4% off",
    img: [s58],
  },
  {
    id: 60,
    name: "Tata Tea Gold",
    nameH: "टाटा चाय गोल्ड",
    brand: "Tata",
    oldprice: "125.00",
    newprice: "123.00",
    qty: "250 Gram",
    discount: "2% off",
    img: [s59],
  },
  {
    id: 61,
    name: "Tea Open",
    nameH: "खुला चाय का पत्ति",
    brand: "Matardana",
    oldprice: "80.00",
    newprice: "75.00",
    qty: "250 Gram",
    discount: "6% off",
    img: [s60],
  },
  {
    id: 62,
    name: "Sabudana Papad",
    nameH: "साबूदाना पापड़",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "20.00",
    qty: "80 Gram",
    discount: "20% off",
    img: [s61],
  },
  {
    id: 63,
    name: "Happy Chef Pineapple Essence",
    nameH: "हैप्पी शेफ अनानास सार",
    brand: "Happy Chef",
    oldprice: "100.00",
    newprice: "99.00",
    qty: "30 Ml",
    discount: "1% off",
    img: [s62],
  },
  {
    id: 64,
    name: "Papilon Shades Of Liquid Food",
    nameH: "खाने का रंग",
    brand: "Papilon",
    oldprice: "250.00",
    newprice: "240.00",
    qty: "10 Piece",
    discount: "4% off",
    img: [s63],
  },
  {
    id: 65,
    name: "PURAMIO Kewra Culinary",
    nameH: "केवरा सार",
    brand: "Puramio",
    oldprice: "200.00",
    newprice: "170.00",
    qty: "50 Ml",
    discount: "15% off",
    img: [s64],
  },
  {
    id: 66,
    name: "Haldirams Namkeen - Mini Samosa",
    nameH: "हल्दीराम समोसा",
    brand: "Haldirams",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "200 Gram",
    discount: "4% off",
    img: [s65],
  },
  {
    id: 67,
    name: "Chips(Non Fried)",
    nameH: "चिप्स",
    brand: "Matardana",
    oldprice: "70.00",
    newprice: "60.00",
    qty: "200 Gram",
    discount: "14% off",
    img: [s66],
  },
  {
    id: 68,
    name: "Bikaji Aloo Bhujiya Tana-Tan",
    nameH: "बीकाजी आलू भुजिया टना-टन",
    brand: "Bikaji",
    oldprice: "55.00",
    newprice: "50.00",
    qty: "200 Gram",
    discount: "9% off",
    img: [s67],
  },
  {
    id: 69,
    name: "Haldirams Mathri",
    nameH: "हल्दीराम की मठरी",
    brand: "Haldirams",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "200 Gram",
    discount: "4% off",
    img: [s68],
  },
  {
    id: 70,
    name: "Haldirams Classic Nut Cracker",
    nameH: "हल्दीराम का क्लासिक नट क्रैकर",
    brand: "Haldirams",
    oldprice: "45.00",
    newprice: "42.00",
    qty: "200 Gram",
    discount: "7% off",
    img: [s69],
  },
  {
    id: 71,
    name: "Knorr Classic Hot & Sour Vegetable Soup",
    nameH: "नॉर क्लासिक हॉट एंड सॉर वेजिटेबल सूप",
    brand: "multi brand",
    oldprice: "55.00",
    newprice: "52.00",
    qty: "43 Gram",
    discount: "5% off",
    img: [s70],
  },
  {
    id: 72,
    name: "Weikfield Coca Powder",
    nameH: "वेकफील्ड कोका पाउडर",
    brand: "Weikfield",
    oldprice: "140.00",
    newprice: "136.00",
    qty: "50 Gram",
    discount: "3% off",
    img: [s71],
  },
  {
    id: 73,
    name: "Weikfield Drinking Chocolate",
    nameH: "वेकफील्ड ड्रिंकिंग चॉकलेट",
    brand: "Weikfield",
    oldprice: "65.00",
    newprice: "60.00",
    qty: "100 Gram",
    discount: "8% off",
    img: [s72],
  },
  {
    id: 74,
    name: "Gits Gulab Jamun Mix",
    nameH: "गिट्स गुलाब जामुन मिक्स",
    brand: "Gits",
    oldprice: "",
    newprice: "99.00",
    qty: "250 Gram",
    discount: "",
    img: [s73],
  },
  {
    id: 75,
    name: "Chings Secret Tomato With Croutons Soup",
    nameH: "चिंग सीक्रेट टोमेटो क्रोटोन्स सूप",
    brand: "Chings",
    oldprice: "",
    newprice: "10.00",
    qty: "16 Gram",
    discount: "",
    img: [s74],
  },
  {
    id: 76,
    name: "Fun Foods Original Veg Mayonnaise",
    nameH: "वेज मेयोनेज़",
    brand: "Dr.oetker",
    oldprice: "",
    newprice: "35.00",
    qty: "100 Gram",
    discount: "",
    img: [s75],
  },
  {
    id: 77,
    name: "Brooke Bond Red Label Tea",
    nameH: "रेड लेबल चाय",
    brand: "Brooke Bond",
    oldprice: "",
    newprice: "35.00",
    qty: "100 Gram",
    discount: "",
    img: [s76],
  },
  {
    id: 78,
    name: "Brooke Bond Taza Regular Tea",
    nameH: "ब्रुक बांड ताज़ा रेगुलर टी",
    brand: "Brooke Bond",
    oldprice: "",
    newprice: "85.00",
    qty: "250 Gram",
    discount: "",
    img: [s77],
  },
  {
    id: 79,
    name: "Saffola Veggie Twist Masala Oats",
    nameH: "सफोला वेजी मसाला ओट्स",
    brand: "Saffola",
    oldprice: "",
    newprice: "15.00",
    qty: "38 Gram",
    discount: "",
    img: [s78],
  },
  {
    id: 80,
    name: "Dabar Glucon D Instant Energy Regular Energy Drink",
    nameH: "ग्लुकोन डी एनर्जी ड्रिंक",
    brand: "Dabur",
    oldprice: "",
    newprice: "30.00",
    qty: "125 Gram",
    discount: "",
    img: [s79],
  },
  {
    id: 81,
    name: "Horlicks Health & Nutrition Drink(Plain)",
    nameH: "हॉर्लिक्स स्वास्थ्य और पोषण पेय",
    brand: "Horlicks",
    oldprice: "",
    newprice: "454.00",
    qty: "1 KG",
    discount: "",
    img: [s80],
  },
  {
    id: 82,
    name: "Womens Horlicks Plus",
    nameH: "हॉर्लिक्स महिला प्लस",
    brand: "Horlicks",
    oldprice: "299.00",
    newprice: "295.00",
    qty: "400 Gram",
    discount: "1% off",
    img: [s81],
  },
  {
    id: 83,
    name: "Nutrela Soya Mini Chunks(20Gram Free)",
    nameH: "न्यूट्रेला सोया मिनी चंक्स",
    brand: "Nutrela",
    oldprice: "",
    newprice: "45.00",
    qty: "220 Gram",
    discount: "",
    img: [s82],
  },
  {
    id: 84,
    name: "Nutrela Soya Chunks(20Gram Free)",
    nameH: "न्यूट्रेला सोया चंक्स",
    brand: "Nutrela",
    oldprice: "",
    newprice: "45.00",
    qty: "220 Gram",
    discount: "",
    img: [s83],
  },
  {
    id: 85,
    name: "Nilons Vinegar",
    nameH: "निलोन का सिरका",
    brand: "Nilons",
    oldprice: "60.00",
    newprice: "55.00",
    qty: "630 Ml",
    discount: "8% off",
    img: [s84],
  },
  {
    id: 86,
    name: "Lijjat Papad",
    nameH: "लिज्जत पापड़",
    brand: "Lijjat",
    oldprice: "72.00",
    newprice: "71.00",
    qty: "200 Gram",
    discount: "1% off",
    img: [s85],
  },
  {
    id: 87,
    name: "Haldirams Alo Bhujia",
    nameH: "हल्दीराम आलू भुजिया",
    brand: "Haldirams",
    oldprice: "46.00",
    newprice: "44.00",
    qty: "220 Gram",
    discount: "4% off",
    img: [s86],
  },
  {
    id: 88,
    name: "Haldirams Dal Biji",
    nameH: "हल्दीराम दाल बिजि",
    brand: "Haldirams",
    oldprice: "46.00",
    newprice: "44.00",
    qty: "200 Gram",
    discount: "4% off",
    img: [s87],
  },
  {
    id: 89,
    name: "Haldirams Navrattan",
    nameH: "हल्दीराम नवरत्न",
    brand: "Haldirams",
    oldprice: "44.00",
    newprice: "42.00",
    qty: "220 Gram",
    discount: "5% off",
    img: [s88],
  },
  {
    id: 90,
    name: "Haldirams Punjabi Tadka",
    nameH: "हल्दीराम पंजाबी तड़का",
    brand: "Haldirams",
    oldprice: "48.00",
    newprice: "46.00",
    qty: "220 Gram",
    discount: "4% off",
    img: [s89],
  },
  {
    id: 91,
    name: "Haldirams Khatta Meetha",
    nameH: "हल्दीराम खट्टा मीठा",
    brand: "Haldirams",
    oldprice: "87.00",
    newprice: "83.00",
    qty: "440 Gram",
    discount: "5% off",
    img: [s90],
  },
  {
    id: 92,
    name: "Saffola Everyday Classic Masala Oats",
    nameH: "सफोला एवरीडे क्लासिक मसाला ओट्स",
    brand: "Saffola",
    oldprice: "",
    newprice: "195.00",
    qty: "500 Gram",
    discount: "",
    img: [s91],
  },
  {
    id: 93,
    name: "Haldirams Chakoli",
    nameH: "हल्दीराम चाकोलि",
    brand: "Haldirams",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "200 Gram",
    discount: "4% off",
    img: [s92],
  },
  {
    id: 94,
    name: "Kelloggs Chocos Choco Flakes",
    nameH: "केलॉग्स चोकोस चोको फ्लेक्स",
    brand: "multi brand",
    oldprice: "",
    newprice: "20.00",
    qty: "56 Gram",
    discount: "",
    img: [s93],
  },
  {
    id: 95,
    name: "Bikaji Baat Cheet Papad",
    nameH: "बीकाजी बाट चीत पापड़",
    brand: "Bikaji",
    oldprice: "70.00",
    newprice: "68.00",
    qty: "250 Gram",
    discount: "3% off",
    img: [s94],
  },
  {
    id: 96,
    name: "Complan Kesar Badam Health Drink",
    nameH: "शिकायत केसर बादाम स्वास्थ्य पेय",
    brand: "multi brand",
    oldprice: "",
    newprice: "315.00",
    qty: "500 Gram",
    discount: "",
    img: [s95],
  },
  {
    id: 97,
    name: "Fortune Soya Chunks(Free 50gram Mini Soya Chunk)",
    nameH: "फॉर्च्यून सोया चंक्स",
    brand: "Fortune",
    oldprice: "",
    newprice: "45.00",
    qty: "200 Gram",
    discount: "",
    img: [s96],
  },
  {
    id: 98,
    name: "Sabudana Chips Azwain Flavour",
    nameH: "साबूदाना चिप्स अजवाइन फ्लेवर",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "35.00",
    qty: "200 Gram",
    discount: "13% off",
    img: [s97],
  },
  {
    id: 99,
    name: "Sabudana Chips Red Chilli Flavour",
    nameH: "साबूदाना चिप्स (चिल्ली)",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "35.00",
    qty: "200 Gram",
    discount: "13% off",
    img: [s98],
  },
  {
    id: 100,
    name: "Sabudana Jalabi Chips",
    nameH: "साबूदाना जलेबी चिप्स",
    brand: "Matardana",
    oldprice: "40.00",
    newprice: "35.00",
    qty: "200 Gram",
    discount: "13% off",
    img: [s99],
  },
  {
    id: 101,
    name: "Golden Fingers Fryums (Phophi)",
    nameH: "फोफी",
    brand: "Matardana",
    oldprice: "25.00",
    newprice: "20.00",
    qty: "200 Gram",
    discount: "20% off",
    img: [s100],
  },
  {
    id: 102,
    name: "3D Fryums (Heart And Badminton Shaped)",
    nameH: "फ्रयूमस",
    brand: "Matardana",
    oldprice: "35.00",
    newprice: "30.00",
    qty: "200 Gram",
    discount: "14% off",
    img: [s101],
  },
  {
    id: 103,
    name: "Multicolor Finger Fryums (Phophi - Small)",
    nameH: "फोफी",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "18.00",
    qty: "200 Gram",
    discount: "10% off",
    img: [s102],
  },
  {
    id: 104,
    name: "Multicolor Fryums (Phophi - Bhindi)",
    nameH: "फोफी भिंडी",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "18.00",
    qty: "200 Gram",
    discount: "10% off",
    img: [s103],
  },
  {
    id: 105,
    name: "Window - Wheel Fryums (Ready-to-Fry Snack)",
    nameH: "फ्रयूमस",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "18.00",
    qty: "200 Gram",
    discount: "10% off",
    img: [s104],
  },
  {
    id: 106,
    name: "Brooke Bond Taj Mahal Tea",
    nameH: "ताज महल चाय",
    brand: "Brooke Bond",
    oldprice: "",
    newprice: "150.00",
    qty: "250 Gram",
    discount: "",
    img: [s105],
  },
  {
    id: 107,
    name: "Nescafe Classic Coffee",
    nameH: "नेस्कैफे क्लासिक कॉफ़ी",
    brand: "Nestle",
    oldprice: "",
    newprice: "75.00",
    qty: "25 Gram",
    discount: "",
    img: [s106],
  },
  {
    id: 108,
    name: "Rajasthani Papad",
    nameH: "राजस्थानी पापड़",
    brand: "Rajasthani",
    oldprice: "55.00",
    newprice: "52.00",
    qty: "200 Gram",
    discount: "5% off",
    img: [s107],
  },
  {
    id: 109,
    name: "Chings Secret Schezwan Instant Noodle",
    nameH: "चिंग्स सीक्रेट शेजवान इंस्टेंट नूडल",
    brand: "Chings",
    oldprice: "60.00",
    newprice: "58.00",
    qty: "240 Gram",
    discount: "3% off",
    img: [s108],
  },
  {
    id: 110,
    name: "Britannia Good Day Cashew Almond Cookies(Pack Of 2)",
    nameH: "ब्रिटानिया गुड डे काजू बादाम कुकीज़",
    brand: "britannia",
    oldprice: "",
    newprice: "10.00",
    qty: "33 Gram",
    discount: "",
    img: [s109],
    available: "not",
  },
  {
    id: 111,
    name: "Haldiram Moong Dal 1 Kg",
    nameH: "",
    brand: "Haldirams",
    oldprice: "",
    newprice: "255.00",
    qty: "1 KG",
    discount: "",
    img: [s110],
    available: "not",
  },
  {
    id: 112,
    name: "7up Added Natural Lemon Cold Drink",
    nameH: "7अप नेचुरल लेमन कोल्ड ड्रिंक",
    brand: "7up",
    oldprice: "90.00",
    newprice: "78.00",
    qty: "2.25Ltr",
    discount: "13% off",
    img: [s111],
    available: "not",
  },
  {
    id: 113,
    name: "Tetley Green Tea, Honey And Lemon (25 N)",
    nameH: "हरी चाय",
    brand: "Tetley",
    oldprice: "",
    newprice: "165.00",
    qty: "1 Piece",
    discount: "",
    img: [s112],
    available: "not",
  },
  {
    id: 114,
    name: "Green Chilli Sauce",
    nameH: "हरा मिर्च सौस",
    brand: "Chings",
    oldprice: "70.00",
    newprice: "69.00",
    qty: "680 Gram",
    discount: "1% off",
    img: [s113],
    available: "not",
  },
  {
    id: 115,
    name: "Marwar Papad",
    nameH: "मारवाड़ पापड़",
    brand: "Marwar",
    oldprice: "80.00",
    newprice: "75.00",
    qty: "200 Gram",
    discount: "6% off",
    img: [s114],
    available: "not",
  },
  {
    id: 116,
    name: "Britannia Bake Rusk Toast",
    nameH: "ब्रिटानिया रस्क बिस्कुट",
    brand: "britannia",
    oldprice: "",
    newprice: "30.00",
    qty: "200 Gram",
    discount: "",
    img: [s115],
    available: "not",
  },
  {
    id: 116,
    name: "Pichkoo Tomato Sauce",
    nameH: "पिचकू टमाटर सौस",
    brand: "Maggi",
    oldprice: "",
    newprice: "15.00",
    qty: "90 Gram",
    discount: "",
    img: [s116],
    available: "not",
  },
];

export const Household = [
  {
    id: 1,
    name: "Odonil Smile Air Freshener",
    nameH: "ओडोनिल स्माइल",
    brand: "Dabur",
    oldprice: "",
    newprice: "50.00",
    qty: "1 Piece",
    discount: "",
    img: [h1],
  },

  {
    id: 2,
    name: "Freshwrapp Aluminium Foil (9m)",
    nameH: "फ्रेशराप एल्युमीनियम फॉयल (9m)",
    brand: "DNV",
    oldprice: "71.00",
    newprice: "61.00",
    qty: "1 Piece",
    discount: "14% off",
    img: [h2],
  },
  {
    id: 3,
    name: "Freshwrapp Aluminium Foil 500g",
    nameH: "फ्रेशराप एल्युमीनियम फॉयल 500g",
    brand: "DNV",
    oldprice: "295.00",
    newprice: "260.00",
    qty: "500 Gram",
    discount: "12% off",
    img: [h3],
  },
  {
    id: 4,
    name: "Freshwrapp Aluminium Foil (72m)",
    nameH: "फ्रेशराप एल्युमीनियम फॉयल (72m)",
    brand: "DNV",
    oldprice: "435.00",
    newprice: "355.00",
    qty: "1 Piece",
    discount: "18% off",
    img: [h4],
  },
  {
    id: 5,
    name: "Alfa Aluminium Foil (72m)",
    nameH: "अल्फ़ा एल्युमीनियम फॉयल (72m)",
    brand: "multi brand",
    oldprice: "549.00",
    newprice: "310.00",
    qty: "1 Piece",
    discount: "44% off",
    img: [h5],
  },
  {
    id: 6,
    name: "Surf Excel Easy Wash Liquid",
    nameH: "सर्फ एक्सेल इज़ी वॉश लिक्विड",
    brand: "Surf Excel",
    oldprice: "",
    newprice: "170.00",
    qty: "1 Ltr",
    discount: "",
    img: [h6],
  },
  {
    id: 7,
    name: "Good Knight Active+ Mosquito Vaporiser Refill (45 Ml)",
    nameH: "गुड नाईट लिक्विड",
    brand: "Patanjali",
    oldprice: "",
    newprice: "72.00",
    qty: "45 Ml",
    discount: "",
    img: [h7],
  },
  {
    id: 8,
    name: "Vim Dishwash Bar - Lemon",
    nameH: "विम डिशवाश बार - नींबू",
    brand: "Vim",
    oldprice: "",
    newprice: "5.00",
    qty: "85 Gram",
    discount: "",
    img: [h8],
  },
  {
    id: 9,
    name: "Steel Scrubber",
    nameH: "स्टील स्क्रबर",
    brand: "Scotch brite",
    oldprice: "",
    newprice: "32.00",
    qty: "1 Piece",
    discount: "",
    img: [h9],
  },
  {
    id: 10,
    name: "Scotch Brite-Silver Sparcle(Pack Of 2 Piece)",
    nameH: "स्क्रबर",
    brand: "Scotch brite",
    oldprice: "25.00",
    newprice: "15.00",
    qty: "1 Piece",
    discount: "40% off",
    img: [h10],
  },
  {
    id: 11,
    name: "Surf Excel Easy Wash",
    nameH: "सर्फ एक्सेल इजी वाश डिटर्जेंट पाउडर",
    brand: "Surf Excel",
    oldprice: "55.00",
    newprice: "53.00",
    qty: "500 Gram",
    discount: "4% off",
    img: [h11],
  },
  {
    id: 12,
    name: "Lizol Disinfectant Surface & Floor Cleaner Liquid - Citrus",
    nameH: "सरफेस क्लीनर",
    brand: "Lizol",
    oldprice: "",
    newprice: "98.00",
    qty: "500 Ml",
    discount: "",
    img: [h12],
  },
  {
    id: 13,
    name: "Godrej Ezee 2 In 1 Liquid Detergent",
    nameH: "गोदरेज ईज़ी लिक्विड डिटर्जेंट 2 इन 1",
    brand: "Godrej",
    oldprice: "",
    newprice: "230.00",
    qty: "1 KG",
    discount: "",
    img: [h13],
  },
  {
    id: 14,
    name: "Colin Glass And Household Cleaner",
    nameH: "कोलिन ग्लास एंड हाउसहोल्ड क्लीनर",
    brand: "Colin",
    oldprice: "99.00",
    newprice: "93.00",
    qty: "500 Ml",
    discount: "6% off",
    img: [h14],
  },
  {
    id: 15,
    name: "Gainda Phenyle",
    nameH: "गैंडा फिनाइल",
    brand: "Gainda",
    oldprice: "60.00",
    newprice: "55.00",
    qty: "450 Ml",
    discount: "8% off",
    img: [h15],
  },
  {
    id: 16,
    name: "D Size Battery - Heavy Duty, 1050 R20",
    nameH: "डी साइज बैटरी हैवी ड्यूटी 1050",
    brand: "Eveready",
    oldprice: "60.00",
    newprice: "58.00",
    qty: "2 Piece",
    discount: "3% off",
    img: [h16],
  },
  {
    id: 17,
    name: "Tide Jasmine And Rose Detergent Powder",
    nameH: "टाइड जैस्मीन और गुलाब डिटर्जेंट पाउडर",
    brand: "Tide",
    oldprice: "96.00",
    newprice: "95.00",
    qty: "1 KG",
    discount: "1% off",
    img: [h17],
  },
  {
    id: 18,
    name: "Ariel Matic Top Load Detergent Powder",
    nameH: "एरियल मैटिक टॉप लोड डिटर्जेंट पाउडर",
    brand: "Ariel",
    oldprice: "225.00",
    newprice: "220.00",
    qty: "1 KG",
    discount: "2% off",
    img: [h18],
  },
  {
    id: 19,
    name: "Vim Liquid Dishwash Liquid - Gel Lemon",
    nameH: "विम तरल डिशवॉश तरल - जेल नींबू",
    brand: "Vim",
    oldprice: "",
    newprice: "45.00",
    qty: "250 Ml",
    discount: "%off",
    img: [h19],
  },
  {
    id: 20,
    name: "Garbage Bag (Medium Size 30 Pieces)",
    nameH: "कचरा बैग (मध्यम आकार के 30 टुकड़े)",
    brand: "multi brand",
    oldprice: "50.00",
    newprice: "40.00",
    qty: "1 Piece",
    discount: "20% off",
    img: [h20],
  },
  {
    id: 21,
    name: "The Original Laxmanrekha",
    nameH: "लक्ष्मणरेखा",
    brand: "Midas Hygiene",
    oldprice: "",
    newprice: "15.00",
    qty: "1 Piece",
    discount: "%off",
    img: [h21],
  },
  {
    id: 22,
    name: "Eveready Red Battery (AAA Size)",
    nameH: "एवरेडी रेड बैटरी",
    brand: "Eveready",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "2 Piece",
    discount: "3% off",
    img: [h22],
  },
  {
    id: 23,
    name: "Eveready Blue Battery (AAA Size)",
    nameH: "एवरेडी ब्लू बैटरी",
    brand: "Eveready",
    oldprice: "20.00",
    newprice: "19.00",
    qty: "2 Piece",
    discount: "5% off",
    img: [h23],
  },
  {
    id: 24,
    name: "Eveready Blue Battery (AA Size)",
    nameH: "एवरेडी ब्लू बैटरी",
    brand: "Eveready",
    oldprice: "20.00",
    newprice: "19.00",
    qty: "2 Piece",
    discount: "5% off",
    img: [h24],
  },
  {
    id: 25,
    name: "Eveready Red Battery (AA Size)",
    nameH: "एवरेडी रेड बैटरी",
    brand: "Eveready",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "2 Piece",
    discount: "3% off",
    img: [h25],
  },
  {
    id: 26,
    name: "Kamal Phenyle",
    nameH: "कमल फिनाइल",
    brand: "Kamal",
    oldprice: "75.00",
    newprice: "60.00",
    qty: "650 Ml",
    discount: "20% off",
    img: [h26],
  },
  {
    id: 27,
    name: "10 ON Toilet Roll(240Nx2 Sheets)",
    nameH: "10'ऑन टॉयलेट रोल",
    brand: "multi brand",
    oldprice: "30.00",
    newprice: "35.00",
    qty: "1 Piece",
    discount: "8% off",
    img: [h27],
  },
  {
    id: 28,
    name: "Paper Napkins",
    nameH: "कागज़ की ​नैपकिन्स",
    brand: "multi brand",
    oldprice: "58.00",
    newprice: "30.00",
    qty: "1 Piece",
    discount: "48% off",
    img: [h28],
  },
  {
    id: 29,
    name: "Cotton Kitchen Towel Roll",
    nameH: "Cotton Kitchen Towel Roll",
    brand: "multi brand",
    oldprice: "120.00",
    newprice: "105.00",
    qty: "1 Piece",
    discount: "13% off",
    img: [h29],
  },
  {
    id: 30,
    name: "Kitchen Napkin Roll (60Nx2 Sheets)",
    nameH: "किचन नैपकिन रोल",
    brand: "multi brand",
    oldprice: "78.00",
    newprice: "65.00",
    qty: "1 Piece",
    discount: "17% off",
    img: [h30],
  },
  {
    id: 31,
    name: "Rin Original Detergent Powder",
    nameH: "रिन डिटर्जेंट पाउडर",
    brand: "Rin",
    oldprice: "",
    newprice: "39.00",
    qty: "500 Gram",
    discount: "",
    img: [h41],
  },
  {
    id: 32,
    name: "Cherry Blossom Black Shoe Polish",
    nameH: "चेरी ब्लॉसम ब्लैक शू पॉलिश",
    brand: "multi brand",
    oldprice: "",
    newprice: "92.00",
    qty: "75 Ml",
    discount: "",
    img: [h42],
  },
  {
    id: 33,
    name: "Surf Excel Stain Eraser Detergent Bar",
    nameH: "सर्फ़ एकसेल स्टैन इरेज़र डिटर्जेंट बार",
    brand: "Surf Excel",
    oldprice: "",
    newprice: "16.00",
    qty: "150 Gram",
    discount: "",
    img: [h43],
  },
  {
    id: 34,
    name: "Ghadi Mahashaktishali Formula Detergent Powder",
    nameH: "घडी महाशक्तिशाली फार्मूला डिटर्जेंट पाउडर",
    brand: "Ghadi",
    oldprice: "",
    newprice: "59.00",
    qty: "1 KG",
    discount: "",
    img: [h44],
  },
  {
    id: 35,
    name: "Sani Fresh Ultra Shine Liquid ( Original )",
    nameH: "सानी फ्रेश अल्ट्रा शाइन लिक्विड ओरिजिनल;",
    brand: "Harpic",
    oldprice: "",
    newprice: "154.00",
    qty: "1 Ltr",
    discount: "",
    img: [h45],
  },
  {
    id: 36,
    name: "Fevi Kwik",
    nameH: "फेवी क्विक",
    brand: "Pidilite",
    oldprice: "",
    newprice: "5.00",
    qty: "5 Ml",
    discount: "",
    img: [h46],
  },
  {
    id: 37,
    name: "Eagle Super Phenyle",
    nameH: "चील छाप फिनाइल",
    brand: "multi brand",
    oldprice: "140.00",
    newprice: "135.00",
    qty: "1 Ltr",
    discount: "4% off",
    img: [h47],
    available:"not"
  },
  {
    id: 39,
    name: "Match Box / Matchstick(10 Pieces) Packet",
    nameH: "माचिस",
    brand: "multi brand",
    oldprice: "20.00",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "50% off",
    img: [h48],
    available:"not"
  },
  {
    id: 40,
    name: "Harpic Power Plus 10x Max Clean Plain Liquid Toilet Cleaner",
    nameH: "हार्पिक पावर प्लस 10x मैक्स क्लीन प्लेन लिक्विड टॉयलेट क्लीनर",
    brand: "Harpic",
    oldprice: "",
    newprice: "86.00",
    qty: "500 Ml",
    discount: "",
    img: [h31],
  },
  {
    id: 41,
    name: "Harpic 10x Better Cleaning Disinfectant Bathroom Cleaner Floral Liquid Toilet Cleaner",
    nameH: "हार्पिक 10x बेहतर सफाई निस्संक्रामक बाथरूम क्लीनर तरल शौचालय क्लीनर",
    brand: "Harpic",
    oldprice: "",
    newprice: "95.00",
    qty: "",
    discount: "",
    img: [h32],
  },
  {
    id: 42,
    name: "Lizol Disinfectant Surface Cleaner Floral Floor Cleaner",
    nameH: "लिज़ोल निस्संक्रामक सतह क्लीनर फ्लोरल फ़्लोर क्लीनर",
    brand: "Lizol",
    oldprice: "179.00",
    newprice: "174.00",
    qty: "975 Ml",
    discount: "3% off",
    img: [h33],
  },
  {
    id: 43,
    name: "Ariel Complete Detergent Powder (200 Gm Free)",
    nameH: "एरियल कम्पलीट डिटर्जेंट पाउडर (200 ग्राम फ्री)",
    brand: "Ariel",
    oldprice: "",
    newprice: "135.00",
    qty: "500 Gram",
    discount: "",
    img: [h34],
  },
  {
    id: 44,
    name: "Tide Double Power Plus Lemon & Mint Detergent Powder",
    nameH: "टाइड डबल पावर प्लस नींबू और पुदीना डिटर्जेंट पाउडर",
    brand: "Tide",
    oldprice: "",
    newprice: "52.00",
    qty: "500 Gram",
    discount: "",
    img: [h35],
  },
  {
    id: 45,
    name: "Vim Bar With Power Of Lemon",
    nameH: "नींबू की शक्ति के साथ विम बार",
    brand: "Vim",
    oldprice: "",
    newprice: "28.00",
    qty: "250 Gram",
    discount: "",
    img: [h36],
  },
  {
    id: 46,
    name: "Xpert Double Action Formula Bar(Pack Of 3) + 2 Scrub Pads + 1 Steel Scrubber Free)",
    nameH: "एक्सपर्ट डबल एक्शन फॉर्मूला बार",
    brand: "Xpert",
    oldprice: "60.00",
    newprice: "40.00",
    qty: "450 Gram",
    discount: "33% off",
    img: [h37],
  },
  {
    id: 47,
    name: "Odonil",
    nameH: "ओडोनिल",
    brand: "Dabur",
    oldprice: "141.00",
    newprice: "136.00",
    qty: "200 Gram",
    discount: "4% off",
    img: [h38],
  },
  {
    id: 48,
    name: "Exo Anti Bacterial Touch & Shine Round Bar",
    nameH: "एक्सो एंटी बैक्टीरियल टच एंड शाइन राउंड बार",
    brand: "Exo",
    oldprice: "67.00",
    newprice: "65.00",
    qty: "700 Gram",
    discount: "3% off",
    img: [h39],
  },
  {
    id: 49,
    name: "Odopic Dishwash Bar",
    nameH: "ओडोपिक डिशवॉश बार",
    brand: "Odopic",
    oldprice: "43.00",
    newprice: "40.00",
    qty: "500 Gram",
    discount: "7% off",
    img: [h40],
  },

];

export const Eggs = [
  {
    id: 1,
    name: "Amul Dahi",
    nameH: "अमूल दही",
    brand: "Amul",
    oldprice: "",
    newprice: "32.00",
    qty: "400 Gram",
    discount: "",
    img: [d1],
  },

  {
    id: 2,
    name: "Amul Butter",
    nameH: "अमूल मक्खन",
    brand: "Amul",
    oldprice: "",
    newprice: "50.00",
    qty: "100 Gram",
    discount: "",
    img: [d2],
  },
  {
    id: 3,
    name: "Amul Cheese Slices(10Unit X 20 Gram)",
    nameH: "अमूल चीज़",
    brand: "Amul",
    oldprice: "",
    newprice: "130.00",
    qty: "200 Gram",
    discount: "",
    img: [d3],
  },
  {
    id: 4,
    name: "Amul Cheese Block",
    nameH: "अमूल चीज़ ब्लॉक",
    brand: "Amul",
    oldprice: "",
    newprice: "114.00",
    qty: "200 Gram",
    discount: "",
    img: [d4],
  },
  {
    id: 5,
    name: "Amul Mithae Mate",
    nameH: "अमूल मीठा मेट",
    brand: "Amul",
    oldprice: "",
    newprice: "56.00",
    qty: "200 Gram",
    discount: "",
    img: [d5],
  },
  {
    id: 6,
    name: "Amul Fresh Cream",
    nameH: "अमूल फ्रेश क्रीम",
    brand: "Amul",
    oldprice: "199.00",
    newprice: "197.00",
    qty: "1 Ltr",
    discount: "1% off",
    img: [d6],
  },
  {
    id: 7,
    name: "Maharaja Brown Bread",
    nameH: "महाराजा ब्राउन ब्रेड",
    brand: "multi brand",
    oldprice: "",
    newprice: "40.00",
    qty: "400 Gram",
    discount: "",
    img: [d7],
  },
  {
    id: 8,
    name: "Raj Fresh Paneer",
    nameH: "राज फ्रेश पनीर",
    brand: "Raj fresh",
    oldprice: "",
    newprice: "75.00",
    qty: "200 Gram",
    discount: "",
    img: [d8],
  },
  {
    id: 9,
    name: "Dr. Oetker Peanuts Butter Ceamy",
    nameH: "क्रीमी पीनट्स बटर",
    brand: "Dr.oetker",
    oldprice: "169.00",
    newprice: "162.00",
    qty: "400 Gram",
    discount: "4% off",
    img: [d9],
  },
  {
    id: 10,
    name: "Amulya Dairy Whitener",
    nameH: "अमूल्य डेयरी व्हाइटनर",
    brand: "Amul",
    oldprice: "",
    newprice: "10.00",
    qty: "24 Gram",
    discount: "",
    img: [d10],
  },
 

];

export const Personal = [
  {
    id: 1,
    name: "Sensodyne Repair And Protect Toothpaste",
    nameH: "सेंसोडाइन टूथपेस्ट",
    brand: "Sensodyne",
    oldprice: "",
    newprice: "175.00",
    qty: "70 Gram",
    discount: "",
    img: [p1],
  },

  {
    id: 2,
    name: "Sensodyne Fresh Mint Toothpaste",
    nameH: "सेंसोडाइन टूथपेस्ट फ्रेश मिंट",
    brand: "Sensodyne",
    oldprice: "",
    newprice: "115.00",
    qty: "75 Gram",
    discount: "",
    img: [p2],
  },
  {
    id: 3,
    name: "Sensodyne Fresh Mint Toothpaste",
    nameH: "सेंसोडाइन टूथपेस्ट फ्रेश मिंट",
    brand: "Sensodyne",
    oldprice: "",
    newprice: "75.00",
    qty: "40 Gram",
    discount: "",
    img: [p3],
  },
  {
    id: 4,
    name: "Sensodyne Deep Clean Toothpaste",
    nameH: "सेंसोडाइन टूथपेस्",
    brand: "Sensodyne",
    oldprice: "",
    newprice: "70.00",
    qty: "40 Gram",
    discount: "",
    img: [p4],
  },
  {
    id: 5,
    name: "Sensodyne Toothbrush",
    nameH: "सेंसोडाइन टूथब्रश",
    brand: "Sensodyne",
    oldprice: "",
    newprice: "50.00",
    qty: "1 Piece",
    discount: "",
    img: [p5],
  },
  {
    id: 6,
    name: "Aqui Plus Cream",
    nameH: "एक्वी प्लस क्रीम",
    brand: "HAPDCO",
    oldprice: "100.00",
    newprice: "90.00",
    qty: "25 Gram",
    discount: "10% off",
    img: [p6],
  },
  {
    id: 7,
    name: "Sunny Face Wash Gel",
    nameH: "सनी फेस वाश जेल",
    brand: "Bakson Homoeopathic",
    oldprice: "145.00",
    newprice: "137.75",
    qty: "110 Gram",
    discount: "5% off",
    img: [p7],
  },
  {
    id: 8,
    name: "Sunny Fairness Cream For Men",
    nameH: "सनी फेयरनेस क्रीम फॉर मेन",
    brand: "Bakson Homoeopathic",
    oldprice: "150.00",
    newprice: "142.50",
    qty: "100 Gram",
    discount: "5% off",
    img: [p8],
  },
  {
    id: 9,
    name: "Jaborandi Hair Oil",
    nameH: "",
    brand: "SBL",
    oldprice: "135.00",
    newprice: "128.25",
    qty: "100 Ml",
    discount: "5% off",
    img: [p9],
  },
  {
    id: 10,
    name: "Arnica Montana Shampoo",
    nameH: "",
    brand: "SBL",
    oldprice: "143.00",
    newprice: "135.85",
    qty: "200 Ml",
    discount: "5% off",
    img: [p10],
  },
  {
    id: 11,
    name: "Arnica Montana Oil",
    nameH: "",
    brand: "SBL",
    oldprice: "135.00",
    newprice: "128.25",
    qty: "200 Ml",
    discount: "5% off",
    img: [p11],
  },
  {
    id: 12,
    name: "Aqui Plus Face Wash (Free 30% Extra)",
    nameH: "एक्वी प्लस फेस वाश",
    brand: "HAPDCO",
    oldprice: "",
    newprice: "95.00",
    qty: "65 Ml",
    discount: "",
    img: [p12],
  },
  {
    id: 13,
    name: "Sarda Arnica Vitalizer (Medicated Hair Oil)",
    nameH: "सारदा अर्निका विटालिजेर",
    brand: "multi brand",
    oldprice: "145.00",
    newprice: "130.50",
    qty: "200 Ml",
    discount: "10% off",
    img: [p13],
  },
  {
    id: 14,
    name: "Helka Lava Tooth Paste",
    nameH: "हल्का लावा टूथ पेस्ट",
    brand: "Wheezal",
    oldprice: "70.00",
    newprice: "63.00",
    qty: "100 Gram",
    discount: "10% off",
    img: [p14],
  },
  {
    id: 15 ,
    name: "Helka Lava Tooth Powder",
    nameH: "हल्का लावा टूथ पाउडर",
    brand: "Wheezal",
    oldprice: "105.00",
    newprice: "94.50",
    qty: "100 Gram",
    discount: "10% off",
    img: [p15],
  },
  {
    id: 16 ,
    name: "Silkn Stay Calendula Soap",
    nameH: "सिल्कन स्टे कैलेंडुला सोप",
    brand: "SBL",
    oldprice: "45.00",
    newprice: "42.75",
    qty: "75 Gram",
    discount: "5% off",
    img: [p16],
  },
  {
    id: 17 ,
    name: "Silkn Stay Glycerine Soap",
    nameH: "सिल्कन स्टे ग्लिसरीन सोप",
    brand: "SBL",
    oldprice: "50.00",
    newprice: "47.50",
    qty: "75 Gram",
    discount: "5% off",
    img: [p17],
  },
  {
    id:  18,
    name: "Jaborandi Hair Treatment ",
    nameH: "जैबोरैंडी हेयर ट्रीटमेंट",
    brand: "Wheezal",
    oldprice: "125.00",
    newprice: "115.00",
    qty: "110 Ml",
    discount: "8% off",
    img: [p18],
  },
  {
    id: 19 ,
    name: "Arnica Hair N Scalp Shampoo",
    nameH: "अर्निका हेयर न स्कैल्प शैम्पू",
    brand: "Wheezal",
    oldprice: "100.00",
    newprice: "90.00",
    qty: "100 Ml",
    discount: "10% off",
    img: [p19],
  },
  {
    id:  20,
    name: "Sunny Hair Color Black",
    nameH: "सनी हेयर कलर ब्लैक",
    brand: "Bakson Homoeopathic",
    oldprice: "40.00",
    newprice: "38.00",
    qty: "20 Gram",
    discount: "5% off",
    img: [p20],
  },
  {
    id:21  ,
    name: "Lux Soap",
    nameH: "लक्स",
    brand: "Lux",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [p21],
  },
  {
    id:  22,
    name: "Dove Cream Beauty Bathing Bar Soap",
    nameH: "डब साबुन",
    brand: "Dove",
    oldprice: "",
    newprice: "21.00",
    qty: "50 Gram",
    discount: "",
    img: [p22],
  },
  {
    id:23  ,
    name: "Dettol Bathing Bar Soap - Germ Protection, Original",
    nameH: "डेटोल साबुन",
    brand: "Dettol",
    oldprice: "40.00",
    newprice: "35.00",
    qty: "75 Gram",
    discount: "13% off",
    img: [p23],
  },
  {
    id:  24,
    name: "Dove Daily Shine Shampoo",
    nameH: "डब शैम्पू",
    brand: "Dove",
    oldprice: "70.00",
    newprice: "65.00",
    qty: "80 Ml",
    discount: "7% off",
    img: [p24],
  },
  {
    id:25  ,
    name: "Dove Anti-Dandruff Solutions - Dandruff Clean & Fresh Shampoo",
    nameH: "डब शैम्पू एंटी डैंड्रफ सोलूशन्स",
    brand: "Dove",
    oldprice: "65.00",
    newprice: "62.00",
    qty: "80 Ml",
    discount: "5% off",
    img: [p25],
  },
  {
    id:  26,
    name: "Bajaj Hair Oil - Almond Drops",
    nameH: "बजाज आलमंड आयल",
    brand: "Bajaj",
    oldprice: "",
    newprice: "67.00",
    qty: "100 Ml",
    discount: "%off",
    img: [p26],
  },
  {
    id: 27 ,
    name: "Colgate Total Advanced Health Anticavity Toothpaste ",
    nameH: "कोलगेट टूथ पेस्ट",
    brand: "Colgate",
    oldprice: "137.00",
    newprice: "135.00",
    qty: "185 Gram",
    discount: "1% off",
    img: [p27],
  },
  {
    id:28  ,
    name: "Pepsodent Germicheck Toothpaste",
    nameH: "पेप्सोडेंट जर्म प्रोटेक्शन",
    brand: "Pepsodent",
    oldprice: "95.00",
    newprice: "90.00",
    qty: "200 Gram",
    discount: "5% off",
    img: [p28],
  },
  {
    id:29  ,
    name: "Colgate ZigZag Anti Bacterial Soft Tooth Brush",
    nameH: "कोलगेट ज़िगज़ैग एंटी बैक्टीरियल सॉफ्ट टूथ ब्रश",
    brand: "Colgate",
    oldprice: "30.00",
    newprice: "25.00",
    qty: "1 Piece",
    discount: "17% off",
    img: [p29],
  },
  {
    id:30  ,
    name: "Tongue Cleaner(steel)",
    nameH: "जिभिया",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "50% off",
    img: [p30],
  },
  {
    id:31  ,
    name: "Dettol Skin Care Ph Balanced Hand Wash",
    nameH: "डेटॉल स्किन केयर Ph बैलेंस्ड हैंड वॉश",
    brand: "Dettol",
    oldprice: "79.00",
    newprice: "77.00",
    qty: "200 Ml",
    discount: "3% off",
    img: [p31],
  },
  {
    id:32  ,
    name: "Patanjali Dant Kanti Tooth Paste",
    nameH: "पतंजलि दंत कांति दाँत पेस्ट",
    brand: "Patanjali",
    oldprice: "",
    newprice: "45.00",
    qty: "100 Gram",
    discount: "%off",
    img: [p32],
  },
  {
    id:33  ,
    name: "Treseme Keratin Smooth Shampo",
    nameH: "ट्राइसेम शैंपू",
    brand: "Treseme",
    oldprice: "",
    newprice: "65.00",
    qty: "80 Ml",
    discount: "%off",
    img: [p33],
  },
  {
    id:34  ,
    name: "Lakme Blush & Glow Face Wash, Lemon Fresh",
    nameH: "लक्मे ब्लश और ग्लो फेस वाश क्रीम",
    brand: "Lakme",
    oldprice: "",
    newprice: "225.00",
    qty: "100 Gram",
    discount: "%off",
    img: [p34],
  },
  {
    id:35  ,
    name: "Ponds Dreamflower Fragrant Talc Pink Lily",
    nameH: "",
    brand: "Ponds",
    oldprice: "",
    newprice: "229.00",
    qty: "100 Gram",
    discount: "%off",
    img: [p35],
  },
  {
    id: 36 ,
    name: "Lifebuoy Total Soap",
    nameH: "लाइफबॉय टोटल साबुन",
    brand: "Lifebuoy",
    oldprice: "",
    newprice: "10.00",
    qty: "59 Gram",
    discount: "%off",
    img: [p36],
  },
  {
    id:37  ,
    name: "Dettol Skin Care Floral Soap(Pack Of 4 Buy 3 Get 1 Free)",
    nameH: "डेटॉल स्किन केयर फ्लोरल साबुन",
    brand: "Dettol",
    oldprice: "",
    newprice: "178.00",
    qty: "300 Gram",
    discount: "%off",
    img: [p37],
  },
  {
    id:38  ,
    name: "Godrej Cinthol Cool Menthol+Active Deo Soap",
    nameH: "गोदरेज सिनेथॉल कूल मेंथॉल + सक्रिय डीओ साबुन",
    brand: "Godrej",
    oldprice: "",
    newprice: "35.00",
    qty: "100 Gram",
    discount: "",
    img: [p38],
  },
  {
    id:39  ,
    name: "Dove Nutritive Solutions Hairfall Rescue Shampoo",
    nameH: "डोभ पोषण संबंधी समाधान हेयरफॉल बचाव शैम्पू",
    brand: "Dove",
    oldprice: "",
    newprice: "53.00",
    qty: "80 Ml",
    discount: "",
    img: [p39],
  },
  {
    id: 40 ,
    name: "Dettol Original Soap(Pack Of 5 Buy 4 Get 1 Free)",
    nameH: "डेटॉल मूल साबुन",
    brand: "Dettol",
    oldprice: "",
    newprice: "219.00",
    qty: "625 Gram",
    discount: "%off",
    img: [p40],
  },
  {
    id:41  ,
    name: "Hamam Neem Tulsi & Aloevera Soap",
    nameH: "हमाम नीम तुलसी और एलोवेरा साबुन",
    brand: "Hamam",
    oldprice: "",
    newprice: "32.00",
    qty: "100 Gram",
    discount: "",
    img: [p41],
  },
  {
    id:42,
    name: "Colgate Active Salt Mint Tooth Paste",
    nameH: "कोलगेट एक्टिव सॉल्ट मिंट टूथ पेस्ट",
    brand: "Colgate",
    oldprice: "",
    newprice: "99.00",
    qty: "200 Gram",
    discount: "%off",
    img: [p42],
  },
  {
    id:43  ,
    name: "Parachute Pure Coconut Oil",
    nameH: "पैराशूट नारियल तेल",
    brand: "Parachute",
    oldprice: "",
    newprice: "39.00",
    qty: "100 Ml",
    discount: "",
    img: [p43],
  },
  {
    id:  44,
    name: "Dettol Original Liquid Hand Wash",
    nameH: "डेटॉल ओरिजिनल लिक्विड हैंड वाश",
    brand: "Dettol",
    oldprice: "",
    newprice: "40.00",
    qty: "175 Ml",
    discount: "",
    img: [p44],
  },
  {
    id:45  ,
    name: "Dettol Skin Care Ph Balanced Hand Wash (Refill)",
    nameH: "डेटॉल स्किन केयर पीएच बैलेंस्ड हैंड वाश",
    brand: "Dettol",
    oldprice: "",
    newprice: "40.00",
    qty: "175 Ml",
    discount: "%off",
    img: [p45],
  },
  {
    id: 46 ,
    name: "Savlon Herbal Senstive Ph Balanced Hand Wash",
    nameH: "सेवलॉन हर्बल सेंसिटिव पीएच बैलेंस्ड हैंड वाश",
    brand: "ITC",
    oldprice: "99.00",
    newprice: "95.00",
    qty: "750 Ml",
    discount: "4% off",
    img: [p46],
  },
  {
    id: 47 ,
    name: "Tongue Cleaner(copper)",
    nameH: "जिभिया",
    brand: "multi brand",
    oldprice: "25.00",
    newprice: "15.00",
    qty: "1 Piece",
    discount: "40% off",
    img: [p47],
  },
  {
    id: 48 ,
    name: "Dermicool Menthol Regular Prickly Heat Powder(Free Dettol Shop Worth Rs.50)",
    nameH: "डर्मिकूल",
    brand: "Dermicool",
    oldprice: "",
    newprice: "117.00",
    qty: "150 Gram",
    discount: "",
    img: [p48],
  },
  {
    id: 49 ,
    name: "Dettol Original Liquid Hand Wash(Bottle)",
    nameH: "डेटॉल ओरिजिनल लिक्विड हैंड वाश",
    brand: "Dettol",
    oldprice: "",
    newprice: "99.00",
    qty: "250 Ml",
    discount: "",
    img: [p49],
  },
 
  {
    id:50  ,
    name: "Patanjali Aloevera Moisturizing Cream",
    nameH: "पतंजलि एलोवेरा मॉइस्चराइजिंग क्रीम",
    brand: "Patanjali",
    oldprice: "",
    newprice: "75.00",
    qty: "50 Gram",
    discount: "",
    img: [p50],
  },
  {
    id:  51,
    name: "Glycerin",
    nameH: "ग्लिसरीन",
    brand: "multi brand",
    oldprice: "45.00",
    newprice: "42.00",
    qty: "50 Gram",
    discount: "7% off",
    img: [p51],
  },
  {
    id: 52 ,
    name: "Vicco Turmeric Skin Cream",
    nameH: "विको हल्दी त्वचा क्रीम",
    brand: "Vicco",
    oldprice: "",
    newprice: "188.00",
    qty: "50 Gram",
    discount: "",
    img: [p52],
  },
  {
    id: 53 ,
    name: "Dettol Intense Cool 2x Menthol Soap",
    nameH: "डेटॉल इंटेंस कूल 2x मेन्थॉल साबुन",
    brand: "Dettol",
    oldprice: "",
    newprice: "33.00",
    qty: "75 Gram",
    discount: "",
    img: [p53],
  },
  {
    id: 54 ,
    name: "Lifebuoy Total 10 Handwash",
    nameH: "लाइफबॉय टोटल १० हैंडवॉश",
    brand: "Lifebuoy",
    oldprice: "",
    newprice: "90.00",
    qty: "190 Ml",
    discount: "",
    img: [p54],
  },
  {
    id:55  ,
    name: "Colgate Cibaca 1-2-3 Soft Toothbrush",
    nameH: "कोलगेट सिबाका 1-2-3 सॉफ्ट टूथब्रश",
    brand: "Colgate",
    oldprice: "",
    newprice: "15.00",
    qty: "1 Piece",
    discount: "",
    img: [p55],
  },
  {
    id:56  ,
    name: "Colgate Super Flexi Soft Toothbrush",
    nameH: "कोलगेट सुपर फ्लेक्सी सॉफ्ट टूथब्रश",
    brand: "Colgate",
    oldprice: "",
    newprice: "20.00",
    qty: "1 Piece",
    discount: "",
    img: [p56],
  },
  {
    id:57  ,
    name: "Vaseline Petroleum Jelly",
    nameH: "वेसिलीन पेट्रोलियम जेली",
    brand: "Vaseline",
    oldprice: "",
    newprice: "42.00",
    qty: "21 Gram",
    discount: "",
    img: [p57],
  },


 
  {
    id:58  ,
    name: "Pears Pure And Gentle Glycerin & Natural Oils Soap",
    nameH: "पीअर्स प्योर एंड जेंटल ग्लिसरीन नेचुरल ऑयल्स सोप",
    brand: "ITC",
    oldprice: "",
    newprice: "40.00",
    qty: "100 Gram",
    discount: "%off",
    img: [p58],
  },
];

export const Pooja = [
  {
    id: 1,
    name: "Cycle Rhythm Amber Agarbattis",
    nameH: "साइकिल एम्बर अगरबत्ती",
    brand: "Cycle",
    oldprice: "",
    newprice: "10.00",
    qty: "16 Gram",
    discount: "",
    img: [pj1],
  },

  {
    id: 2,
    name: "Cycle Heritage Radiant Rose Agarbattis",
    nameH: "साइकिल हेरिटेज रेडियंट रोज अगरबत्तिस",
    brand: "Cycle",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj2],
  },
  {
    id: 3,
    name: "Cycle Sandalum Agarbattis",
    nameH: "साइकिल चंदन अगरबत्ती",
    brand: "Cycle",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj3],
  },
  {
    id: 4,
    name: "Cycle Heritage Chandanam Agarbattis",
    nameH: "साइकिल हेरिटेज चंदनम अगरबत्ती",
    brand: "Cycle",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj4],
  },
  {
    id: 5,
    name: "Mangaldeep Puja Agarbattis Rose(Free Matchbox Inside)",
    nameH: "मंगलदीप पूजा अगरबत्ती गुलाब",
    brand: "Mangaldeep",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj5],
  },
  {
    id: 6,
    name: "Mangaldeep Puja Agarbattis Bouquet(Free Matchbox Inside)",
    nameH: "मंगलदीप पूजा अगरबत्ती गुलदस्ता",
    brand: "Mangaldeep",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj6],
  },
  {
    id: 7,
    name: "Mangaldeep Puja Agarbattis Treya(Free Matchbox Inside)",
    nameH: "मंगलदीप पूजा अगरबत्ती त्रय",
    brand: "Mangaldeep",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj7],
  },
  {
    id: 8,
    name: "Mangaldeep Puja Agarbattis Mogra(Free Matchbox Inside)",
    nameH: "मंगलदीप पूजा अगरबत्ती मोगरा",
    brand: "Mangaldeep",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj8],
  },
  {
    id: 9,
    name: "Mangaldeep Premium Lavender Agarbatti(Free Matchbox Inside)",
    nameH: "मंगलदीप प्रीमियम लैवेंडर अगरबत्ती",
    brand: "Mangaldeep",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj9],
  },
  {
    id: 10,
    name: "Shalimar Natural Sandal Dhoop",
    nameH: "शालीमार नेचुरल संदल धुप",
    brand: "multi brand",
    oldprice: "15.00",
    newprice: "13.00",
    qty: "1 Piece",
    discount: "13% off",
    img: [pj10],
  },
  {
    id: 11,
    name: "Shalimar Natural Rose Dhoop(10 Thick Sticks)",
    nameH: "शालीमार प्राकृतिक गुलाब धूप",
    brand: "multi brand",
    oldprice: "15.00",
    newprice: "13.00",
    qty: "",
    discount: "13% off",
    img: [pj11],
  },
  {
    id: 12,
    name: "Chandan Deluxe Dhoop",
    nameH: "चंदन डीलक्स धूप",
    brand: "multi brand",
    oldprice: "",
    newprice: "8.00",
    qty: "1 Piece",
    discount: "",
    img: [pj12],
  },
  {
    id: 13,
    name: "Subh Ganesh Ghee",
    nameH: "शुभ गणेश घी",
    brand: "multi brand",
    oldprice: "45.00",
    newprice: "24.00",
    qty: "100 Ml",
    discount: "47% off",
    img: [pj13],
  },
  {
    id: 14,
    name: "Sugandhi Dhoop",
    nameH: "धुप अगरबत्ति",
    brand: "multi brand",
    oldprice: "25.00",
    newprice: "20.00",
    qty: "10 Gram",
    discount: "20% off",
    img: [pj14],
  },
  {
    id: 15,
    name: "Singhada Aata",
    nameH: "सिंघारा आटा",
    brand: "Matardana",
    oldprice: "",
    newprice: "60.00",
    qty: "200 Gram",
    discount: "",
    img: [pj15],
  },
  {
    id: 16,
    name: "Kapoor",
    nameH: "कपूर",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "45.00",
    qty: "250 Gram",
    discount: "10% off",
    img: [pj16],
  },
  {
    id: 17,
    name: "Supari",
    nameH: "सुपारी",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "35.00",
    qty: "50 Gram",
    discount: "30% off",
    img: [pj17],
  },
  {
    id: 18,
    name: "Roli",
    nameH: "रॊलि",
    brand: "Matardana",
    oldprice: "6.00",
    newprice: "5.00",
    qty: "10 Gram",
    discount: "17% off",
    img: [pj18],
  },
  {
    id: 19,
    name: "Sindoor",
    nameH: "सिन्दूर",
    brand: "Matardana",
    oldprice: "7.00",
    newprice: "5.00",
    qty: "10 Gram",
    discount: "29% off",
    img: [pj19],
  },
  {
    id: 20,
    name: "Til Ka Tel",
    nameH: "तिल का तेल",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "45.00",
    qty: "200 Ml",
    discount: "10% off",
    img: [pj20],
  },
  {
    id: 21,
    name: "Gugul",
    nameH: "गुग्गुल",
    brand: "Matardana",
    oldprice: "50.00",
    newprice: "40.00",
    qty: "50 Gram",
    discount: "20% off",
    img: [pj21],
  },
  {
    id: 22,
    name: "Misri",
    nameH: "मिसरी",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "28.00",
    qty: "200 Gram",
    discount: "7% off",
    img: [pj22],
  },
  {
    id: 23,
    name: "Makundana",
    nameH: "मकुनदना",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "25.00",
    qty: "200 Gram",
    discount: "17% off",
    img: [pj23],
  },
  {
    id: 24,
    name: "Batasa",
    nameH: "बतशा",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "28.00",
    qty: "200 Gram",
    discount: "7% off",
    img: [pj24],
  },
  {
    id: 25,
    name: "Gandhak",
    nameH: "गन्धक",
    brand: "Matardana",
    oldprice: "160.00",
    newprice: "159.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [pj25],
  },
  {
    id: 26,
    name: "Humad Top Quality",
    nameH: "हुमाद",
    brand: "Matardana",
    oldprice: "70.00",
    newprice: "65.00",
    qty: "500 Gram",
    discount: "7% off",
    img: [pj26],
  },
  {
    id: 27,
    name: "Homelites Matchbox(Pack Of 5)",
    nameH: "होमलाइट्स माचिस",
    brand: "Homelites",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj27],
  },
  {
    id: 28,
    name: "Red Rose Premium Sticks",
    nameH: "",
    brand: "Matardana",
    oldprice: "20.00",
    newprice: "18.00",
    qty: "1 Piece",
    discount: "10% off",
    img: [pj28],
  },
  {
    id: 29,
    name: "Humad 2nd Quality",
    nameH: "हमद द्वितीय गुणवत्ता",
    brand: "Matardana",
    oldprice: "",
    newprice: "90.00",
    qty: "1 KG",
    discount: "",
    img: [pj29],
  },
  {
    id: 30,
    name: "Mysore Sandal Dhoop",
    nameH: "मैसूर सैंडल धुप",
    brand: "Mysore Sandal",
    oldprice: "",
    newprice: "30.00",
    qty: "1 Piece",
    discount: "",
    img: [pj30],
    available:"not"
  },
];

export const Medical = [
  {
    id: 1,
    name: "Stayfree Secure Regular Sanitary Pad (Regular Size 7 Pieces)",
    nameH: "स्टेफ्री सिक्योर कॉटनी सॉफ्ट कवर सैनिटरी पैड",
    brand: "Stayfree",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "1 Piece",
    discount: "3% off",
    img: [m1],
  },

  {
    id: 2,
    name: "Whisper Choice Extra Long Sanitary Pad (XL Size 6 Pieces)",
    nameH: "व्हिस्पर चॉइस एक्स्ट्रा लॉन्ग सैनिटरी पैड",
    brand: "Whisper",
    oldprice: "32.00",
    newprice: "30.00",
    qty: "1 Piece",
    discount: "6% off",
    img: [m2],
  },
  {
    id: 3,
    name: "Pro-Ease Go Sanitary Pad (XL Size Pack Of 6)",
    nameH: "प्रो-इज़ गो सेनेटरी पैड",
    brand: "Pro-Ease",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "1 Piece",
    discount: "3% off",
    img: [m3],
  },
  {
    id: 4,
    name: "Whisper Choice Aloe Cottony Soft Sanitary Pad(Size XL Pack Of 6)",
    nameH: "व्हिस्पर चॉइस एलो कॉटनी सॉफ्ट सेनेटरीपैड",
    brand: "Whisper",
    oldprice: "28.00",
    newprice: "26.00",
    qty: "1 Piece",
    discount: "7% off",
    img: [m4],
  },
  {
    id: 5,
    name: "Whisper Choice Aloe Cottony Soft Sanitary Pad(Size XL Pack Of 20)",
    nameH: "व्हिस्पर चॉइस एलो कॉटनी सॉफ्ट सेनेटरीपैड",
    brand: "Whisper",
    oldprice: "72.00",
    newprice: "67.00",
    qty: "1 Piece",
    discount: "7% off",
    img: [m5],
  },
  {
    id: 6,
    name: "Moov Pain Relief Cream",
    nameH: "मूव पेन रिलीफ",
    brand: "Moov",
    oldprice: "65.00",
    newprice: "63.00",
    qty: "15 Gram",
    discount: "3% off",
    img: [m6],
  },
  {
    id: 7,
    name: "Moov Pain Relief Spray",
    nameH: "मूव पेन रिलीफ स्प्रे",
    brand: "Moov",
    oldprice: "190.00",
    newprice: "171.00",
    qty: "50 Gram",
    discount: "10% off",
    img: [m7],
  },
  {
    id: 8,
    name: "Vicks Vaporub",
    nameH: "विक्स वेपो रब",
    brand: "Vicks",
    oldprice: "",
    newprice: "80.00",
    qty: "25 Gram",
    discount: "",
    img: [m8],
  },
  {
    id: 9,
    name: "Amrutanjan Advanced Pain Relief",
    nameH: "अमृतांजन पेन रिलीफ",
    brand: "Amrutanzan",
    oldprice: "",
    newprice: "350.00",
    qty: "50 Gram",
    discount: "",
    img: [m9],
  },
  {
    id: 10,
    name: "Zandu Balm",
    nameH: "जंडू बाम",
    brand: "Emami",
    oldprice: "",
    newprice: "38.00",
    qty: "8 Ml",
    discount: "",
    img: [m10],
  },
  {
    id: 11,
    name: "Cotton",
    nameH: "रुई",
    brand: "Matardana",
    oldprice: "30.00",
    newprice: "25.00",
    qty: "1 Piece",
    discount: "17% off",
    img: [m27],
  },
  {
    id: 12,
    name: "Dabur Pudin Hara - Active",
    nameH: "डाबर पुदीन हरा",
    brand: "Dabur",
    oldprice: "",
    newprice: "55.00",
    qty: "30 Ml",
    discount: "",
    img: [m28],
  },
  {
    id: 13,
    name: "Pudin Hara Tab",
    nameH: "पुदीन हरा गोली",
    brand: "Dabur",
    oldprice: "",
    newprice: "30.00",
    qty: "10 Piece",
    discount: "",
    img: [m29],
  },
  {
    id: 14,
    name: "Hicks Hixcrepe Bandage(10cm X 4m)4inch",
    nameH: "हिक्सक्रेप बैंडेज",
    brand: "Hicks",
    oldprice: "170.00",
    newprice: "120.00",
    qty: "1 Piece",
    discount: "29% off",
    img: [m30],
  },
  {
    id: 15,
    name: "HANSAPLAST Wash Proof Bandage (Set Of 4 )",
    nameH: "हंसापलास्ट",
    brand: "HANSAPLAST",
    oldprice: "10.00",
    newprice: "8.00",
    qty: "1 Piece",
    discount: "20% off",
    img: [m31],
  },
  {
    id:16 ,
    name: "Iodex Pain Balm - Multi-Purpose",
    nameH: "आयोडेक्स बाम",
    brand: "Iodex",
    oldprice: "",
    newprice: "75.00",
    qty: "16 Gram",
    discount: "",
    img: [m32],
  },
  {
    id:17 ,
    name: "Savlon",
    nameH: "सेवलॉन",
    brand: "johnson & johnson",
    oldprice: "",
    newprice: "77.00",
    qty: "200 Ml",
    discount: "",
    img: [m33],
  },
  {
    id:18 ,
    name: "Dettol Antiseptic Liquid",
    nameH: "डेटॉल एंटी सेप्टिक लिक्विड",
    brand: "Dettol ",
    oldprice: "",
    newprice: "105.60",
    qty: "250 Ml",
    discount: "",
    img: [m34],
  },
  {
    id:19 ,
    name: "Zandu Ultra Balm",
    nameH: "झंडू अल्ट्रा बाम",
    brand: "Emami",
    oldprice: "",
    newprice: "44.00",
    qty: "8 Ml",
    discount: "",
    img: [m35],
  },
  {
    id:20 ,
    name: "Vicks Cough Drops",
    nameH: "विक्स चॉकलेट",
    brand: "Vicks",
    oldprice: "",
    newprice: "3.00",
    qty: "3 Piece",
    discount: "",
    img: [m36],
  },
  {
    id:21 ,
    name: "Strepsils Warm Ginger & Lemon Lozenge",
    nameH: "स्ट्रेप्सिल्स वार्म अदरक और नींबू लोजेंज",
    brand: "Strepsil",
    oldprice: "4.00",
    newprice: "3.00",
    qty: "1 Piece",
    discount: "25% off",
    img: [m17],
  },
  {
    id:22 ,
    name: "Sat Isabgol",
    nameH: "सत ईसबगोल",
    brand: "Dabur",
    oldprice: "55.00",
    newprice: "50.00",
    qty: "50 Gram",
    discount: "9% off",
    img: [m18],
  },
  {
    id:23 ,
    name: "Patanjali Balm",
    nameH: "पतंजलि बाल्म",
    brand: "Patanjali",
    oldprice: "",
    newprice: "45.00",
    qty: "25 Gram",
    discount: "",
    img: [m19],
  },
  {
    id:24 ,
    name: "Cotton(Medical)",
    nameH: "कपास",
    brand: "Ghanshyam",
    oldprice: "45.00",
    newprice: "35.00",
    qty: "60 Gram",
    discount: "22% off",
    img: [m20],
  },
  {
    id:25 ,
    name: "Hansaplast Regular(Set Of 5)",
    nameH: "हंसापलास्ट",
    brand: "HANSAPLAST",
    oldprice: "10.00",
    newprice: "9.00",
    qty: "1 Piece",
    discount: "10% off",
    img: [m21],
  },
  {
    id:26 ,
    name: "Hicks Hixcrepe Bandage(15cm X 4m)6inch",
    nameH: "हिक्सक्रेप बैंडेज",
    brand: "Hicks",
    oldprice: "220.00",
    newprice: "180.00",
    qty: "1 Piece",
    discount: "18% off",
    img: [m22],
  },
  {
    id:27 ,
    name: "Electral ORS",
    nameH: "इलेक्ट्रॉल",
    brand: "FDC",
    oldprice: "19.74",
    newprice: "19.00",
    qty: "21.8 Gram",
    discount: "4% off",
    img: [m23],
  },
  {
    id:28 ,
    name: "ENO Orange(Set Of 2)",
    nameH: "ईनो ऑरेंज",
    brand: "Gsk",
    oldprice: "",
    newprice: "18.00",
    qty: "5 Gram",
    discount: "",
    img: [m24],
  },
  {
    id: 29,
    name: "ENO Lemon(Set Of 2)",
    nameH: "ईनो लेमन",
    brand: "Gsk",
    oldprice: "",
    newprice: "18.00",
    qty: "5 Gram",
    discount: "",
    img: [m25],
  },
  {
    id:30 ,
    name: "Boro Plus Antiseptic Cream",
    nameH: "बोरो प्लस",
    brand: "Emami",
    oldprice: "",
    newprice: "38.00",
    qty: "19 Ml",
    discount: "",
    img: [m26],
  },
  {
    id:31 ,
    name: "38.00",
    nameH: "वोलिनी दर्द निवारक स्प्रे",
    brand: "Volini",
    oldprice: "140.00",
    newprice: "130.00",
    qty: "40 Gram",
    discount: "7% off",
    img: [m11],
  },
  {
    id:32 ,
    name: "Volini Pain Relief Gel",
    nameH: "वोलिनी दर्द निवारक जेल",
    brand: "Volini",
    oldprice: "120.00",
    newprice: "115.00",
    qty: "30 Gram",
    discount: "4% off",
    img: [m12],
  },
  {
    id:33 ,
    name: "Hicks Digital Thermometer",
    nameH: "हिक्स डिजिटल थर्मामीटर",
    brand: "Hicks",
    oldprice: "249.00",
    newprice: "240.00",
    qty: "1 Piece",
    discount: "4% off",
    img: [m13],
  },
  {
    id:34 ,
    name: "Durex Air Condom(10 Count)",
    nameH: "ड्यूरेक्स एयर कंडोम",
    brand: "Durex",
    oldprice: "",
    newprice: "217.00",
    qty: "1 Piece",
    discount: "",
    img: [m14],
  },
  {
    id:35 ,
    name: "Durex Air Condom(3 Count)",
    nameH: "ड्यूरेक्स एयर कंडोम",
    brand: "Durex",
    oldprice: "",
    newprice: "72.00",
    qty: "1 Piece",
    discount: "",
    img: [m15],
  },
  {
    id:36 ,
    name: "Stayfree Secure Sanitary Pad(XL Size 20 Pieces)",
    nameH: "स्टेफ्री सिक्योर सैनिटरी पैड",
    brand: "Stayfree",
    oldprice: "",
    newprice: "115.00",
    qty: "1 Piece",
    discount: "",
    img: [m16],
    available:"not"
  },
];

export const Frozen = [
  {
    id: 1,
    name: "Green Peas(Frozen)",
    nameH: "हरी मटर",
    brand: "Pal Fresh",
    oldprice: "270.00",
    newprice: "170.00",
    qty: "1 KG",
    discount: "37% off",
    img: [fz1],
  },

  {
    id: 2,
    name: "Button Mushroom (Canned)",
    nameH: "गोल्डन क्राउन बटन मशरुम",
    brand: "multi brand",
    oldprice: "185.00",
    newprice: "155.00",
    qty: "800 Gram",
    discount: "16% off",
    img: [fz2],
  },
  {
    id: 3,
    name: "Baby Corn (Canned)",
    nameH: "बेबी कॉर्न",
    brand: "multi brand",
    oldprice: "140.00",
    newprice: "125.00",
    qty: "800 Gram",
    discount: "11% off",
    img: [fz3],
  },
  {
    id: 4,
    name: "Sweet Corn (Canned - Cream Style)",
    nameH: "कैंड स्वीट कॉर्न",
    brand: "multi brand",
    oldprice: "45.00",
    newprice: "42.00",
    qty: "450 Gram",
    discount: "7% off",
    img: [fz4],
  },

 
];

export const Essential = [
  {
    id: 1,
    name: "Dabur Hand Sanitizer",
    nameH: "डाबर हैंड सैनिटाइजर",
    brand: "Dabur",
    oldprice: "",
    newprice: "125.00",
    qty: "250 Ml",
    discount: "",
    img: [e1],
  },

  {
    id: 2,
    name: "Dazz Multisurface Disinfectant Spray",
    nameH: "डैज़ मल्टीसर्फेस डिसइंफेक्टेंट स्प्रे",
    brand: "multi brand",
    oldprice: "",
    newprice: "159.00",
    qty: "215 Ml",
    discount: "",
    img: [e2],
  },
  {
    id: 3,
    name: "Alife Neem-Aloevera Hand Sanitizer",
    nameH: "एलिफ़ नीम-एलोवेरा हैंड सैनिटाइज़र",
    brand: "Fortune",
    oldprice: "",
    newprice: "25.00",
    qty: "50 Ml",
    discount: "",
    img: [e3],
  },
  {
    id: 4,
    name: "Lifebuoy Germ Kill Spray",
    nameH: "लाइफबॉय जर्म किल स्प्रे",
    brand: "Lifebuoy",
    oldprice: "",
    newprice: "149.00",
    qty: "75 Ml",
    discount: "",
    img: [e4],
  }
  
];





export const Matardana=[
  {
      id: 1,
      name: "Lady Finger",
      nameH: "भिंडी",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "52.00",
      qty: "1 KG",
      discount: "13% off",
      img: [v1],
    },
    {
      id: 2,
      name: "Matar(Chhemi)",
      nameH: "मटर",
      brand: "Matardana",
      oldprice: "120.00",
      newprice: "95.00",
      qty: "1 KG",
      discount: "21% off",
      img: [v2],
    },
    {
      id: 3,
      name: "Pointed Gourd(Parwal Local)",
      nameH: "परवल",
      brand: "Matardana",
      oldprice: "80.00",
      newprice: "70.00",
      qty: "1 KG",
      discount: "13% off",
      img: [v3],
    },
    {
      id: 4,
      name: "Nenua",
      nameH: "नेनुआ",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "48.00",
      qty: "1 KG",
      discount: "20% off",
      img: [v4],
    },
    {
      id: 5,
      name: "Bhua (Ash Gourd)",
      nameH: "भुआ",
      brand: "Matardana",
      oldprice: "300.00",
      newprice: "280.00",
      qty: "4 KG",
      discount: "7% off",
      img: [v5],
    },
    {
      id: 6,
      name: "Amla (Indian Gooseberry)",
      nameH: "आंवला",
      brand: "Matardana",
      oldprice: "40.00",
      newprice: "30.00",
      qty: "500 Gram",
      discount: "25% off",
      img: [v6],
    },
    {
      id: 7,
      name: "Sem",
      nameH: "सेम",
      brand: "Matardana",
      oldprice: "80.00",
      newprice: "50.00",
      qty: "1 KG",
      discount: "38% off",
      img: [v7],
    },
    {
      id: 8,
      name: "Mustard Leaf ( Sarso Ka Saag)",
      nameH: "सरसों के साग",
      brand: "Matardana",
      oldprice: "40.00",
      newprice: "35.00",
      qty: "1 KG",
      discount: "13% off",
      img: [v8],
    },
    {
      id: 9,
      name: "Red Cabbage",
      nameH: "",
      brand: "Matardana",
      oldprice: "300.00",
      newprice: "240.00",
      qty: "1 KG",
      discount: "20% off",
      img: [v9],
    },
    {
      id: 10,
      name: "New Red Potato",
      nameH: "नया लाल आलू",
      brand: "Matardana",
      oldprice: "70.00",
      newprice: "44.00",
      qty: "1 KG",
      discount: "37% off",
      img: [v10],
    },
    {
      id: 11,
      name: "Kanda",
      nameH: "कंदा",
      brand: "Matardana",
      oldprice: "35.00",
      newprice: "25.00",
      qty: "500 Gram",
      discount: "29% off",
      img: [v11],
    },
    {
      id: 12,
      name: "Garlic",
      nameH: "लहसुन",
      brand: "Matardana",
      oldprice: "130.00",
      newprice: "115.00",
      qty: "1 KG",
      discount: "12% off",
      img: [v12],
    },
    {
      id: 13,
      name: "Salad Carrot",
      nameH: "सलाद का गाजर",
      brand: "Matardana",
      oldprice: "70.00",
      newprice: "40.00",
      qty: "1 KG",
      discount: "43% off",
      img: [v13],
    },
    {
      id: 14,
      name: "Radish",
      nameH: "मूली",
      brand: "Matardana",
      oldprice: "50.00",
      newprice: "30.00",
      qty: "1 KG",
      discount: "40% off",
      img: [v14],
    },
    {
      id: 15,
      name: "Brinjal",
      nameH: "बैगन",
      brand: "Matardana",
      oldprice: "70.00",
      newprice: "40.00",
      qty: "1 KG",
      discount: "43% off",
      img: [v15],
    },
    {
      id: 16,
      name: "Green Chili",
      nameH: "हरी मिर्च ",
      brand: "Matardana",
      oldprice: "12.00",
      newprice: "7.00",
      qty: "100 Gram",
      discount: "42% off",
      img: [v16],
    },
    {
      id: 17,
      name: "Cauliflower",
      nameH: "गोभी ",
      brand: "Matardana",
      oldprice: "80.00",
      newprice: "50.00",
      qty: "1 Piece",
      discount: "38% off",
      img: [v17],
    },
    {
      id: 18,
      name: "Cabbage",
      nameH: "पत्ता गोभी",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "35.00",
      qty: "1 KG",
      discount: "42% off",
      img: [v18],
    },
    {
      id: 19,
      name: "Lemon",
      nameH: "नींबू ",
      brand: "Matardana",
      oldprice: "15.00",
      newprice: "11.00",
      qty: "3 Piece",
      discount: "27% off",
      img: [v19],
    },
    {
      id: 20,
      name: "Pointed Gourd (Parwal)",
      nameH: "परवल",
      brand: "Matardana",
      oldprice: "80.00",
      newprice: "68.00",
      qty: "1 KG",
      discount: "15% off",
      img: [v20],
    },
    {
      id: 21,
      name: "Ginger (Adrak)",
      nameH: "अदरक",
      brand: "Matardana",
      oldprice: "12.00",
      newprice: "10.00",
      qty: "100 Gram",
      discount: "17% off",
      img: [v21],
    },
    {
      id: 22,
      name: "White Potato (Safed Aalu)",
      nameH: "सफेद आलू",
      brand: "Matardana",
      oldprice: "40.00",
      newprice: "33.00",
      qty: "1 KG",
      discount: "18% off",
      img: [v22],
    },
    {
      id: 23,
      name: "Red Potato",
      nameH: "लाल आलू",
      brand: "Matardana",
      oldprice: "40.00",
      newprice: "36.00",
      qty: "1 KG",
      discount: "10% off",
      img: [v23],
    },
    {
      id: 24,
      name: "Baby Potato",
      nameH: "बेबी पोटैटो / छोटा आलू",
      brand: "Matardana",
      oldprice: "18.00",
      newprice: "15.00",
      qty: "500 Gram",
      discount: "17% off",
      img: [v24],
    },
    {
      id: 25,
      name: "Beetroot",
      nameH: "चुकुन्दर",
      brand: "Matardana",
      oldprice: "15.00",
      newprice: "11.00",
      qty: "250 Gram",
      discount: "27% off",
      img: [v25],
    },
    {
      id: 26,
      name: "Cucumber",
      nameH: "खीरा",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "48.00",
      qty: "1 KG",
      discount: "20% off",
      img: [v26],
    },
    {
      id: 27,
      name: "Capsicum",
      nameH: "शिमला मिर्च",
      brand: "Matardana",
      oldprice: "50.00",
      newprice: "40.00",
      qty: "500 Gram",
      discount: "20% off",
      img: [v27],
    },
    {
      id: 28,
      name: "Mushroom",
      nameH: "मशरुम",
      brand: "Matardana",
      oldprice: "70.00",
      newprice: "60.00",
      qty: "200 Gram",
      discount: "14% off",
      img: [v28],
    },
    {
      id: 29,
      name: "Yellow Capsicum",
      nameH: "पीला शिमला मिर्च",
      brand: "Matardana",
      oldprice: "110.00",
      newprice: "85.00",
      qty: "250 Gram",
      discount: "23% off",
      img: [v29],
    },
    {
      id: 30,
      name: "Bitter Gourd (Karela)",
      nameH: "करेला",
      brand: "Matardana",
      oldprice: "30.00",
      newprice: "26.00",
      qty: "500 Gram",
      discount: "13% off",
      img: [v30],
    },
    {
      id: 31,
      name: "Mint Leaves (Pudina)",
      nameH: "पुदीना",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "45.00",
      qty: "100 Gram",
      discount: "25% off",
      img: [v31],
    },
    {
      id: 32,
      name: "Red Spinach",
      nameH: "लाल साग",
      brand: "Matardana",
      oldprice: "25.00",
      newprice: "20.00",
      qty: "500 Gram",
      discount: "20% off",
      img: [v32],
    },
    {
      id: 33,
      name: "Beans",
      nameH: "बीन्स",
      brand: "Matardana",
      oldprice: "30.00",
      newprice: "25.00",
      qty: "250 Gram",
      discount: "17% off",
      img: [v33],
    },
    {
      id: 34,
      name: "Boro",
      nameH: "बोरो",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "35.00",
      qty: "500 Gram",
      discount: "42% off",
      img: [v34],
    },
    {
      id: 35,
      name: "Raw Banana",
      nameH: "कच्चा केला",
      brand: "Matardana",
      oldprice: "30.00",
      newprice: "17.00",
      qty: "6 Piece",
      discount: "43% off",
      img: [v35],
    },
    {
      id: 36,
      name: "Kundri",
      nameH: "कुंदरी / कुन्द्रु",
      brand: "Matardana",
      oldprice: "20.00",
      newprice: "15.00",
      qty: "500 Gram",
      discount: "25% off",
      img: [v36],
    },
  
    {
      id: 37,
      name: "Tamarind (Imli)",
      nameH: "इमली",
      brand: "Matardana",
      oldprice: "15.00",
      newprice: "10.00",
      qty: "100 Gram",
      discount: "33% off",
      img: [v37],
    },
    {
      id: 38,
      name: "Arbi",
      nameH: "अरबी",
      brand: "Matardana",
      oldprice: "30.00",
      newprice: "27.00",
      qty: "500 Gram",
      discount: "10% off",
      img: [v38],
    },
  
    {
      id: 39,
      name: "Kohra",
      nameH: "कोंहरा / कोहड़ा",
      brand: "Matardana",
      oldprice: "25.00",
      newprice: "22.00",
      qty: "500 Gram",
      discount: "12% off",
      img: [v39],
    },
  
    {
      id: 40,
      name: "Coriander (Hara Dhaniya)",
      nameH: "हरा धनिया",
      brand: "Matardana",
      oldprice: "16.00",
      newprice: "12.00",
      qty: "100 Gram",
      discount: "25% off",
      img: [v40],
    },
    {
      id: 41,
      name: "Lauki (Bottle Gourds)",
      nameH: "लौकी",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "35.00",
      qty: "1 KG",
      discount: "42% off",
      img: [v41],
    },
    {
      id: 42,
      name: "Pink Onion",
      nameH: "प्याज",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "35.00",
      qty: "1 KG",
      discount: "42% off",
      img: [v42],
    },
    {
      id: 43,
      name: "Curry Leaves Twig",
      nameH: "करी पत्ता",
      brand: "Matardana",
      oldprice: "",
      newprice: "5.00",
      qty: "5 Piece",
      discount: "",
      img: [v43],
    },
    {
      id: 44,
      name: "Oal (Yam)",
      nameH: "ओल",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "50.00",
      qty: "1 Kg",
      discount: "17% off",
      img: [v44],
    },
    {
      id: 45,
      name: "Tomato",
      nameH: "टमाटर",
      brand: "Matardana",
      oldprice: "90.00",
      newprice: "80.00",
      qty: "1 KG",
      discount: "11% off",
      img: [v45],
    },
    {
      id: 46,
      name: "Baby Corn",
      nameH: "बेबी कॉर्न",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "55.00",
      qty: "200 Gram",
      discount: "8% off",
      img: [v46],
    },
  
    {
      id: 47,
      name: "Raw Papaya",
      nameH: "कच्चा पपीता",
      brand: "Matardana",
      oldprice: "25.00",
      newprice: "19.00",
      qty: "500 Gram",
      discount: "24% off",
      img: [v47],
    },
    {
      id: 48,
      name: "New Potato",
      nameH: "नया आलू",
      brand: "Matardana",
      oldprice: "65.00",
      newprice: "42.00",
      qty: "1 KG",
      discount: "35% off",
      img: [v48],
    },
    {
      id: 49,
      name: "Broccoli",
      nameH: "ब्रोकली",
      brand: "Matardana",
      oldprice: "175.00",
      newprice: "165.00",
      qty: "500 Gram",
      discount: "6% off",
      img: [v49],
    },
    {
      id: 50,
      name: "Spinach (Palak)",
      nameH: "पालक",
      brand: "Matardana",
      oldprice: "25.00",
      newprice: "18.00",
      qty: "500 Gram",
      discount: "28% off",
      img: [v50],
    },
    {
      id: 51,
      name: "Methi Patta/Saag",
      nameH: "मेथी",
      brand: "Matardana",
      oldprice: "20.00",
      newprice: "14.00",
      qty: "250 Gram",
      discount: "30% off",
      img: [v51],
    },
    {
      id: 52,
      name: "Pealed Jackfruit(Kathal)",
      nameH: "छिले हुए कटहल",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "45.00",
      qty: "1 KG",
      discount: "25% off",
      img: [v52],
      available: "not",
    },
    {
      id: 53,
      name: "Red Onion",
      nameH: "लाल प्याज",
      brand: "Matardana",
      oldprice: "45.00",
      newprice: "34.00",
      qty: "1 kG",
      discount: "24% off",
      img: [v53],
      available: "not",
    },
    {
      id: 54,
      name: "Ridge Gourd (Tori / Turai)",
      nameH: "तोरई",
      brand: "Matardana",
      oldprice: "30.00",
      newprice: "25.00",
      qty: "500 Gram",
      discount: "17% off",
      img: [v59],
      available: "not",
    },
    {
      id: 55,
      name: "Arbi Leaf ( Kopal)",
      nameH: "अरवी कोपल / अरबी पत्ता",
      brand: "Matardana",
      oldprice: "25.00",
      newprice: "22.00",
      qty: "250 Gram",
      discount: "12% off",
      img: [v54],
      available: "not",
    },
    {
      id: 56,
      name: "Chathail",
      nameH: "चटैल",
      brand: "Matardana",
      oldprice: "25.00",
      newprice: "23.00",
      qty: "500 Gram",
      discount: "8% off",
      img: [v55],
      available: "not",
    },
    {
      id: 57,
      name: "Whole Jackfruit (Kathal)",
      nameH: "कटहल",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "40.00",
      qty: "1 KG",
      discount: "33% off",
      img: [v60],
      available: "not",
    },
    {
      id: 58,
      name: "Soya Leaf",
      nameH: "सोया पत्ता",
      brand: "Matardana",
      oldprice: "20.00",
      newprice: "10.00",
      qty: "50 Gram",
      discount: "50% off",
      img: [v56],
      available: "not",
    },
    {
      id: 59,
      name: "Brinjal (Round)",
      nameH: "गोल बैगन",
      brand: "Matardana",
      oldprice: "70.00",
      newprice: "60.00",
      qty: "1 KG",
      discount: "14% off",
      img: [v57],
      available: "not",
    },
    {
      id: 60,
      name: "Banana Battisa",
      nameH: "कच्चा केला बत्तीसा",
      brand: "Matardana",
      oldprice: "90.00",
      newprice: "65.00",
      qty: "12 Piece",
      discount: "28% off",
      img: [v58],
      available: "not",
    },
    {
      id: 61,
      name: "Aalu Bukhara (Plum)",
      nameH: "आलू बुखारा (पल्म)",
      brand: "Matardana",
      oldprice: "400.00",
      newprice: "248.00",
      qty: "750 Gram",
      discount: "38% off",
      img: [f1],
    },
    {
      id: 62,
      name: "Shimla Apple",
      nameH: "शिमला एप्पल",
      brand: "Matardana",
      oldprice: "65.00",
      newprice: "58.00",
      qty: "500 Gram",
      discount: "11% off",
      img: [f2],
    },
    {
      id: 63,
      name: "Singhara Fruit (kuchha)",
      nameH: "सिंघाड़ा फल (कच्चा)",
      brand: "Matardana",
      oldprice: "100.00",
      newprice: "75.00",
      qty: "1 KG",
      discount: "25% off",
      img: [f3],
    },
    {
      id: 64,
      name: "Apple Imported",
      nameH: "इम्पोर्टेड सेब",
      brand: "Matardana",
      oldprice: "150.00",
      newprice: "116.00",
      qty: "500 Gram",
      discount: "23% off",
      img: [f4],
    },
    {
      id: 65,
      name: "Apple Kashmir",
      nameH: "सेब",
      brand: "Matardana",
      oldprice: "200.00",
      newprice: "150.00",
      qty: "1 KG",
      discount: "25% off",
      img: [f5],
    },
    {
      id: 66,
      name: "Pineapple(Medium Size)",
      nameH: "अनानास",
      brand: "Matardana",
      oldprice: "90.00",
      newprice: "65.00",
      qty: "1 Piece",
      discount: "28% off",
      img: [f6],
    },
    {
      id: 67,
      name: "Coconut(Medium)",
      nameH: "नारियल",
      brand: "Matardana",
      oldprice: "50.00",
      newprice: "35.00",
      qty: "1 Piece",
      discount: "30% off",
      img: [f7],
    },
    {
      id: 68,
      name: "Papaya",
      nameH: "पपीता",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "42.00",
      qty: "1 KG",
      discount: "30% off",
      img: [f8],
    },
    {
      id: 69,
      name: "Pomegranate (Medium Size Anar)",
      nameH: "अनार",
      brand: "Matardana",
      oldprice: "190.00",
      newprice: "170.00",
      qty: "1 KG",
      discount: "11% off",
      img: [f9],
    },
    {
      id: 70,
      name: "Orange",
      nameH: "संतरा",
      brand: "Matardana",
      oldprice: "75.00",
      newprice: "48.00",
      qty: "1 KG",
      discount: "36% off",
      img: [f10],
    },
    {
      id: 71,
      name: "Mosambi",
      nameH: "मौसम्बी",
      brand: "Matardana",
      oldprice: "100.00",
      newprice: "65.00",
      qty: "1 KG",
      discount: "35% off",
      img: [f11],
    },
    {
      id: 72,
      name: "Kiwi",
      nameH: "कीवी",
      brand: "Matardana",
      oldprice: "130.00",
      newprice: "105.00",
      qty: "3 Piece",
      discount: "19% off",
      img: [f12],
    },
    {
      id: 73,
      name: "Banana Chinia(Medium Size)",
      nameH: "चिनिया केला",
      brand: "Matardana",
      oldprice: "28.00",
      newprice: "24.00",
      qty: "6 Piece",
      discount: "14% off",
      img: [f13],
    },
    {
      id: 74,
      name: "Singapuri Banana",
      nameH: "सिंगापुरी केला",
      brand: "Matardana",
      oldprice: "160.00",
      newprice: "105.00",
      qty: "24 Piece",
      discount: "34% off",
      img: [f14],
    },
    {
      id: 75,
      name: "Pealed Pineapple (Medium Size)",
      nameH: "छीला हुआ अनानास",
      brand: "Matardana",
      oldprice: "100.00",
      newprice: "70.00",
      qty: "1 Piece",
      discount: "30% off",
      img: [f15],
    },
    {
      id: 76,
      name: "Pear (Nashpati)",
      nameH: "नाशपाती",
      brand: "Matardana",
      oldprice: "80.00",
      newprice: "75.00",
      qty: "500 Gram",
      discount: "6% off",
      img: [f16],
    },
    {
      id: 77,
      name: "Tender Coconut(Big)",
      nameH: "कच्चा नारियल (बड़ा)",
      brand: "Matardana",
      oldprice: "80.00",
      newprice: "70.00",
      qty: "1 Piece",
      discount: "13% off",
      img: [f17],
    },
    {
      id: 78,
      name: "Tender Coconut(Small)",
      nameH: "कच्चा नारियल (छोटा)",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "55.00",
      qty: "1 Piece",
      discount: "8% off",
      img: [f18],
    },
    {
      id: 79,
      name: "Sweet Tamarind",
      nameH: "मीठी इमली",
      brand: "multi brand",
      oldprice: "250.00",
      newprice: "230.00",
      qty: "250 Gram",
      discount: "8% off",
      img: [f19],
    },
    {
      id: 80,
      name: "Cherry",
      nameH: "चेरी",
      brand: "Matardana",
      oldprice: "450.00",
      newprice: "400.00",
      qty: "500 Gram",
      discount: "11% off",
      img: [f20],
    },
    {
      id: 81,
      name: "Guava",
      nameH: "अमरुद",
      brand: "Matardana",
      oldprice: "75.00",
      newprice: "57.00",
      qty: "500 Gram",
      discount: "24% off",
      img: [f21],
    },
    {
      id: 82,
      name: "Apple Himachal",
      nameH: "हिमाचल का सेब",
      brand: "Matardana",
      oldprice: "75.00",
      newprice: "60.00",
      qty: "500 Gram",
      discount: "20% off",
      img: [f22],
    },
    {
      id: 83,
      name: "Ghagra Nimbu",
      nameH: "गगरा निम्बू",
      brand: "Matardana",
      oldprice: "50.00",
      newprice: "35.00",
      qty: "1 Piece",
      discount: "30% off",
      img: [f23],
    },
    {
      id: 84,
      name: "Kinnow",
      nameH: "माल्टा",
      brand: "Matardana",
      oldprice: "75.00",
      newprice: "64.00",
      qty: "500 Gram",
      discount: "15% off",
      img: [f24],
      available: "not",
    },
    {
      id: 85,
      name: "Sweet Potato",
      nameH: "शकरकंद",
      brand: "Matardana",
      oldprice: "40.00",
      newprice: "25.00",
      qty: "500 Gram",
      discount: "38% off",
      img: [f25],
    },
    {
      id: 86,
      name: "Grapes",
      nameH: "अंगूर",
      brand: "Matardana",
      oldprice: "100.00",
      newprice: "90.00",
      qty: "500 Gram",
      discount: "10% off",
      img: [f26],
      available: "not",
    },
    {
      id: 87,
      name: "Pomegranate (Big Size Anar)",
      nameH: "अनार",
      brand: "Matardana",
      oldprice: "110.00",
      newprice: "95.00",
      qty: "500 Gram",
      discount: "14% off",
      img: [f27],
      available: "not",
    },
  
    {
      id: 88,
      name: "Coconut(Big)",
      nameH: "नारियल",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "50.00",
      qty: "1 Piece",
      discount: "17% off",
      img: [f28],
      available: "not",
    },
    {
      id: 89,
      name: "Black Grapes",
      nameH: "काला अंगूर",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "40.00",
      qty: "250 Gram",
      discount: "33% off",
      img: [f29],
      available: "not",
    },
    {
      id: 90,
      name: "Custard Apple (Sharifa)",
      nameH: "शरीफा",
      brand: "Matardana",
      oldprice: "60.00",
      newprice: "50.00",
      qty: "250 Gram",
      discount: "17% off",
      img: [f30],
      available: "not",
    },
    {
      id: 91,
      name: "Dragon Fruit",
      nameH: "ड्रैगन फल",
      brand: "Matardana",
      oldprice: "350.00",
      newprice: "300.00",
      qty: "3 Piece",
      discount: "14% off",
      img: [f31],
      available: "not",
    },
    {
      id: 92,
      name: "Star Fruits",
      nameH: "स्टार फल",
      brand: "Matardana",
      oldprice: "50.00",
      newprice: "40.00",
      qty: "200 Gram",
      discount: "20% off",
      img: [f32],
      available: "not",
    },
    {
      id: 93,
      name: "Avocado",
      nameH: "एवाकाडो",
      brand: "Matardana",
      oldprice: "100.00",
      newprice: "90.00",
      qty: "250 Gram",
      discount: "10% off",
      img: [f33],
      available: "not",
    },
    {
      id: 94,
      name: "Strawberry",
      nameH: "स्ट्रॉबेरी",
      brand: "Matardana",
      oldprice: "250.00",
      newprice: "240.00",
      qty: "200 Gram",
      discount: "4% off",
      img: [f34],
      available: "not",
    },
    {
      id: 95,
      name: "Red Grapes",
      nameH: "लाल अंगूर",
      brand: "Matardana",
      oldprice: "240.00",
      newprice: "190.00",
      qty: "500 Gram",
      discount: "21% off",
      img: [f35],
      available: "not",
    },
  
    {
      id: 96,
      name: "Apple Washington",
      nameH: "वाशिंगटन का सेब",
      brand: "Matardana",
      oldprice: "150.00",
      newprice: "133.00",
      qty: "500 Gram",
      discount: "11% off",
      img: [f36],
      available: "not",
    },
    {
      id: 97,
      name: "Dal Badi",
      nameH: "दाल बड़ी",
      brand: "Matardana",
      oldprice: "",
      newprice: "40.00",
      qty: "200 Gram",
      discount: "",
      img: [g3],
    },
    {
      id: 98,
      name: "Makhana (Top Quality)",
      nameH: "मखाना",
      brand: "Matardana",
      oldprice: "210.00",
      newprice: "185.00",
      qty: "250 Gram",
      discount: "12% off",
      img: [g4],
    },
    {
      id: 99,
      name: "Bhua Badi",
      nameH: "भुआ बड़ी",
      brand: "Matardana",
      oldprice: "",
      newprice: "100.00",
      qty: "500 Gram",
      discount: "",
      img: [g15],
    },
    {
      id: 100,
      name: "Kaju",
      nameH: "काजू",
      brand: "Matardana",
      oldprice: "270.00",
      newprice: "263.00",
      qty: "250 Gram",
      discount: "3% off",
      img: [g28],
    },
   
]

export const Everest=[

  {
    id: 1,
    name: "Everest Garam Masala",
    nameH: "एवरेस्ट गरम मसाला",
    brand: "Everest",
    oldprice: "78.00",
    newprice: "76.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g5],
  },
  {
    id: 2,
    name: "Everest Amchur",
    nameH: "अमचूर",
    brand: "Everest",
    oldprice: "80.00",
    newprice: "75.00",
    qty: "100 Gram",
    discount: "6% off",
    img: [g6],
  },
  {
    id: 3,
    name: "Everest Haldi Powder",
    nameH: "हल्दी पाउडर",
    brand: "Everest",
    oldprice: "31.00",
    newprice: "30.00",
    qty: "100 Gram",
    discount: "3%  off",
    img: [g7],
  },
  {
    id: 4,
    name: "Everest Dhaniya Powder",
    nameH: "धनिया पाउडर",
    brand: "Everest",
    oldprice: "35.00",
    newprice: "32.00",
    qty: "100 Gram",
    discount: "9% off",
    img: [g8],
  },
  {
    id: 5,
    name: "Everest Black Pepper Powder",
    nameH: "गोलकी पाउडर",
    brand: "Everest",
    oldprice: "67.00",
    newprice: "66.00",
    qty: "50 Gram",
    discount: "1% off",
    img: [g9],
  },
  {
    id: 6,
    name: "Everest Kasuri Methi",
    nameH: "कश्तुरी मेथी",
    brand: "Everest",
    oldprice: "47.00",
    newprice: "46.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [g10],
  },
  {
    id: 7,
    name: "Everest Biryani Masala",
    nameH: "बिरयानी मसाला",
    brand: "Everest",
    oldprice: "70.00",
    newprice: "68.00",
    qty: "50 Gram",
    discount: "3% off",
    img: [g11],
  },
  {
    id: 8,
    name: "Everest Chaat Masala",
    nameH: "चाट मसाला",
    brand: "Everest",
    oldprice: "62.00",
    newprice: "61.00",
    qty: "100 Gram",
    discount: "2% off",
    img: [g12],
  },
  {
    id: 9,
    name: "Everest Meat Masala",
    nameH: "मीट मसाला",
    brand: "Everest",
    oldprice: "72.00",
    newprice: "71.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g13],
  },
  {
    id: 10,
    name: "Everest Pav Bhaji Masala",
    nameH: "पावभाजी मसाला",
    brand: "Everest",
    oldprice: "40.00",
    newprice: "36.00",
    qty: "50 Gram",
    discount: "10% off",
    img: [g14],
  },
  {
    id:11,
    name: "Everest Kasuri Methi",
    nameH: "कश्तुरी मेथी",
    brand: "Everest",
    oldprice: "47.00",
    newprice: "46.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [img60],
  },
  {
    id: 12,
    name: "MDH Kasuri Methi",
    nameH: "एमडीएच कस्तूरी मैथि",
    brand: "Everest",
    oldprice: "46.00",
    newprice: "45.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [g38],
  },
 
]

export const Fortune=[
  {
    id: 1,
    name: "Fortune Pure & Hygienic Sulphurless Process Sugar",
    nameH: "फॉर्च्यून शुद्ध और स्वच्छ सल्फर रहित चीनी",
    brand: "Fortune",
    oldprice: "60.00 ",
    newprice: "59.00",
    qty: "1 KG",
    discount: "2% off",
    img: [g2],
  },
  {
    id: 2,
    name: "Alife Neem-Aloevera Hand Sanitizer",
    nameH: "एलिफ़ नीम-एलोवेरा हैंड सैनिटाइज़र",
    brand: "Fortune",
    oldprice: "",
    newprice: "25.00",
    qty: "50 Ml",
    discount: "",
    img: [e3],
  },
  {
    id: 3,
    name: "Fortune Soya Chunks(Free 50gram Mini Soya Chunk)",
    nameH: "फॉर्च्यून सोया चंक्स",
    brand: "Fortune",
    oldprice: "",
    newprice: "45.00",
    qty: "200 Gram",
    discount: "",
    img: [s96],
  },
  {
    id: 4,
    name: "Fortune Atta",
    nameH: "फॉर्च्यून आटा",
    brand: "Fortune",
    oldprice: "195.00",
    newprice: "170.00",
    qty: "5 KG",
    discount: "13% off",
    img: [g93],
  },
  {    id: 5,
    name: "Fortune Rice Bran Refined Oil",
    nameH: "फॉर्च्यून राइस ब्रान रिफाइंड तेल",
    brand: "Fortune",
    oldprice: "205.00",
    newprice: "200.00",
    qty: "1 Ltr",
    discount: "2% off",
    img: [g102],
  },
  {
    id: 6,
    name: "Fortune Refine Soyabean Oil",
    nameH: "फॉर्च्यून सोयाबीन तेल",
    brand: "Fortune",
    oldprice: "190.00",
    newprice: "185.00",
    qty: "1 Ltr",
    discount: "3% off",
    img: [g103],
  },
]

export const Cycle=[
  {
    id: 1,
    name: "Cycle Rhythm Amber Agarbattis",
    nameH: "साइकिल एम्बर अगरबत्ती",
    brand: "Cycle",
    oldprice: "",
    newprice: "10.00",
    qty: "16 Gram",
    discount: "",
    img: [pj1],
  },

  {
    id: 2,
    name: "Cycle Heritage Radiant Rose Agarbattis",
    nameH: "साइकिल हेरिटेज रेडियंट रोज अगरबत्तिस",
    brand: "Cycle",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj2],
  },
  {
    id: 3,
    name: "Cycle Sandalum Agarbattis",
    nameH: "साइकिल चंदन अगरबत्ती",
    brand: "Cycle",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj3],
  },
  {
    id: 4,
    name: "Cycle Heritage Chandanam Agarbattis",
    nameH: "साइकिल हेरिटेज चंदनम अगरबत्ती",
    brand: "Cycle",
    oldprice: "",
    newprice: "10.00",
    qty: "1 Piece",
    discount: "",
    img: [pj4],
  }, 
]

export const Kissan=[
  {
    id: 1,
    name: "Kissan Chotu Fresh Tomato Ketchup",
    nameH: "किसान छोटू ताजा टमाटर केचप",
    brand: "Kissan",
    oldprice: "",
    newprice: "15.00",
    qty: "130 Gram",
    discount: "",
    img: [s34],
  },
  {
    id: 2,
    name: "Tomato Ketchup",
    nameH: "टमाटर का कैच अप",
    brand: "Kissan",
    oldprice: "65.00",
    newprice: "60.00",
    qty: "200 Gram",
    discount: "8% off",
    img: [s35],
  },
  {
    id: 3,
    name: "Kissan Professional Sauce Dip",
    nameH: "किसान प्रोफेशनल सॉस डीप",
    brand: "Kissan",
    oldprice: "85.00",
    newprice: "82.00",
    qty: "930 Gram",
    discount: "4% off",
    img: [s58],
  },
 
]

export const Dabur=[
  {
    id: 1,
    name: "Hajmola Regular (120N)",
    nameH: "",
    brand: "Dabur",
    oldprice: "45.00",
    newprice: "44.00",
    qty: "1 Piece",
    discount: "2% off",
    img: [s17],
  },
  {
    id: 2,
    name: "Hajmola Imli (50N)",
    nameH: "हाजमोला इमली",
    brand: "Dabur",
    oldprice: "",
    newprice: "20.00",
    qty: "1 Piece",
    discount: "",
    img: [s29],
  },
  {
    id: 3,
    name: "Hajmola Regular (50N)",
    nameH: "हाजमोला",
    brand: "Dabur",
    oldprice: "",
    newprice: "20.00",
    qty: "1 Piece",
    discount: "",
    img: [s30],
  },
  {
    id: 4,
    name: "Dabar Glucon D Instant Energy Regular Energy Drink",
    nameH: "ग्लुकोन डी एनर्जी ड्रिंक",
    brand: "Dabur",
    oldprice: "",
    newprice: "30.00",
    qty: "125 Gram",
    discount: "",
    img: [s79],
  },
  {
    id: 5,
    name: "Odonil Smile Air Freshener",
    nameH: "ओडोनिल स्माइल",
    brand: "Dabur",
    oldprice: "",
    newprice: "50.00",
    qty: "1 Piece",
    discount: "",
    img: [h1],
  },
  {
    id: 6,
    name: "Odonil",
    nameH: "ओडोनिल",
    brand: "Dabur",
    oldprice: "141.00",
    newprice: "136.00",
    qty: "200 Gram",
    discount: "4% off",
    img: [h38],
  },
  {
    id: 7,
    name: "Dabur Pudin Hara - Active",
    nameH: "डाबर पुदीन हरा",
    brand: "Dabur",
    oldprice: "",
    newprice: "55.00",
    qty: "30 Ml",
    discount: "",
    img: [m28],
  },
  {
    id: 8,
    name: "Pudin Hara Tab",
    nameH: "पुदीन हरा गोली",
    brand: "Dabur",
    oldprice: "",
    newprice: "30.00",
    qty: "10 Piece",
    discount: "",
    img: [m29],
  },
  {
    id:9 ,
    name: "Sat Isabgol",
    nameH: "सत ईसबगोल",
    brand: "Dabur",
    oldprice: "55.00",
    newprice: "50.00",
    qty: "50 Gram",
    discount: "9% off",
    img: [m18],
  },
  {
    id: 10,
    name: "Dabur Hand Sanitizer",
    nameH: "डाबर हैंड सैनिटाइजर",
    brand: "Dabur",
    oldprice: "",
    newprice: "125.00",
    qty: "250 Ml",
    discount: "",
    img: [e1],
  },
]

export const Tata=[

  {
    id: 1,
    name: "Tata Salt",
    nameH: "नमक",
    brand: "Tata",
    oldprice: "21.00",
    newprice: "20.00",
    qty: "1 KG",
    discount: "5% off",
    img: [g61],
  },
  {
    id: 2,
    name: "Tata Tea Gold",
    nameH: "टाटा चाय गोल्ड",
    brand: "Tata",
    oldprice: "125.00",
    newprice: "123.00",
    qty: "250 Gram",
    discount: "2% off",
    img: [g62],
  },
  

]

export const Maggi=[
  {
    id: 1,
    name: "Maggie Magic Masala",
    nameH: "मैगी मैजिक मसाला",
    brand: "Maggi",
    oldprice: "",
    newprice: "10.00",
    qty: "6 Gram",
    discount: "",
    img: [g51],
  },
  {
    id: 2,
    name: "Tomato Sauce",
    nameH: "टमाटर का सौस",
    brand: "Maggi",
    oldprice: "65.00",
    newprice: "60.00",
    qty: "200 Gram",
    discount: "8% off",
    img: [s36],
  },
  {
    id: 3,
    name: "Pichkoo Tomato Sauce",
    nameH: "पिचकू टमाटर सौस",
    brand: "Maggi",
    oldprice: "",
    newprice: "15.00",
    qty: "90 Gram",
    discount: "",
    img: [s116],
    available: "not",
  },
]

export const Weikfield=[
  {
    id: 1,
    name: "Weikfield Baking Powder",
    nameH: "बेकिंग पाउडर",
    brand: "Weikfield",
    oldprice: "30.00",
    newprice: "29.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g42],
  },
  {
    id: 2,
    name: "Weikfield Corn Flour",
    nameH: "वेइकफील्ड कॉर्न फ्लोर",
    brand: "Weikfield",
    oldprice: "27.00",
    newprice: "26.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [g99],
  },
  {
    id: 3,
    name: "WeikFIELD Custard Powder (Vanilla Flavour)",
    nameH: "वेकफील्ड कस्टर्ड पाउडर",
    brand: "Weikfield",
    oldprice: "37.00",
    newprice: "36.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [s15],
  },
  {
    id: 4,
    name: "WeikFIELD Red Chilli Sauce",
    nameH: "वीइक्फेल्ड रेड चिली सॉस",
    brand: "Weikfield",
    oldprice: "90.00",
    newprice: "80.00",
    qty: "630 Gram",
    discount: "11% off",
    img: [s38],
  },
  {
    id:5,
    name: "Weikfield Coca Powder",
    nameH: "वेकफील्ड कोका पाउडर",
    brand: "Weikfield",
    oldprice: "140.00",
    newprice: "136.00",
    qty: "50 Gram",
    discount: "3% off",
    img: [s71],
  },
  {
    id: 6,
    name: "Weikfield Drinking Chocolate",
    nameH: "वेकफील्ड ड्रिंकिंग चॉकलेट",
    brand: "Weikfield",
    oldprice: "65.00",
    newprice: "60.00",
    qty: "100 Gram",
    discount: "8% off",
    img: [s72],
  },
]

export const Chings=[
  {
    id: 1,
    name: "Chings Secret Veg Manchurian Masala",
    nameH: "चिंग्स सीक्रेट वेज मंचूरियन मसाला",
    brand: "Chings",
    oldprice: "",
    newprice: "10.00",
    qty: "20 Gram",
    discount: "",
    img: [g39],
  },
  {
    id: 2,
    name: "Chings Schezwan Fried Rice Masala",
    nameH: "चिंग्स सचेज़वान फ्राइड राइस मसाला",
    brand: "Chings",
    oldprice: "",
    newprice: "10.00",
    qty: "20 Gram",
    discount: "",
    img: [g49],
  },
  {
    id: 3,
    name: "Schezwan Stir Fry Sauce",
    nameH: "शेजवान सौस",
    brand: "Chings",
    oldprice: "85.00",
    newprice: "80.00",
    qty: "250 Gram",
    discount: "6% off",
    img: [s37],
  },
  {
    id: 4,
    name: "Chings Dark Soya Sauce",
    nameH: "सोया सौस",
    brand: "Chings",
    oldprice: "",
    newprice: "20.00",
    qty: "90 Gram",
    discount: "",
    img: [s44],
  },
  {
    id: 5,
    name: "Chings Secret Red Chilli Sauces",
    nameH: "लाल मिर्च सौस",
    brand: "Chings",
    oldprice: "",
    newprice: "20.00",
    qty: "90 Gram",
    discount: "",
    img: [s47],
  },
  {
    id: 6,
    name: "Chings Veg Hakka Instant Noodle",
    nameH: "चिंग्स वेज हक्का इंस्टा नूडल",
    brand: "Chings",
    oldprice: "30.00",
    newprice: "28.00",
    qty: "150 Gram",
    discount: "7% off",
    img: [s51],
  },
  {
    id: 7,
    name: "Chings Secret Tomato With Croutons Soup",
    nameH: "चिंग सीक्रेट टोमेटो क्रोटोन्स सूप",
    brand: "Chings",
    oldprice: "",
    newprice: "10.00",
    qty: "16 Gram",
    discount: "",
    img: [s74],
  },

  {
    id: 8,
    name: "Chings Secret Schezwan Instant Noodle",
    nameH: "चिंग्स सीक्रेट शेजवान इंस्टेंट नूडल",
    brand: "Chings",
    oldprice: "60.00",
    newprice: "58.00",
    qty: "240 Gram",
    discount: "3% off",
    img: [s108],
  },
  {
    id: 9,
    name: "Green Chilli Sauce",
    nameH: "हरा मिर्च सौस",
    brand: "Chings",
    oldprice: "70.00",
    newprice: "69.00",
    qty: "680 Gram",
    discount: "1% off",
    img: [s113],
    available: "not",
  },
]

export const Tops=[
  {
    id: 1,
    name: "Tops Premium Red Chilli Red Sauce",
    nameH: "टॉप प्रीमियम रेड चिली रेड सॉस",
    brand: "Tops",
    oldprice: "",
    newprice: "70.00",
    qty: "650 Gram",
    discount: "",
    img: [s45],
  },
]

export const Vim=[
  {
    id: 1,
    name: "Vim Dishwash Bar - Lemon",
    nameH: "विम डिशवाश बार - नींबू",
    brand: "Vim",
    oldprice: "",
    newprice: "5.00",
    qty: "85 Gram",
    discount: "",
    img: [h8],
  },
  {
    id: 2,
    name: "Vim Liquid Dishwash Liquid - Gel Lemon",
    nameH: "विम तरल डिशवॉश तरल - जेल नींबू",
    brand: "Vim",
    oldprice: "",
    newprice: "45.00",
    qty: "250 Ml",
    discount: "%off",
    img: [h19],
  },
  {
    id: 3,
    name: "Vim Bar With Power Of Lemon",
    nameH: "नींबू की शक्ति के साथ विम बार",
    brand: "Vim",
    oldprice: "",
    newprice: "28.00",
    qty: "250 Gram",
    discount: "",
    img: [h36],
  },

]

export const SurfExcel=[
  {
    id: 1,
    name: "Surf Excel Easy Wash Liquid",
    nameH: "सर्फ एक्सेल इज़ी वॉश लिक्विड",
    brand: "Surf Excel",
    oldprice: "",
    newprice: "170.00",
    qty: "1 Ltr",
    discount: "",
    img: [h6],
  },
  {
    id: 2,
    name: "Surf Excel Easy Wash",
    nameH: "सर्फ एक्सेल इजी वाश डिटर्जेंट पाउडर",
    brand: "Surf Excel",
    oldprice: "55.00",
    newprice: "53.00",
    qty: "500 Gram",
    discount: "4% off",
    img: [h11],
  },
  {
    id: 3,
    name: "Surf Excel Stain Eraser Detergent Bar",
    nameH: "सर्फ़ एकसेल स्टैन इरेज़र डिटर्जेंट बार",
    brand: "Surf Excel",
    oldprice: "",
    newprice: "16.00",
    qty: "150 Gram",
    discount: "",
    img: [h43],
  },
]

export const Ghadi=[
  {
    id: 1,
    name: "Ghadi Mahashaktishali Formula Detergent Powder",
    nameH: "घडी महाशक्तिशाली फार्मूला डिटर्जेंट पाउडर",
    brand: "Ghadi",
    oldprice: "",
    newprice: "59.00",
    qty: "1 KG",
    discount: "",
    img: [h44],
  },
]
export const Patanjali=[
  {
    id: 1,
    name: "Cookies",
    nameH: "",
    brand: "Patanjali",
    oldprice: "50.00",
    newprice: "40.00",
    qty: "60 Piece",
    discount: "20% off",
    img: [s21],
  },
  {
    id: 2,
    name: "Good Knight Active+ Mosquito Vaporiser Refill (45 Ml)",
    nameH: "गुड नाईट लिक्विड",
    brand: "Patanjali",
    oldprice: "",
    newprice: "72.00",
    qty: "45 Ml",
    discount: "",
    img: [h7],
  },
  {
    id:3  ,
    name: "Patanjali Dant Kanti Tooth Paste",
    nameH: "पतंजलि दंत कांति दाँत पेस्ट",
    brand: "Patanjali",
    oldprice: "",
    newprice: "45.00",
    qty: "100 Gram",
    discount: "%off",
    img: [p32],
  },
  {
    id:3  ,
    name: "Patanjali Aloevera Moisturizing Cream",
    nameH: "पतंजलि एलोवेरा मॉइस्चराइजिंग क्रीम",
    brand: "Patanjali",
    oldprice: "",
    newprice: "75.00",
    qty: "50 Gram",
    discount: "",
    img: [p50],
  },
  {
    id:4 ,
    name: "Patanjali Balm",
    nameH: "पतंजलि बाल्म",
    brand: "Patanjali",
    oldprice: "",
    newprice: "45.00",
    qty: "25 Gram",
    discount: "",
    img: [m19],
  },
]

export const Amul=[
  {
    id: 1,
    name: "Amul Ghee",
    nameH: "अमूल घी",
    brand: "Amul",
    oldprice: "255.00",
    newprice: "250.00",
    qty: "500 Gram",
    discount: "2% off",
    img: [g108],
  },
  {
    id: 1,
    name: "Amul Dahi",
    nameH: "अमूल दही",
    brand: "Amul",
    oldprice: "",
    newprice: "32.00",
    qty: "400 Gram",
    discount: "",
    img: [d1],
  },

  {
    id: 2,
    name: "Amul Butter",
    nameH: "अमूल मक्खन",
    brand: "Amul",
    oldprice: "",
    newprice: "50.00",
    qty: "100 Gram",
    discount: "",
    img: [d2],
  },
  {
    id: 3,
    name: "Amul Cheese Slices(10Unit X 20 Gram)",
    nameH: "अमूल चीज़",
    brand: "Amul",
    oldprice: "",
    newprice: "130.00",
    qty: "200 Gram",
    discount: "",
    img: [d3],
  },
  {
    id: 4,
    name: "Amul Cheese Block",
    nameH: "अमूल चीज़ ब्लॉक",
    brand: "Amul",
    oldprice: "",
    newprice: "114.00",
    qty: "200 Gram",
    discount: "",
    img: [d4],
  },
  {
    id: 5,
    name: "Amul Mithae Mate",
    nameH: "अमूल मीठा मेट",
    brand: "Amul",
    oldprice: "",
    newprice: "56.00",
    qty: "200 Gram",
    discount: "",
    img: [d5],
  },
  {
    id: 6,
    name: "Amul Fresh Cream",
    nameH: "अमूल फ्रेश क्रीम",
    brand: "Amul",
    oldprice: "199.00",
    newprice: "197.00",
    qty: "1 Ltr",
    discount: "1% off",
    img: [d6],
  },
  {
    id: 7,
    name: "Amulya Dairy Whitener",
    nameH: "अमूल्य डेयरी व्हाइटनर",
    brand: "Amul",
    oldprice: "",
    newprice: "10.00",
    qty: "24 Gram",
    discount: "",
    img: [d10],
  },
 
]

export const Aashirvaad=[
  {
    id: 1,
    name: "Aashirvaad Atta",
    nameH: "आशीर्वाद आटा",
    brand: "Aashirvaad",
    oldprice: "213.00",
    newprice: "180.00",
    qty: "5 KG",
    discount: "15% off",
    img: [g55],
  },

]

export const MDH=[
  {
    id: 1,
    name: "MDH Meat Masala",
    nameH: "एमडीएच मीट मसाला",
    brand: "MDH",
    oldprice: "73.00",
    newprice: "72.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g29],
  },
  {
    id: 2,
    name: "MDH Kitchen King",
    nameH: "एमडीएच किचन किंग",
    brand: "MDH",
    oldprice: "70.00",
    newprice: "68.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g30],
  },
  {
    id: 3,
    name: "MDH Jeera Powder",
    nameH: "जीरा पाउडर",
    brand: "MDH",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [g31],
  },
  {
    id:4,
    name: "MDH Chicken Masala",
    nameH: "चिकन मसाला",
    brand: "MDH",
    oldprice: "70.00",
    newprice: "69.00",
    qty: "100 Gram",
    discount: "1% off",
    img: [g32],
  },
  {
    id:5,
    name: "MDH Amchur Powder",
    nameH: "एमडीएच अमचूर पाउडर",
    brand: "MDH",
    oldprice: "80.00",
    newprice: "78.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g33],
  },
  {
    id: 6,
    name: "MDH Chunky Chat Masala",
    nameH: "एमडीएच चंकी चाट मसाला",
    brand: "MDH",
    oldprice: "65.00",
    newprice: "63.00",
    qty: "100 Gram",
    discount: "3% off",
    img: [g34],
  },
  {
    id: 7,
    name: "MDH Garam Masala",
    nameH: "एमडीएच गरम मसाला",
    brand: "MDH",
    oldprice: "78.00",
    newprice: "75.00",
    qty: "100 Gram",
    discount: "4% off",
    img: [g35],
  },
  {
    id: 8,
    name: "MDH Karahi Paneer Masala",
    nameH: "एमडीएच कराही पनीर मसाला",
    brand: "MDH",
    oldprice: "50.00",
    newprice: "48.00",
    qty: "60 Gram",
    discount: "4% off",
    img: [g36],
  },
  {
    id: 9,
    name: "MDH Shahi Paneer Masala",
    nameH: "एमडीएच शाही पनीर मसाला",
    brand: "MDH",
    oldprice: "42.00",
    newprice: "41.00",
    qty: "50 Gram",
    discount: "2% off",
    img: [g37],
  },
  {
    id: 10,
    name: "MDH Kesar",
    nameH: "एमडीएच केसर",
    brand: "MDH",
    oldprice: "255.00",
    newprice: "240.00",
    qty: "1 Gram",
    discount: "6% off",
    img: [g116],
  },
 
]
export const Rakesh=[
  {
    id: 1,
    name: "Rakesh Garam Masala",
    nameH: "राकेश गरम मसाला",
    brand: "Rakesh",
    oldprice: "50.00",
    newprice: "47.00",
    qty: "50 Gram",
    discount: "6% off",
    img: [g41],
  },
  {
    id: 2,
    name: "Rakesh Mirch Powder",
    nameH: "मिर्च पाउडर",
    brand: "Rakesh",
    oldprice: "25.00",
    newprice: "23.00",
    qty: "50 Gram",
    discount: "8% off",
    img: [g43],
  },
]

